var map = {
	"./0.png": "f33e",
	"./00.png": "c038",
	"./surah/100_1.png": "4e2a",
	"./surah/100_10.png": "37d9",
	"./surah/100_11.png": "bac4",
	"./surah/100_2.png": "c245",
	"./surah/100_3.png": "f0b9",
	"./surah/100_4.png": "9e4e",
	"./surah/100_5.png": "f01d",
	"./surah/100_6.png": "66d6",
	"./surah/100_7.png": "66c9",
	"./surah/100_8.png": "67c9",
	"./surah/100_9.png": "d53d",
	"./surah/101_1.png": "9dc0",
	"./surah/101_10.png": "c3c9",
	"./surah/101_11.png": "ccc0",
	"./surah/101_2.png": "5340",
	"./surah/101_3.png": "fc9d",
	"./surah/101_4.png": "3359",
	"./surah/101_5.png": "4f98",
	"./surah/101_6.png": "8cdf",
	"./surah/101_7.png": "f8d7",
	"./surah/101_8.png": "43c2",
	"./surah/101_9.png": "e4fb",
	"./surah/102_1.png": "b06f",
	"./surah/102_2.png": "aea1",
	"./surah/102_3.png": "62e1",
	"./surah/102_4.png": "f67c",
	"./surah/102_5.png": "c072",
	"./surah/102_6.png": "bbe1",
	"./surah/102_7.png": "d448",
	"./surah/102_8.png": "3774",
	"./surah/103_1.png": "97f5",
	"./surah/103_2.png": "20b8",
	"./surah/103_3.png": "3f50",
	"./surah/104_1.png": "f279",
	"./surah/104_2.png": "201c",
	"./surah/104_3.png": "dd20",
	"./surah/104_4.png": "deb9",
	"./surah/104_5.png": "5c81",
	"./surah/104_6.png": "c5df",
	"./surah/104_7.png": "37c7",
	"./surah/104_8.png": "febd",
	"./surah/104_9.png": "e94e",
	"./surah/105_1.png": "4f72",
	"./surah/105_2.png": "b7c0",
	"./surah/105_3.png": "b671",
	"./surah/105_4.png": "ca56",
	"./surah/105_5.png": "a8cb",
	"./surah/106_1.png": "d1b6",
	"./surah/106_2.png": "65b6",
	"./surah/106_3.png": "ef02",
	"./surah/106_4.png": "b273",
	"./surah/107_1.png": "f887",
	"./surah/107_2.png": "fdc7",
	"./surah/107_3.png": "6065",
	"./surah/107_4.png": "55a8",
	"./surah/107_5.png": "f51b",
	"./surah/107_6.png": "3f54",
	"./surah/107_7.png": "7152",
	"./surah/108_1.png": "2531",
	"./surah/108_2.png": "6924",
	"./surah/108_3.png": "25c0",
	"./surah/109_1.png": "5577",
	"./surah/109_2.png": "d73b",
	"./surah/109_3.png": "e2cb",
	"./surah/109_4.png": "dc9d",
	"./surah/109_5.png": "2824",
	"./surah/109_6.png": "ae12",
	"./surah/10_1.png": "0da4",
	"./surah/10_10.png": "c508",
	"./surah/10_100.png": "3918",
	"./surah/10_101.png": "fd20",
	"./surah/10_102.png": "25e5",
	"./surah/10_103.png": "3c18",
	"./surah/10_104.png": "9fc2",
	"./surah/10_105.png": "c86e",
	"./surah/10_106.png": "5119",
	"./surah/10_107.png": "cb68",
	"./surah/10_108.png": "1d48",
	"./surah/10_109.png": "0e1a",
	"./surah/10_11.png": "3c63",
	"./surah/10_12.png": "2bfc",
	"./surah/10_13.png": "952d",
	"./surah/10_14.png": "23b2",
	"./surah/10_15.png": "5a9b",
	"./surah/10_16.png": "b339",
	"./surah/10_17.png": "ba46",
	"./surah/10_18.png": "4a93",
	"./surah/10_19.png": "27ce",
	"./surah/10_2.png": "4721",
	"./surah/10_20.png": "e1e9",
	"./surah/10_21.png": "1b5b",
	"./surah/10_22.png": "cbf9",
	"./surah/10_23.png": "1a0c",
	"./surah/10_24.png": "dcd0",
	"./surah/10_25.png": "24e7",
	"./surah/10_26.png": "1cae",
	"./surah/10_27.png": "2ebd",
	"./surah/10_28.png": "5706",
	"./surah/10_29.png": "d533",
	"./surah/10_3.png": "c7cb",
	"./surah/10_30.png": "c3b2",
	"./surah/10_31.png": "ee00",
	"./surah/10_32.png": "589a",
	"./surah/10_33.png": "de61",
	"./surah/10_34.png": "ca92",
	"./surah/10_35.png": "f8a5",
	"./surah/10_36.png": "776d",
	"./surah/10_37.png": "bb44",
	"./surah/10_38.png": "6706",
	"./surah/10_39.png": "817c",
	"./surah/10_4.png": "ef4f",
	"./surah/10_40.png": "09fa",
	"./surah/10_41.png": "d469",
	"./surah/10_42.png": "8236",
	"./surah/10_43.png": "47d7",
	"./surah/10_44.png": "800d",
	"./surah/10_45.png": "9a2e",
	"./surah/10_46.png": "51b8",
	"./surah/10_47.png": "e22a",
	"./surah/10_48.png": "9c53",
	"./surah/10_49.png": "610c",
	"./surah/10_5.png": "5a39",
	"./surah/10_50.png": "f1b6",
	"./surah/10_51.png": "4a35",
	"./surah/10_52.png": "c5e0",
	"./surah/10_53.png": "91f1",
	"./surah/10_54.png": "d4aa",
	"./surah/10_55.png": "d2c5",
	"./surah/10_56.png": "76eb",
	"./surah/10_57.png": "0157",
	"./surah/10_58.png": "9d9f",
	"./surah/10_59.png": "52f7",
	"./surah/10_6.png": "bf18",
	"./surah/10_60.png": "d406",
	"./surah/10_61.png": "dd00",
	"./surah/10_62.png": "a0f4",
	"./surah/10_63.png": "ac84",
	"./surah/10_64.png": "2353",
	"./surah/10_65.png": "b8a0",
	"./surah/10_66.png": "6522",
	"./surah/10_67.png": "1891",
	"./surah/10_68.png": "753a",
	"./surah/10_69.png": "04a9",
	"./surah/10_7.png": "9fb9",
	"./surah/10_70.png": "6d0e",
	"./surah/10_71.png": "e3cc",
	"./surah/10_72.png": "d7fd",
	"./surah/10_73.png": "2d9b",
	"./surah/10_74.png": "4209",
	"./surah/10_75.png": "0c6f",
	"./surah/10_76.png": "81e9",
	"./surah/10_77.png": "f999",
	"./surah/10_78.png": "23fd",
	"./surah/10_79.png": "b221",
	"./surah/10_8.png": "14c7",
	"./surah/10_80.png": "c48e",
	"./surah/10_81.png": "3659",
	"./surah/10_82.png": "b8d0",
	"./surah/10_83.png": "fc35",
	"./surah/10_84.png": "bc82",
	"./surah/10_85.png": "f15e",
	"./surah/10_86.png": "33a7",
	"./surah/10_87.png": "884d",
	"./surah/10_88.png": "8bac",
	"./surah/10_89.png": "03fe",
	"./surah/10_9.png": "be8f",
	"./surah/10_90.png": "b67c",
	"./surah/10_91.png": "51ef",
	"./surah/10_92.png": "162b",
	"./surah/10_93.png": "72b3",
	"./surah/10_94.png": "cae3",
	"./surah/10_95.png": "4035",
	"./surah/10_96.png": "8e8b",
	"./surah/10_97.png": "bafa",
	"./surah/10_98.png": "d6d1",
	"./surah/10_99.png": "c451",
	"./surah/110_1.png": "ef9e",
	"./surah/110_2.png": "a851",
	"./surah/110_3.png": "a437",
	"./surah/111_1.png": "14f6",
	"./surah/111_2.png": "48e0",
	"./surah/111_3.png": "fb70",
	"./surah/111_4.png": "ec35",
	"./surah/111_5.png": "56c8",
	"./surah/112_1.png": "b0a3",
	"./surah/112_2.png": "d6ae",
	"./surah/112_3.png": "4863",
	"./surah/112_4.png": "1dc9",
	"./surah/113_1.png": "3264",
	"./surah/113_2.png": "2279",
	"./surah/113_3.png": "4e42",
	"./surah/113_4.png": "6b1f",
	"./surah/113_5.png": "141f",
	"./surah/114_1.png": "d42e",
	"./surah/114_2.png": "6c3b",
	"./surah/114_3.png": "9835",
	"./surah/114_4.png": "3234",
	"./surah/114_5.png": "ea8e",
	"./surah/114_6.png": "2846",
	"./surah/11_1.png": "715a",
	"./surah/11_10.png": "84b6",
	"./surah/11_100.png": "4e57",
	"./surah/11_101.png": "35b1",
	"./surah/11_102.png": "cde5",
	"./surah/11_103.png": "1e7f",
	"./surah/11_104.png": "5762",
	"./surah/11_105.png": "01a0",
	"./surah/11_106.png": "c677",
	"./surah/11_107.png": "9b8c",
	"./surah/11_108.png": "76ac",
	"./surah/11_109.png": "2622",
	"./surah/11_11.png": "ea6d",
	"./surah/11_110.png": "f571",
	"./surah/11_111.png": "05f3",
	"./surah/11_112.png": "3ce8",
	"./surah/11_113.png": "366b",
	"./surah/11_114.png": "49de",
	"./surah/11_115.png": "6b3e",
	"./surah/11_116.png": "7ff1",
	"./surah/11_117.png": "f203",
	"./surah/11_118.png": "21b5",
	"./surah/11_119.png": "42b3",
	"./surah/11_12.png": "573a",
	"./surah/11_120.png": "9d0c",
	"./surah/11_121.png": "440d",
	"./surah/11_122.png": "e458",
	"./surah/11_123.png": "c331",
	"./surah/11_13.png": "9af5",
	"./surah/11_14.png": "4835",
	"./surah/11_15.png": "cdd2",
	"./surah/11_16.png": "0584",
	"./surah/11_17.png": "b07b",
	"./surah/11_18.png": "4531",
	"./surah/11_19.png": "a508",
	"./surah/11_2.png": "93c9",
	"./surah/11_20.png": "e2c2",
	"./surah/11_21.png": "a29c",
	"./surah/11_22.png": "ab5e",
	"./surah/11_23.png": "70c2",
	"./surah/11_24.png": "88e7",
	"./surah/11_25.png": "95d7",
	"./surah/11_26.png": "9081",
	"./surah/11_27.png": "d08f",
	"./surah/11_28.png": "d2c2",
	"./surah/11_29.png": "ea69",
	"./surah/11_3.png": "38a7",
	"./surah/11_30.png": "1e79",
	"./surah/11_31.png": "8b41",
	"./surah/11_32.png": "25db",
	"./surah/11_33.png": "9a40",
	"./surah/11_34.png": "ed58",
	"./surah/11_35.png": "825a4",
	"./surah/11_36.png": "379f",
	"./surah/11_37.png": "0b6f",
	"./surah/11_38.png": "86ab",
	"./surah/11_39.png": "06ea",
	"./surah/11_4.png": "4b7b",
	"./surah/11_40.png": "f249",
	"./surah/11_41.png": "b683",
	"./surah/11_42.png": "322c",
	"./surah/11_43.png": "ea95",
	"./surah/11_44.png": "9c49",
	"./surah/11_45.png": "df44",
	"./surah/11_46.png": "91e4",
	"./surah/11_47.png": "1d7f",
	"./surah/11_48.png": "c83a",
	"./surah/11_49.png": "d56a",
	"./surah/11_5.png": "c794",
	"./surah/11_50.png": "6eb0",
	"./surah/11_51.png": "b5f8",
	"./surah/11_52.png": "9e66",
	"./surah/11_53.png": "36594",
	"./surah/11_54.png": "ae6b",
	"./surah/11_55.png": "d575",
	"./surah/11_56.png": "1c39",
	"./surah/11_57.png": "e721",
	"./surah/11_58.png": "8f6f",
	"./surah/11_59.png": "8653",
	"./surah/11_6.png": "a7a3",
	"./surah/11_60.png": "1e3d",
	"./surah/11_61.png": "677b",
	"./surah/11_62.png": "784f",
	"./surah/11_63.png": "651a",
	"./surah/11_64.png": "1edc",
	"./surah/11_65.png": "7ba6",
	"./surah/11_66.png": "0145",
	"./surah/11_67.png": "ddec",
	"./surah/11_68.png": "afd2",
	"./surah/11_69.png": "c743",
	"./surah/11_7.png": "4d8d",
	"./surah/11_70.png": "7765",
	"./surah/11_71.png": "2081",
	"./surah/11_72.png": "0660",
	"./surah/11_73.png": "3351",
	"./surah/11_74.png": "04d4",
	"./surah/11_75.png": "1544",
	"./surah/11_76.png": "6f73",
	"./surah/11_77.png": "b9f9",
	"./surah/11_78.png": "e4bb",
	"./surah/11_79.png": "ed24",
	"./surah/11_8.png": "0d12",
	"./surah/11_80.png": "4a74",
	"./surah/11_81.png": "e2c5",
	"./surah/11_82.png": "7450",
	"./surah/11_83.png": "3dec",
	"./surah/11_84.png": "17d2",
	"./surah/11_85.png": "1d0c",
	"./surah/11_86.png": "a5b0",
	"./surah/11_87.png": "00d9",
	"./surah/11_88.png": "519d",
	"./surah/11_89.png": "99e9",
	"./surah/11_9.png": "57d7",
	"./surah/11_90.png": "75ae",
	"./surah/11_91.png": "1704",
	"./surah/11_92.png": "078d",
	"./surah/11_93.png": "06d5",
	"./surah/11_94.png": "356e",
	"./surah/11_95.png": "99f0",
	"./surah/11_96.png": "7235",
	"./surah/11_97.png": "495b",
	"./surah/11_98.png": "b8d8",
	"./surah/11_99.png": "a50e",
	"./surah/12_1.png": "997a",
	"./surah/12_10.png": "bd61",
	"./surah/12_100.png": "d9ff",
	"./surah/12_101.png": "43b2",
	"./surah/12_102.png": "e060",
	"./surah/12_103.png": "206d",
	"./surah/12_104.png": "d0e0",
	"./surah/12_105.png": "2b31",
	"./surah/12_106.png": "157b",
	"./surah/12_107.png": "24df",
	"./surah/12_108.png": "c4ab",
	"./surah/12_109.png": "ef023",
	"./surah/12_11.png": "dea0",
	"./surah/12_110.png": "89c2",
	"./surah/12_111.png": "d6a5",
	"./surah/12_12.png": "b5a0",
	"./surah/12_13.png": "e8a2",
	"./surah/12_14.png": "98d2",
	"./surah/12_15.png": "2c65",
	"./surah/12_16.png": "afde",
	"./surah/12_17.png": "e20d",
	"./surah/12_18.png": "5461",
	"./surah/12_19.png": "2b7f",
	"./surah/12_2.png": "8594",
	"./surah/12_20.png": "2105",
	"./surah/12_21.png": "506a",
	"./surah/12_22.png": "6dee",
	"./surah/12_23.png": "ab9b",
	"./surah/12_24.png": "3ecb",
	"./surah/12_25.png": "fffd",
	"./surah/12_26.png": "b5ed",
	"./surah/12_27.png": "d122",
	"./surah/12_28.png": "19c9",
	"./surah/12_29.png": "24c3",
	"./surah/12_3.png": "3233",
	"./surah/12_30.png": "0a40",
	"./surah/12_31.png": "664a",
	"./surah/12_32.png": "7c91",
	"./surah/12_33.png": "45f8",
	"./surah/12_34.png": "9cdc",
	"./surah/12_35.png": "f967",
	"./surah/12_36.png": "7a8c",
	"./surah/12_37.png": "a766",
	"./surah/12_38.png": "9daf",
	"./surah/12_39.png": "c3bb",
	"./surah/12_4.png": "9dc5",
	"./surah/12_40.png": "5549",
	"./surah/12_41.png": "3641",
	"./surah/12_42.png": "579f",
	"./surah/12_43.png": "04ee",
	"./surah/12_44.png": "f185",
	"./surah/12_45.png": "ba64",
	"./surah/12_46.png": "f10d",
	"./surah/12_47.png": "a625",
	"./surah/12_48.png": "5c55",
	"./surah/12_49.png": "a156",
	"./surah/12_5.png": "7720",
	"./surah/12_50.png": "4729",
	"./surah/12_51.png": "aade",
	"./surah/12_52.png": "6e37",
	"./surah/12_53.png": "3d51",
	"./surah/12_54.png": "9f30",
	"./surah/12_55.png": "f8fc",
	"./surah/12_56.png": "5e3b",
	"./surah/12_57.png": "d0d2",
	"./surah/12_58.png": "56e8",
	"./surah/12_59.png": "0698",
	"./surah/12_6.png": "b852",
	"./surah/12_60.png": "0c20",
	"./surah/12_61.png": "4c6e",
	"./surah/12_62.png": "d58c",
	"./surah/12_63.png": "4fcf",
	"./surah/12_64.png": "8b20",
	"./surah/12_65.png": "353b",
	"./surah/12_66.png": "50c6",
	"./surah/12_67.png": "316b",
	"./surah/12_68.png": "55ff",
	"./surah/12_69.png": "82b5",
	"./surah/12_7.png": "7674",
	"./surah/12_70.png": "152d",
	"./surah/12_71.png": "6a7c",
	"./surah/12_72.png": "4164",
	"./surah/12_73.png": "f22e",
	"./surah/12_74.png": "fddd",
	"./surah/12_75.png": "aa3d",
	"./surah/12_76.png": "181a",
	"./surah/12_77.png": "0d9b",
	"./surah/12_78.png": "4117",
	"./surah/12_79.png": "26a4",
	"./surah/12_8.png": "03cf",
	"./surah/12_80.png": "db80",
	"./surah/12_81.png": "d61c",
	"./surah/12_82.png": "e40c",
	"./surah/12_83.png": "837a",
	"./surah/12_84.png": "ed6f",
	"./surah/12_85.png": "8314",
	"./surah/12_86.png": "8523",
	"./surah/12_87.png": "a21c",
	"./surah/12_88.png": "a092",
	"./surah/12_89.png": "b133",
	"./surah/12_9.png": "f582",
	"./surah/12_90.png": "fd6f",
	"./surah/12_91.png": "0db4",
	"./surah/12_92.png": "4a0c",
	"./surah/12_93.png": "88f1",
	"./surah/12_94.png": "1542",
	"./surah/12_95.png": "efd8",
	"./surah/12_96.png": "a068",
	"./surah/12_97.png": "4199",
	"./surah/12_98.png": "e464",
	"./surah/12_99.png": "55f9",
	"./surah/13_1.png": "cc83",
	"./surah/13_10.png": "2c9a",
	"./surah/13_11.png": "3ab9",
	"./surah/13_12.png": "e40f",
	"./surah/13_13.png": "4fb0",
	"./surah/13_14.png": "7df9",
	"./surah/13_15.png": "6222",
	"./surah/13_16.png": "036f",
	"./surah/13_17.png": "233a",
	"./surah/13_18.png": "2b48",
	"./surah/13_19.png": "4bdf",
	"./surah/13_2.png": "f1ff",
	"./surah/13_20.png": "5816",
	"./surah/13_21.png": "518f",
	"./surah/13_22.png": "f273",
	"./surah/13_23.png": "7788",
	"./surah/13_24.png": "18ed",
	"./surah/13_25.png": "838c",
	"./surah/13_26.png": "2c3c",
	"./surah/13_27.png": "fdbf3",
	"./surah/13_28.png": "cf83",
	"./surah/13_29.png": "6c26",
	"./surah/13_3.png": "5756",
	"./surah/13_30.png": "4c28",
	"./surah/13_31.png": "ff9d",
	"./surah/13_32.png": "7a56",
	"./surah/13_33.png": "a2c7",
	"./surah/13_34.png": "414c",
	"./surah/13_35.png": "ef34",
	"./surah/13_36.png": "2f3c",
	"./surah/13_37.png": "98aa",
	"./surah/13_38.png": "faeb",
	"./surah/13_39.png": "55ae",
	"./surah/13_4.png": "8d8d",
	"./surah/13_40.png": "bcf1",
	"./surah/13_41.png": "0549",
	"./surah/13_42.png": "b657",
	"./surah/13_43.png": "e86c",
	"./surah/13_5.png": "4371",
	"./surah/13_6.png": "0812",
	"./surah/13_7.png": "b8a05",
	"./surah/13_8.png": "8ec3",
	"./surah/13_9.png": "ac68",
	"./surah/14_1.png": "61ce",
	"./surah/14_10.png": "6fa7",
	"./surah/14_11.png": "1073",
	"./surah/14_12.png": "d62e",
	"./surah/14_13.png": "1d93",
	"./surah/14_14.png": "0023",
	"./surah/14_15.png": "cc1f",
	"./surah/14_16.png": "644a",
	"./surah/14_17.png": "5877f",
	"./surah/14_18.png": "02ac",
	"./surah/14_19.png": "98a1",
	"./surah/14_2.png": "55a5",
	"./surah/14_20.png": "40ff",
	"./surah/14_21.png": "730a",
	"./surah/14_22.png": "a7e4",
	"./surah/14_23.png": "c1b1",
	"./surah/14_24.png": "9a43",
	"./surah/14_25.png": "66f6",
	"./surah/14_26.png": "c7c5",
	"./surah/14_27.png": "3676",
	"./surah/14_28.png": "71a3",
	"./surah/14_29.png": "70af",
	"./surah/14_3.png": "411b",
	"./surah/14_30.png": "b3f1",
	"./surah/14_31.png": "b693",
	"./surah/14_32.png": "4db7",
	"./surah/14_33.png": "3ed1",
	"./surah/14_34.png": "ce3d",
	"./surah/14_35.png": "2596",
	"./surah/14_36.png": "cea0",
	"./surah/14_37.png": "ce10",
	"./surah/14_38.png": "ee54",
	"./surah/14_39.png": "38a9",
	"./surah/14_4.png": "55ac",
	"./surah/14_40.png": "f55b",
	"./surah/14_41.png": "3782",
	"./surah/14_42.png": "e1c3",
	"./surah/14_43.png": "18fa",
	"./surah/14_44.png": "bb81",
	"./surah/14_45.png": "9d80",
	"./surah/14_46.png": "7b53",
	"./surah/14_47.png": "8904",
	"./surah/14_48.png": "01bd",
	"./surah/14_49.png": "33d8",
	"./surah/14_5.png": "8cc3",
	"./surah/14_50.png": "b490",
	"./surah/14_51.png": "88f2",
	"./surah/14_52.png": "f446",
	"./surah/14_6.png": "0475",
	"./surah/14_7.png": "64fe",
	"./surah/14_8.png": "cc72",
	"./surah/14_9.png": "fddc",
	"./surah/15_1.png": "e295",
	"./surah/15_10.png": "c865",
	"./surah/15_11.png": "5697",
	"./surah/15_12.png": "66e9",
	"./surah/15_13.png": "328b",
	"./surah/15_14.png": "2dcc",
	"./surah/15_15.png": "98c1",
	"./surah/15_16.png": "daa3",
	"./surah/15_17.png": "3fa2",
	"./surah/15_18.png": "4ff6",
	"./surah/15_19.png": "8365",
	"./surah/15_2.png": "f82e",
	"./surah/15_20.png": "0f13",
	"./surah/15_21.png": "2e06",
	"./surah/15_22.png": "705a",
	"./surah/15_23.png": "8e33",
	"./surah/15_24.png": "b36e",
	"./surah/15_25.png": "d374",
	"./surah/15_26.png": "f24a",
	"./surah/15_27.png": "b5a3",
	"./surah/15_28.png": "90ac",
	"./surah/15_29.png": "6099",
	"./surah/15_3.png": "ef40",
	"./surah/15_30.png": "8d9a",
	"./surah/15_31.png": "2071",
	"./surah/15_32.png": "f312",
	"./surah/15_33.png": "89f0",
	"./surah/15_34.png": "bc27",
	"./surah/15_35.png": "32c1",
	"./surah/15_36.png": "c0a1",
	"./surah/15_37.png": "8834",
	"./surah/15_38.png": "efea",
	"./surah/15_39.png": "b1df",
	"./surah/15_4.png": "6d10",
	"./surah/15_40.png": "b54b",
	"./surah/15_41.png": "a754",
	"./surah/15_42.png": "e3d4",
	"./surah/15_43.png": "ac83",
	"./surah/15_44.png": "485d",
	"./surah/15_45.png": "1a1a",
	"./surah/15_46.png": "017c",
	"./surah/15_47.png": "f460",
	"./surah/15_48.png": "1529",
	"./surah/15_49.png": "836c",
	"./surah/15_5.png": "a725",
	"./surah/15_50.png": "1098",
	"./surah/15_51.png": "5d57",
	"./surah/15_52.png": "10c6",
	"./surah/15_53.png": "fb44",
	"./surah/15_54.png": "2ce9",
	"./surah/15_55.png": "7c90",
	"./surah/15_56.png": "a744",
	"./surah/15_57.png": "283b",
	"./surah/15_58.png": "541b",
	"./surah/15_59.png": "a63c",
	"./surah/15_6.png": "2ba6",
	"./surah/15_60.png": "639e",
	"./surah/15_61.png": "f53b",
	"./surah/15_62.png": "1678",
	"./surah/15_63.png": "324a",
	"./surah/15_64.png": "c977",
	"./surah/15_65.png": "8692",
	"./surah/15_66.png": "f738",
	"./surah/15_67.png": "ccc07",
	"./surah/15_68.png": "5fee",
	"./surah/15_69.png": "b755",
	"./surah/15_7.png": "9227",
	"./surah/15_70.png": "8553",
	"./surah/15_71.png": "c873",
	"./surah/15_72.png": "e473",
	"./surah/15_73.png": "ca7d",
	"./surah/15_74.png": "ae77",
	"./surah/15_75.png": "5380",
	"./surah/15_76.png": "a589",
	"./surah/15_77.png": "df90",
	"./surah/15_78.png": "42dc",
	"./surah/15_79.png": "014a",
	"./surah/15_8.png": "7022",
	"./surah/15_80.png": "6174",
	"./surah/15_81.png": "c524",
	"./surah/15_82.png": "a75c",
	"./surah/15_83.png": "a7ce",
	"./surah/15_84.png": "38aa",
	"./surah/15_85.png": "2c4c",
	"./surah/15_86.png": "6676",
	"./surah/15_87.png": "2795",
	"./surah/15_88.png": "54b9",
	"./surah/15_89.png": "2124",
	"./surah/15_9.png": "f7c8",
	"./surah/15_90.png": "a525",
	"./surah/15_91.png": "d83d",
	"./surah/15_92.png": "dd5f",
	"./surah/15_93.png": "4e5f",
	"./surah/15_94.png": "063e",
	"./surah/15_95.png": "9289",
	"./surah/15_96.png": "f8f8",
	"./surah/15_97.png": "bcd8",
	"./surah/15_98.png": "2b03",
	"./surah/15_99.png": "bf0c",
	"./surah/16_1.png": "1d1c",
	"./surah/16_10.png": "dfb1",
	"./surah/16_100.png": "2edb",
	"./surah/16_101.png": "cf87",
	"./surah/16_102.png": "4b95",
	"./surah/16_103.png": "e1bf",
	"./surah/16_104.png": "7059",
	"./surah/16_105.png": "c7e5",
	"./surah/16_106.png": "ebbb",
	"./surah/16_107.png": "86df",
	"./surah/16_108.png": "cd23",
	"./surah/16_109.png": "8bd5",
	"./surah/16_11.png": "45f3",
	"./surah/16_110.png": "bd05",
	"./surah/16_111.png": "3e3d",
	"./surah/16_112.png": "699f",
	"./surah/16_113.png": "1b09",
	"./surah/16_114.png": "0b8b",
	"./surah/16_115.png": "5293",
	"./surah/16_116.png": "7f45",
	"./surah/16_117.png": "ac2f",
	"./surah/16_118.png": "99be",
	"./surah/16_119.png": "073d",
	"./surah/16_12.png": "1811",
	"./surah/16_120.png": "d9b5",
	"./surah/16_121.png": "5d4d",
	"./surah/16_122.png": "6bf0",
	"./surah/16_123.png": "b233",
	"./surah/16_124.png": "0241",
	"./surah/16_125.png": "167f",
	"./surah/16_126.png": "9c66",
	"./surah/16_127.png": "6d8d",
	"./surah/16_128.png": "122a",
	"./surah/16_13.png": "7a5d",
	"./surah/16_14.png": "f2736",
	"./surah/16_15.png": "8c0d",
	"./surah/16_16.png": "ab41",
	"./surah/16_17.png": "79c6",
	"./surah/16_18.png": "e2a2",
	"./surah/16_19.png": "ac41",
	"./surah/16_2.png": "bfe2",
	"./surah/16_20.png": "fc9c",
	"./surah/16_21.png": "5d4b",
	"./surah/16_22.png": "cade",
	"./surah/16_23.png": "4a53",
	"./surah/16_24.png": "a9e80",
	"./surah/16_25.png": "9311",
	"./surah/16_26.png": "e65e",
	"./surah/16_27.png": "d4a0",
	"./surah/16_28.png": "3746",
	"./surah/16_29.png": "a4e1",
	"./surah/16_3.png": "39ef",
	"./surah/16_30.png": "ee30",
	"./surah/16_31.png": "f977",
	"./surah/16_32.png": "6b82",
	"./surah/16_33.png": "179a",
	"./surah/16_34.png": "e436",
	"./surah/16_35.png": "cff2",
	"./surah/16_36.png": "1c93",
	"./surah/16_37.png": "1ebb",
	"./surah/16_38.png": "360c",
	"./surah/16_39.png": "5a80",
	"./surah/16_4.png": "5d15",
	"./surah/16_40.png": "df63",
	"./surah/16_41.png": "1692",
	"./surah/16_42.png": "d658",
	"./surah/16_43.png": "c0cb",
	"./surah/16_44.png": "c281",
	"./surah/16_45.png": "2019",
	"./surah/16_46.png": "749d",
	"./surah/16_47.png": "cc47",
	"./surah/16_48.png": "0cc3",
	"./surah/16_49.png": "65c2",
	"./surah/16_5.png": "a9f3",
	"./surah/16_50.png": "1cc9",
	"./surah/16_51.png": "41e1",
	"./surah/16_52.png": "ca89",
	"./surah/16_53.png": "99d7",
	"./surah/16_54.png": "c693",
	"./surah/16_55.png": "a23f",
	"./surah/16_56.png": "7ea3",
	"./surah/16_57.png": "a48d",
	"./surah/16_58.png": "3d2e",
	"./surah/16_59.png": "ffd5",
	"./surah/16_6.png": "0a46",
	"./surah/16_60.png": "d1fd",
	"./surah/16_61.png": "f408",
	"./surah/16_62.png": "959f",
	"./surah/16_63.png": "0d91",
	"./surah/16_64.png": "e7ca",
	"./surah/16_65.png": "0594",
	"./surah/16_66.png": "6921",
	"./surah/16_67.png": "c270",
	"./surah/16_68.png": "58ec",
	"./surah/16_69.png": "ce1c",
	"./surah/16_7.png": "9f56",
	"./surah/16_70.png": "6490",
	"./surah/16_71.png": "8bcc",
	"./surah/16_72.png": "5164",
	"./surah/16_73.png": "1873",
	"./surah/16_74.png": "fd67",
	"./surah/16_75.png": "d7a1",
	"./surah/16_76.png": "270c",
	"./surah/16_77.png": "ca15",
	"./surah/16_78.png": "2803",
	"./surah/16_79.png": "3b8b",
	"./surah/16_8.png": "670e",
	"./surah/16_80.png": "cc7f",
	"./surah/16_81.png": "a3c6",
	"./surah/16_82.png": "4118",
	"./surah/16_83.png": "7e2e",
	"./surah/16_84.png": "671a",
	"./surah/16_85.png": "6c1e",
	"./surah/16_86.png": "76cc",
	"./surah/16_87.png": "f8e1",
	"./surah/16_88.png": "1a2d",
	"./surah/16_89.png": "6291",
	"./surah/16_9.png": "cc33",
	"./surah/16_90.png": "15fc",
	"./surah/16_91.png": "2d06",
	"./surah/16_92.png": "3a8e",
	"./surah/16_93.png": "eb17",
	"./surah/16_94.png": "75b9",
	"./surah/16_95.png": "a6ef",
	"./surah/16_96.png": "95ab",
	"./surah/16_97.png": "5021",
	"./surah/16_98.png": "35be",
	"./surah/16_99.png": "f6c8",
	"./surah/17_1.png": "e653",
	"./surah/17_10.png": "b266",
	"./surah/17_100.png": "df4e",
	"./surah/17_101.png": "1c02",
	"./surah/17_102.png": "3e8b",
	"./surah/17_103.png": "366f",
	"./surah/17_104.png": "de67",
	"./surah/17_105.png": "3241",
	"./surah/17_106.png": "3b5b",
	"./surah/17_107.png": "e46b",
	"./surah/17_108.png": "4f88",
	"./surah/17_109.png": "f576",
	"./surah/17_11.png": "e72d",
	"./surah/17_110.png": "8337",
	"./surah/17_111.png": "6ad6",
	"./surah/17_12.png": "d0aa",
	"./surah/17_13.png": "a53c",
	"./surah/17_14.png": "e879",
	"./surah/17_15.png": "19e2",
	"./surah/17_16.png": "408c",
	"./surah/17_17.png": "9792",
	"./surah/17_18.png": "6880",
	"./surah/17_19.png": "cddb",
	"./surah/17_2.png": "db27",
	"./surah/17_20.png": "a1c0",
	"./surah/17_21.png": "6c12",
	"./surah/17_22.png": "c88c",
	"./surah/17_23.png": "28e0",
	"./surah/17_24.png": "38a4",
	"./surah/17_25.png": "6b54",
	"./surah/17_26.png": "723f",
	"./surah/17_27.png": "2e56",
	"./surah/17_28.png": "2eaf",
	"./surah/17_29.png": "88f2c",
	"./surah/17_3.png": "d549",
	"./surah/17_30.png": "b4bc",
	"./surah/17_31.png": "27e3",
	"./surah/17_32.png": "4228",
	"./surah/17_33.png": "bd8a",
	"./surah/17_34.png": "51c9",
	"./surah/17_35.png": "b472",
	"./surah/17_36.png": "614b",
	"./surah/17_37.png": "b7fa",
	"./surah/17_38.png": "5620",
	"./surah/17_39.png": "02ff",
	"./surah/17_4.png": "bbac",
	"./surah/17_40.png": "ece2",
	"./surah/17_41.png": "d760",
	"./surah/17_42.png": "151d",
	"./surah/17_43.png": "f53d",
	"./surah/17_44.png": "443d",
	"./surah/17_45.png": "b6b8",
	"./surah/17_46.png": "9c9b",
	"./surah/17_47.png": "e95f",
	"./surah/17_48.png": "7b7c",
	"./surah/17_49.png": "0a56",
	"./surah/17_5.png": "d71a",
	"./surah/17_50.png": "ba37",
	"./surah/17_51.png": "60f1",
	"./surah/17_52.png": "0261",
	"./surah/17_53.png": "b04a",
	"./surah/17_54.png": "dc3f",
	"./surah/17_55.png": "faff",
	"./surah/17_56.png": "a941",
	"./surah/17_57.png": "bb8b",
	"./surah/17_58.png": "1bc3",
	"./surah/17_59.png": "92e6",
	"./surah/17_6.png": "3da7",
	"./surah/17_60.png": "8ab0",
	"./surah/17_61.png": "0417",
	"./surah/17_62.png": "0b3f",
	"./surah/17_63.png": "2f0d",
	"./surah/17_64.png": "711b",
	"./surah/17_65.png": "a5d7",
	"./surah/17_66.png": "8874",
	"./surah/17_67.png": "98ef",
	"./surah/17_68.png": "d246",
	"./surah/17_69.png": "9251",
	"./surah/17_7.png": "1947",
	"./surah/17_70.png": "b422",
	"./surah/17_71.png": "2b34",
	"./surah/17_72.png": "6766",
	"./surah/17_73.png": "ffd4",
	"./surah/17_74.png": "4620",
	"./surah/17_75.png": "8328",
	"./surah/17_76.png": "2a8f",
	"./surah/17_77.png": "9cb0",
	"./surah/17_78.png": "c5eb",
	"./surah/17_79.png": "cd47",
	"./surah/17_8.png": "0a32",
	"./surah/17_80.png": "dd6c",
	"./surah/17_81.png": "a47b",
	"./surah/17_82.png": "74f9",
	"./surah/17_83.png": "3d7b",
	"./surah/17_84.png": "1ff9",
	"./surah/17_85.png": "ee95",
	"./surah/17_86.png": "c70f",
	"./surah/17_87.png": "67b3",
	"./surah/17_88.png": "6adb",
	"./surah/17_89.png": "eb05",
	"./surah/17_9.png": "102f",
	"./surah/17_90.png": "4f23",
	"./surah/17_91.png": "ad93",
	"./surah/17_92.png": "dfac",
	"./surah/17_93.png": "0155",
	"./surah/17_94.png": "5b1d",
	"./surah/17_95.png": "49b9",
	"./surah/17_96.png": "dccb",
	"./surah/17_97.png": "400e",
	"./surah/17_98.png": "b94c",
	"./surah/17_99.png": "e315",
	"./surah/18_1.png": "ab0f",
	"./surah/18_10.png": "527e",
	"./surah/18_100.png": "91cf",
	"./surah/18_101.png": "71d3",
	"./surah/18_102.png": "ee5a",
	"./surah/18_103.png": "98c3",
	"./surah/18_104.png": "46c0",
	"./surah/18_105.png": "73e7",
	"./surah/18_106.png": "e123",
	"./surah/18_107.png": "4dea",
	"./surah/18_108.png": "fb14",
	"./surah/18_109.png": "f095",
	"./surah/18_11.png": "6c56",
	"./surah/18_110.png": "23f3",
	"./surah/18_12.png": "2fff",
	"./surah/18_13.png": "8fa6",
	"./surah/18_14.png": "3ca6",
	"./surah/18_15.png": "4b8a",
	"./surah/18_16.png": "6c3d",
	"./surah/18_17.png": "a287",
	"./surah/18_18.png": "0bc7",
	"./surah/18_19.png": "6558",
	"./surah/18_2.png": "0e34",
	"./surah/18_20.png": "4efb",
	"./surah/18_21.png": "a172",
	"./surah/18_22.png": "f4b0",
	"./surah/18_23.png": "be4b",
	"./surah/18_24.png": "fedd",
	"./surah/18_25.png": "a917",
	"./surah/18_26.png": "bedc",
	"./surah/18_27.png": "614b6",
	"./surah/18_28.png": "97a4",
	"./surah/18_29.png": "4f3c",
	"./surah/18_3.png": "c8e4",
	"./surah/18_30.png": "6980",
	"./surah/18_31.png": "78c6",
	"./surah/18_32.png": "4584",
	"./surah/18_33.png": "fe50",
	"./surah/18_34.png": "4448",
	"./surah/18_35.png": "1911",
	"./surah/18_36.png": "6212",
	"./surah/18_37.png": "7ddc",
	"./surah/18_38.png": "187d",
	"./surah/18_39.png": "325a",
	"./surah/18_4.png": "e97e",
	"./surah/18_40.png": "b69f",
	"./surah/18_41.png": "f2d1",
	"./surah/18_42.png": "7927",
	"./surah/18_43.png": "bbfc",
	"./surah/18_44.png": "c81c",
	"./surah/18_45.png": "8e04",
	"./surah/18_46.png": "f3bf",
	"./surah/18_47.png": "181c",
	"./surah/18_48.png": "3863",
	"./surah/18_49.png": "ecd5",
	"./surah/18_5.png": "d7a4",
	"./surah/18_50.png": "42d8",
	"./surah/18_51.png": "7240",
	"./surah/18_52.png": "485f",
	"./surah/18_53.png": "1878",
	"./surah/18_54.png": "3ca9",
	"./surah/18_55.png": "61d8",
	"./surah/18_56.png": "3eb7",
	"./surah/18_57.png": "1be41",
	"./surah/18_58.png": "9c29",
	"./surah/18_59.png": "4666",
	"./surah/18_6.png": "c20e",
	"./surah/18_60.png": "b988",
	"./surah/18_61.png": "86c5",
	"./surah/18_62.png": "4728",
	"./surah/18_63.png": "1b0a",
	"./surah/18_64.png": "5a7e",
	"./surah/18_65.png": "c3bb1",
	"./surah/18_66.png": "3eb6",
	"./surah/18_67.png": "e12a",
	"./surah/18_68.png": "004e",
	"./surah/18_69.png": "ef0b",
	"./surah/18_7.png": "c6ce",
	"./surah/18_70.png": "a4c1",
	"./surah/18_71.png": "e576",
	"./surah/18_72.png": "3f93",
	"./surah/18_73.png": "b25d",
	"./surah/18_74.png": "546f",
	"./surah/18_75.png": "4f17",
	"./surah/18_76.png": "d890",
	"./surah/18_77.png": "8e4f",
	"./surah/18_78.png": "bb79",
	"./surah/18_79.png": "31a7",
	"./surah/18_8.png": "3510",
	"./surah/18_80.png": "2b38",
	"./surah/18_81.png": "9084",
	"./surah/18_82.png": "658b",
	"./surah/18_83.png": "96e5",
	"./surah/18_84.png": "5be2",
	"./surah/18_85.png": "f2cf",
	"./surah/18_86.png": "2c3cc",
	"./surah/18_87.png": "6082",
	"./surah/18_88.png": "722c",
	"./surah/18_89.png": "9bd0",
	"./surah/18_9.png": "24c8",
	"./surah/18_90.png": "7397",
	"./surah/18_91.png": "b29b",
	"./surah/18_92.png": "6bab",
	"./surah/18_93.png": "4b20",
	"./surah/18_94.png": "c4db",
	"./surah/18_95.png": "06e2",
	"./surah/18_96.png": "69d5",
	"./surah/18_97.png": "6324",
	"./surah/18_98.png": "2d7c",
	"./surah/18_99.png": "d6f1",
	"./surah/19_1.png": "b7ce",
	"./surah/19_10.png": "0857",
	"./surah/19_11.png": "7e7f",
	"./surah/19_12.png": "c033",
	"./surah/19_13.png": "b37d",
	"./surah/19_14.png": "42b4",
	"./surah/19_15.png": "9db3",
	"./surah/19_16.png": "931d",
	"./surah/19_17.png": "4144",
	"./surah/19_18.png": "75be",
	"./surah/19_19.png": "03c0",
	"./surah/19_2.png": "a6a6",
	"./surah/19_20.png": "d8ef",
	"./surah/19_21.png": "6107",
	"./surah/19_22.png": "507a",
	"./surah/19_23.png": "cf61",
	"./surah/19_24.png": "5ec6",
	"./surah/19_25.png": "5a12",
	"./surah/19_26.png": "792c",
	"./surah/19_27.png": "f768",
	"./surah/19_28.png": "a238",
	"./surah/19_29.png": "f97c",
	"./surah/19_3.png": "2462",
	"./surah/19_30.png": "07d6",
	"./surah/19_31.png": "4594",
	"./surah/19_32.png": "067c",
	"./surah/19_33.png": "53fe",
	"./surah/19_34.png": "5cfe",
	"./surah/19_35.png": "fabd",
	"./surah/19_36.png": "2a89",
	"./surah/19_37.png": "a2d3",
	"./surah/19_38.png": "2bd1",
	"./surah/19_39.png": "460c",
	"./surah/19_4.png": "21d7",
	"./surah/19_40.png": "ed96",
	"./surah/19_41.png": "4df5",
	"./surah/19_42.png": "952df",
	"./surah/19_43.png": "1c7ef",
	"./surah/19_44.png": "4364",
	"./surah/19_45.png": "aa8d",
	"./surah/19_46.png": "c78c",
	"./surah/19_47.png": "7838",
	"./surah/19_48.png": "d37a",
	"./surah/19_49.png": "8469",
	"./surah/19_5.png": "7ee6",
	"./surah/19_50.png": "ff44",
	"./surah/19_51.png": "4409",
	"./surah/19_52.png": "e579",
	"./surah/19_53.png": "2767",
	"./surah/19_54.png": "6c17",
	"./surah/19_55.png": "c3ac",
	"./surah/19_56.png": "2233",
	"./surah/19_57.png": "0a85",
	"./surah/19_58.png": "9027",
	"./surah/19_59.png": "a9e5",
	"./surah/19_6.png": "ba88",
	"./surah/19_60.png": "8c27",
	"./surah/19_61.png": "c021",
	"./surah/19_62.png": "1b1f",
	"./surah/19_63.png": "2e5b",
	"./surah/19_64.png": "3ab6",
	"./surah/19_65.png": "d590",
	"./surah/19_66.png": "4f6f",
	"./surah/19_67.png": "dc3a",
	"./surah/19_68.png": "46be",
	"./surah/19_69.png": "ba83",
	"./surah/19_7.png": "3b5c",
	"./surah/19_70.png": "b433",
	"./surah/19_71.png": "061f",
	"./surah/19_72.png": "2771",
	"./surah/19_73.png": "dd58",
	"./surah/19_74.png": "1cfe",
	"./surah/19_75.png": "7f57",
	"./surah/19_76.png": "3519",
	"./surah/19_77.png": "7066",
	"./surah/19_78.png": "b1cc",
	"./surah/19_79.png": "13be",
	"./surah/19_8.png": "bc47",
	"./surah/19_80.png": "b991",
	"./surah/19_81.png": "b02c",
	"./surah/19_82.png": "125d",
	"./surah/19_83.png": "48b4",
	"./surah/19_84.png": "6e0a",
	"./surah/19_85.png": "ab73",
	"./surah/19_86.png": "3eff",
	"./surah/19_87.png": "ebd2",
	"./surah/19_88.png": "1880",
	"./surah/19_89.png": "1803",
	"./surah/19_9.png": "45c2",
	"./surah/19_90.png": "f7f2",
	"./surah/19_91.png": "c5ce",
	"./surah/19_92.png": "0e5c",
	"./surah/19_93.png": "5607",
	"./surah/19_94.png": "988d",
	"./surah/19_95.png": "fca9",
	"./surah/19_96.png": "1a9a",
	"./surah/19_97.png": "290b",
	"./surah/19_98.png": "b007",
	"./surah/1_1.png": "a730",
	"./surah/1_2.png": "e537",
	"./surah/1_3.png": "82ae",
	"./surah/1_4.png": "1d4c",
	"./surah/1_5.png": "1bb7",
	"./surah/1_6.png": "f1ec",
	"./surah/1_7.png": "a3b1",
	"./surah/20_1.png": "a275",
	"./surah/20_10.png": "5347",
	"./surah/20_100.png": "6362",
	"./surah/20_101.png": "e8dd",
	"./surah/20_102.png": "02ec",
	"./surah/20_103.png": "1897",
	"./surah/20_104.png": "84ce",
	"./surah/20_105.png": "ecf6",
	"./surah/20_106.png": "90bb",
	"./surah/20_107.png": "ed47",
	"./surah/20_108.png": "9578",
	"./surah/20_109.png": "7625",
	"./surah/20_11.png": "e5f7",
	"./surah/20_110.png": "6504",
	"./surah/20_111.png": "eb91",
	"./surah/20_112.png": "b18f",
	"./surah/20_113.png": "bcaf",
	"./surah/20_114.png": "437a",
	"./surah/20_115.png": "c4bd",
	"./surah/20_116.png": "e2dc",
	"./surah/20_117.png": "b642",
	"./surah/20_118.png": "f89b",
	"./surah/20_119.png": "30c2",
	"./surah/20_12.png": "c890",
	"./surah/20_120.png": "7ddd",
	"./surah/20_121.png": "1958",
	"./surah/20_122.png": "10f4",
	"./surah/20_123.png": "89cb",
	"./surah/20_124.png": "a870",
	"./surah/20_125.png": "db32",
	"./surah/20_126.png": "b148",
	"./surah/20_127.png": "42e4",
	"./surah/20_128.png": "393b",
	"./surah/20_129.png": "b3a4",
	"./surah/20_13.png": "2a4e",
	"./surah/20_130.png": "5cab",
	"./surah/20_131.png": "e3e4",
	"./surah/20_132.png": "f228",
	"./surah/20_133.png": "e899",
	"./surah/20_134.png": "1b57",
	"./surah/20_135.png": "b044",
	"./surah/20_14.png": "f12c",
	"./surah/20_15.png": "7432",
	"./surah/20_16.png": "d2b8",
	"./surah/20_17.png": "26e9",
	"./surah/20_18.png": "4df7",
	"./surah/20_19.png": "0c73",
	"./surah/20_2.png": "4961",
	"./surah/20_20.png": "4975",
	"./surah/20_21.png": "572b",
	"./surah/20_22.png": "7503",
	"./surah/20_23.png": "ada8",
	"./surah/20_24.png": "774c",
	"./surah/20_25.png": "d427",
	"./surah/20_26.png": "88c6",
	"./surah/20_27.png": "3cc2",
	"./surah/20_28.png": "7e43",
	"./surah/20_29.png": "25f7",
	"./surah/20_3.png": "48ba",
	"./surah/20_30.png": "83ea",
	"./surah/20_31.png": "8b8f",
	"./surah/20_32.png": "d9fe",
	"./surah/20_33.png": "6361",
	"./surah/20_34.png": "3539",
	"./surah/20_35.png": "74c9",
	"./surah/20_36.png": "8e4d",
	"./surah/20_37.png": "bfa7",
	"./surah/20_38.png": "3941",
	"./surah/20_39.png": "8eaa",
	"./surah/20_4.png": "2409",
	"./surah/20_40.png": "4e55",
	"./surah/20_41.png": "d182",
	"./surah/20_42.png": "4419",
	"./surah/20_43.png": "31bf",
	"./surah/20_44.png": "af0a",
	"./surah/20_45.png": "0ffe",
	"./surah/20_46.png": "28c3",
	"./surah/20_47.png": "c781",
	"./surah/20_48.png": "4be3",
	"./surah/20_49.png": "d77e",
	"./surah/20_5.png": "71e1",
	"./surah/20_50.png": "d6c0",
	"./surah/20_51.png": "1aa8",
	"./surah/20_52.png": "bad0",
	"./surah/20_53.png": "04fa",
	"./surah/20_54.png": "5bee",
	"./surah/20_55.png": "b858",
	"./surah/20_56.png": "53fe4",
	"./surah/20_57.png": "ddae",
	"./surah/20_58.png": "fc94",
	"./surah/20_59.png": "b020",
	"./surah/20_6.png": "3fc0",
	"./surah/20_60.png": "f9d0",
	"./surah/20_61.png": "f047",
	"./surah/20_62.png": "487b",
	"./surah/20_63.png": "48db",
	"./surah/20_64.png": "bcc0",
	"./surah/20_65.png": "caf7",
	"./surah/20_66.png": "4eeb",
	"./surah/20_67.png": "61c0",
	"./surah/20_68.png": "3d7a",
	"./surah/20_69.png": "22ef",
	"./surah/20_7.png": "88f24",
	"./surah/20_70.png": "5e32",
	"./surah/20_71.png": "952f",
	"./surah/20_72.png": "dd76",
	"./surah/20_73.png": "d502",
	"./surah/20_74.png": "3b02",
	"./surah/20_75.png": "1e55",
	"./surah/20_76.png": "23e1",
	"./surah/20_77.png": "37cf",
	"./surah/20_78.png": "11c1",
	"./surah/20_79.png": "604d",
	"./surah/20_8.png": "3f1e",
	"./surah/20_80.png": "2703",
	"./surah/20_81.png": "ed8a",
	"./surah/20_82.png": "3665",
	"./surah/20_83.png": "579f7",
	"./surah/20_84.png": "9502",
	"./surah/20_85.png": "37708",
	"./surah/20_86.png": "95c1",
	"./surah/20_87.png": "9cb2",
	"./surah/20_88.png": "4762",
	"./surah/20_89.png": "1ff0",
	"./surah/20_9.png": "39d5",
	"./surah/20_90.png": "e427",
	"./surah/20_91.png": "6d77",
	"./surah/20_92.png": "a716",
	"./surah/20_93.png": "46af",
	"./surah/20_94.png": "5e01",
	"./surah/20_95.png": "b8e6",
	"./surah/20_96.png": "21d4",
	"./surah/20_97.png": "7a31",
	"./surah/20_98.png": "27f0",
	"./surah/20_99.png": "1c71",
	"./surah/21_1.png": "1f3f",
	"./surah/21_10.png": "48e2",
	"./surah/21_100.png": "0261c",
	"./surah/21_101.png": "dc7d",
	"./surah/21_102.png": "66bf",
	"./surah/21_103.png": "35da",
	"./surah/21_104.png": "d35f",
	"./surah/21_105.png": "d138",
	"./surah/21_106.png": "0fd7",
	"./surah/21_107.png": "9bea",
	"./surah/21_108.png": "e375",
	"./surah/21_109.png": "67d3",
	"./surah/21_11.png": "dc2c",
	"./surah/21_110.png": "ff7d",
	"./surah/21_111.png": "2ad5",
	"./surah/21_112.png": "dded",
	"./surah/21_12.png": "53e5",
	"./surah/21_13.png": "1cef",
	"./surah/21_14.png": "8c22",
	"./surah/21_15.png": "6c47",
	"./surah/21_16.png": "50ba",
	"./surah/21_17.png": "85a3",
	"./surah/21_18.png": "35ab",
	"./surah/21_19.png": "1175",
	"./surah/21_2.png": "bdac",
	"./surah/21_20.png": "f725",
	"./surah/21_21.png": "639d",
	"./surah/21_22.png": "24b3",
	"./surah/21_23.png": "1ffd",
	"./surah/21_24.png": "e7c7",
	"./surah/21_25.png": "1ee4",
	"./surah/21_26.png": "edde",
	"./surah/21_27.png": "a0c0",
	"./surah/21_28.png": "6b33",
	"./surah/21_29.png": "f6e8",
	"./surah/21_3.png": "a786",
	"./surah/21_30.png": "0303",
	"./surah/21_31.png": "4a1e",
	"./surah/21_32.png": "8ab9",
	"./surah/21_33.png": "c870",
	"./surah/21_34.png": "72c8",
	"./surah/21_35.png": "9f3e",
	"./surah/21_36.png": "119a",
	"./surah/21_37.png": "53fd",
	"./surah/21_38.png": "3c2d",
	"./surah/21_39.png": "1f51",
	"./surah/21_4.png": "2138",
	"./surah/21_40.png": "ff60",
	"./surah/21_41.png": "9378",
	"./surah/21_42.png": "9f84",
	"./surah/21_43.png": "9897",
	"./surah/21_44.png": "6fb7",
	"./surah/21_45.png": "82f0",
	"./surah/21_46.png": "0649",
	"./surah/21_47.png": "a386",
	"./surah/21_48.png": "6173",
	"./surah/21_49.png": "8e11",
	"./surah/21_5.png": "96d3",
	"./surah/21_50.png": "058e",
	"./surah/21_51.png": "f958",
	"./surah/21_52.png": "72b9",
	"./surah/21_53.png": "a19e",
	"./surah/21_54.png": "0ff3",
	"./surah/21_55.png": "3336",
	"./surah/21_56.png": "113a",
	"./surah/21_57.png": "456a",
	"./surah/21_58.png": "eef3",
	"./surah/21_59.png": "9002",
	"./surah/21_6.png": "328e",
	"./surah/21_60.png": "3ccc",
	"./surah/21_61.png": "7d84",
	"./surah/21_62.png": "5d9a",
	"./surah/21_63.png": "bdfb",
	"./surah/21_64.png": "4597",
	"./surah/21_65.png": "4acf",
	"./surah/21_66.png": "ab2b",
	"./surah/21_67.png": "dd87",
	"./surah/21_68.png": "3825",
	"./surah/21_69.png": "e63c",
	"./surah/21_7.png": "8c5f",
	"./surah/21_70.png": "0125",
	"./surah/21_71.png": "9e25",
	"./surah/21_72.png": "4e6e",
	"./surah/21_73.png": "0eb7",
	"./surah/21_74.png": "ff55",
	"./surah/21_75.png": "6247",
	"./surah/21_76.png": "d2c23",
	"./surah/21_77.png": "346a",
	"./surah/21_78.png": "17d8",
	"./surah/21_79.png": "e2c2c",
	"./surah/21_8.png": "13e8",
	"./surah/21_80.png": "aab5",
	"./surah/21_81.png": "0764",
	"./surah/21_82.png": "d116",
	"./surah/21_83.png": "671f",
	"./surah/21_84.png": "6953",
	"./surah/21_85.png": "f359",
	"./surah/21_86.png": "c0c5",
	"./surah/21_87.png": "18b7",
	"./surah/21_88.png": "e6e4",
	"./surah/21_89.png": "420b",
	"./surah/21_9.png": "2ed5",
	"./surah/21_90.png": "59a3",
	"./surah/21_91.png": "251a",
	"./surah/21_92.png": "8f5c",
	"./surah/21_93.png": "3896",
	"./surah/21_94.png": "176f",
	"./surah/21_95.png": "f425",
	"./surah/21_96.png": "a4f2",
	"./surah/21_97.png": "2170",
	"./surah/21_98.png": "11f5",
	"./surah/21_99.png": "c4d7",
	"./surah/22_1.png": "2bb6",
	"./surah/22_10.png": "1cfc",
	"./surah/22_11.png": "b358",
	"./surah/22_12.png": "a004",
	"./surah/22_13.png": "4cb5",
	"./surah/22_14.png": "1b76",
	"./surah/22_15.png": "7bf6",
	"./surah/22_16.png": "b139",
	"./surah/22_17.png": "0097",
	"./surah/22_18.png": "acc5",
	"./surah/22_19.png": "0098",
	"./surah/22_2.png": "d3b6",
	"./surah/22_20.png": "877c",
	"./surah/22_21.png": "7e54",
	"./surah/22_22.png": "eee8",
	"./surah/22_23.png": "4a52",
	"./surah/22_24.png": "d39e",
	"./surah/22_25.png": "71a7",
	"./surah/22_26.png": "8f59",
	"./surah/22_27.png": "72c3",
	"./surah/22_28.png": "b8e0",
	"./surah/22_29.png": "8c82",
	"./surah/22_3.png": "5fcb",
	"./surah/22_30.png": "4cd1",
	"./surah/22_31.png": "ee4d",
	"./surah/22_32.png": "de36",
	"./surah/22_33.png": "cb15",
	"./surah/22_34.png": "d986",
	"./surah/22_35.png": "76b2",
	"./surah/22_36.png": "d0ba",
	"./surah/22_37.png": "1f04",
	"./surah/22_38.png": "b0fe",
	"./surah/22_39.png": "e8cd",
	"./surah/22_4.png": "a115",
	"./surah/22_40.png": "cc0b",
	"./surah/22_41.png": "0367",
	"./surah/22_42.png": "f51f",
	"./surah/22_43.png": "32f0",
	"./surah/22_44.png": "75cb",
	"./surah/22_45.png": "3d08",
	"./surah/22_46.png": "e853",
	"./surah/22_47.png": "556a",
	"./surah/22_48.png": "ada9",
	"./surah/22_49.png": "1b1a",
	"./surah/22_5.png": "133a",
	"./surah/22_50.png": "27ce8",
	"./surah/22_51.png": "a88e",
	"./surah/22_52.png": "11c7",
	"./surah/22_53.png": "bfe28",
	"./surah/22_54.png": "4d50",
	"./surah/22_55.png": "9e54",
	"./surah/22_56.png": "a222",
	"./surah/22_57.png": "3ae9",
	"./surah/22_58.png": "4c5d",
	"./surah/22_59.png": "82f6",
	"./surah/22_6.png": "3cda",
	"./surah/22_60.png": "ebb2",
	"./surah/22_61.png": "5364",
	"./surah/22_62.png": "ba42",
	"./surah/22_63.png": "561d",
	"./surah/22_64.png": "675d",
	"./surah/22_65.png": "86ab1",
	"./surah/22_66.png": "ea56",
	"./surah/22_67.png": "c76f",
	"./surah/22_68.png": "b689",
	"./surah/22_69.png": "f758",
	"./surah/22_7.png": "2552",
	"./surah/22_70.png": "3a7b",
	"./surah/22_71.png": "6930",
	"./surah/22_72.png": "aa3f",
	"./surah/22_73.png": "1f34",
	"./surah/22_74.png": "55c9",
	"./surah/22_75.png": "82cb",
	"./surah/22_76.png": "0eb5",
	"./surah/22_77.png": "c4bb",
	"./surah/22_78.png": "f62e",
	"./surah/22_8.png": "e2a3",
	"./surah/22_9.png": "4802",
	"./surah/23_1.png": "d4cf",
	"./surah/23_10.png": "5884",
	"./surah/23_100.png": "5591",
	"./surah/23_101.png": "fc33",
	"./surah/23_102.png": "fbd3",
	"./surah/23_103.png": "79276",
	"./surah/23_104.png": "f03a",
	"./surah/23_105.png": "5469",
	"./surah/23_106.png": "095b",
	"./surah/23_107.png": "8c97",
	"./surah/23_108.png": "d862",
	"./surah/23_109.png": "db05",
	"./surah/23_11.png": "1a1a4",
	"./surah/23_110.png": "c048",
	"./surah/23_111.png": "841b",
	"./surah/23_112.png": "a121",
	"./surah/23_113.png": "e6ac",
	"./surah/23_114.png": "3d11",
	"./surah/23_115.png": "8b6c",
	"./surah/23_116.png": "d44b",
	"./surah/23_117.png": "9408",
	"./surah/23_118.png": "53df",
	"./surah/23_12.png": "fb2b",
	"./surah/23_13.png": "c630",
	"./surah/23_14.png": "9bd7",
	"./surah/23_15.png": "ed52",
	"./surah/23_16.png": "136f",
	"./surah/23_17.png": "852b",
	"./surah/23_18.png": "320d",
	"./surah/23_19.png": "8c29",
	"./surah/23_2.png": "b29f",
	"./surah/23_20.png": "15f8",
	"./surah/23_21.png": "ea50",
	"./surah/23_22.png": "ac21",
	"./surah/23_23.png": "3f8e",
	"./surah/23_24.png": "5727",
	"./surah/23_25.png": "a0fe",
	"./surah/23_26.png": "86e5",
	"./surah/23_27.png": "506d",
	"./surah/23_28.png": "6b4b",
	"./surah/23_29.png": "1aa89",
	"./surah/23_3.png": "b4e4",
	"./surah/23_30.png": "6bff",
	"./surah/23_31.png": "6224",
	"./surah/23_32.png": "d612",
	"./surah/23_33.png": "33c5",
	"./surah/23_34.png": "acb4",
	"./surah/23_35.png": "c7b3",
	"./surah/23_36.png": "8929",
	"./surah/23_37.png": "c125",
	"./surah/23_38.png": "3ce5",
	"./surah/23_39.png": "90d3",
	"./surah/23_4.png": "feb9",
	"./surah/23_40.png": "d159",
	"./surah/23_41.png": "5198",
	"./surah/23_42.png": "7809",
	"./surah/23_43.png": "c57a",
	"./surah/23_44.png": "b40a",
	"./surah/23_45.png": "b2cf",
	"./surah/23_46.png": "22eb",
	"./surah/23_47.png": "4573",
	"./surah/23_48.png": "8b8b",
	"./surah/23_49.png": "1550",
	"./surah/23_5.png": "2872",
	"./surah/23_50.png": "c836",
	"./surah/23_51.png": "871f",
	"./surah/23_52.png": "7540",
	"./surah/23_53.png": "fcbd",
	"./surah/23_54.png": "13b3",
	"./surah/23_55.png": "a734",
	"./surah/23_56.png": "cc724",
	"./surah/23_57.png": "5af3",
	"./surah/23_58.png": "b8a9",
	"./surah/23_59.png": "b446",
	"./surah/23_6.png": "9e17",
	"./surah/23_60.png": "795b",
	"./surah/23_61.png": "f8e5",
	"./surah/23_62.png": "06dd",
	"./surah/23_63.png": "4077",
	"./surah/23_64.png": "7f43",
	"./surah/23_65.png": "f993",
	"./surah/23_66.png": "f240",
	"./surah/23_67.png": "6cab",
	"./surah/23_68.png": "bb0f",
	"./surah/23_69.png": "a838",
	"./surah/23_7.png": "9f42",
	"./surah/23_70.png": "6e3f",
	"./surah/23_71.png": "a9e3a",
	"./surah/23_72.png": "b671b",
	"./surah/23_73.png": "5df2",
	"./surah/23_74.png": "a672",
	"./surah/23_75.png": "5c50",
	"./surah/23_76.png": "218c",
	"./surah/23_77.png": "bc8a",
	"./surah/23_78.png": "1400",
	"./surah/23_79.png": "1c31",
	"./surah/23_8.png": "7fee",
	"./surah/23_80.png": "c2ca",
	"./surah/23_81.png": "bae7",
	"./surah/23_82.png": "e761",
	"./surah/23_83.png": "2cb7",
	"./surah/23_84.png": "7472",
	"./surah/23_85.png": "b58d",
	"./surah/23_86.png": "93c2",
	"./surah/23_87.png": "62c6",
	"./surah/23_88.png": "0621",
	"./surah/23_89.png": "4b4b",
	"./surah/23_9.png": "7055",
	"./surah/23_90.png": "5660",
	"./surah/23_91.png": "f859",
	"./surah/23_92.png": "2c3f",
	"./surah/23_93.png": "4e7b",
	"./surah/23_94.png": "bb6a",
	"./surah/23_95.png": "0814",
	"./surah/23_96.png": "69c3",
	"./surah/23_97.png": "5463",
	"./surah/23_98.png": "77c6",
	"./surah/23_99.png": "bf81",
	"./surah/24_1.png": "1863",
	"./surah/24_10.png": "be23",
	"./surah/24_11.png": "f7c2",
	"./surah/24_12.png": "3f97",
	"./surah/24_13.png": "0cdb",
	"./surah/24_14.png": "f15e2",
	"./surah/24_15.png": "f8b3",
	"./surah/24_16.png": "f2f2",
	"./surah/24_17.png": "8b97",
	"./surah/24_18.png": "f88f",
	"./surah/24_19.png": "e184",
	"./surah/24_2.png": "ad8a",
	"./surah/24_20.png": "9359",
	"./surah/24_21.png": "03a4",
	"./surah/24_22.png": "9ab6",
	"./surah/24_23.png": "01ab",
	"./surah/24_24.png": "344d",
	"./surah/24_25.png": "43ff",
	"./surah/24_26.png": "6d16",
	"./surah/24_27.png": "c9d4",
	"./surah/24_28.png": "3834",
	"./surah/24_29.png": "3a7d",
	"./surah/24_3.png": "cf2a",
	"./surah/24_30.png": "db7c",
	"./surah/24_31.png": "541e",
	"./surah/24_32.png": "fded",
	"./surah/24_33.png": "0acd",
	"./surah/24_34.png": "c138",
	"./surah/24_35.png": "6157",
	"./surah/24_36.png": "8db7",
	"./surah/24_37.png": "b740",
	"./surah/24_38.png": "cfde",
	"./surah/24_39.png": "b016",
	"./surah/24_4.png": "51ab",
	"./surah/24_40.png": "9dd6",
	"./surah/24_41.png": "94bf",
	"./surah/24_42.png": "db277",
	"./surah/24_43.png": "c465",
	"./surah/24_44.png": "1ddb",
	"./surah/24_45.png": "4af5",
	"./surah/24_46.png": "c83e",
	"./surah/24_47.png": "64ae",
	"./surah/24_48.png": "2446",
	"./surah/24_49.png": "8d08",
	"./surah/24_5.png": "85d6",
	"./surah/24_50.png": "95a7",
	"./surah/24_51.png": "7574",
	"./surah/24_52.png": "0fa1",
	"./surah/24_53.png": "30e4",
	"./surah/24_54.png": "2f98",
	"./surah/24_55.png": "29aa",
	"./surah/24_56.png": "9706",
	"./surah/24_57.png": "876c",
	"./surah/24_58.png": "eea4",
	"./surah/24_59.png": "ba33",
	"./surah/24_6.png": "7747",
	"./surah/24_60.png": "6a74",
	"./surah/24_61.png": "39e1",
	"./surah/24_62.png": "78a7",
	"./surah/24_63.png": "3556",
	"./surah/24_64.png": "f69d",
	"./surah/24_7.png": "eae8",
	"./surah/24_8.png": "6685",
	"./surah/24_9.png": "f46c",
	"./surah/25_1.png": "7b5d",
	"./surah/25_10.png": "190f",
	"./surah/25_11.png": "34ee",
	"./surah/25_12.png": "18eb",
	"./surah/25_13.png": "7589",
	"./surah/25_14.png": "1fdd",
	"./surah/25_15.png": "23a6",
	"./surah/25_16.png": "02a8",
	"./surah/25_17.png": "8df0",
	"./surah/25_18.png": "56a1",
	"./surah/25_19.png": "06bc",
	"./surah/25_2.png": "7d78",
	"./surah/25_20.png": "8457",
	"./surah/25_21.png": "63bf",
	"./surah/25_22.png": "4248",
	"./surah/25_23.png": "ee48",
	"./surah/25_24.png": "1de8",
	"./surah/25_25.png": "0ddf",
	"./surah/25_26.png": "d21b",
	"./surah/25_27.png": "015d",
	"./surah/25_28.png": "be3a",
	"./surah/25_29.png": "36658",
	"./surah/25_3.png": "8dbb",
	"./surah/25_30.png": "58c9",
	"./surah/25_31.png": "8cb3",
	"./surah/25_32.png": "ec01",
	"./surah/25_33.png": "db7b",
	"./surah/25_34.png": "9a21",
	"./surah/25_35.png": "b2a1",
	"./surah/25_36.png": "ece7",
	"./surah/25_37.png": "f1b5",
	"./surah/25_38.png": "1147",
	"./surah/25_39.png": "148a",
	"./surah/25_4.png": "89c1",
	"./surah/25_40.png": "25f4",
	"./surah/25_41.png": "a447",
	"./surah/25_42.png": "583d",
	"./surah/25_43.png": "e1da",
	"./surah/25_44.png": "641e",
	"./surah/25_45.png": "f1e9",
	"./surah/25_46.png": "3f16",
	"./surah/25_47.png": "c27a",
	"./surah/25_48.png": "83f2",
	"./surah/25_49.png": "ae24",
	"./surah/25_5.png": "cb9c",
	"./surah/25_50.png": "9205",
	"./surah/25_51.png": "b1eb",
	"./surah/25_52.png": "5ae9",
	"./surah/25_53.png": "676d",
	"./surah/25_54.png": "7e75",
	"./surah/25_55.png": "1fa0",
	"./surah/25_56.png": "469a",
	"./surah/25_57.png": "28f9",
	"./surah/25_58.png": "db8b",
	"./surah/25_59.png": "1e66",
	"./surah/25_6.png": "234d",
	"./surah/25_60.png": "9239",
	"./surah/25_61.png": "905e",
	"./surah/25_62.png": "b6c1",
	"./surah/25_63.png": "8f68",
	"./surah/25_64.png": "1b93",
	"./surah/25_65.png": "a8ca",
	"./surah/25_66.png": "186a",
	"./surah/25_67.png": "eb7b",
	"./surah/25_68.png": "ad31",
	"./surah/25_69.png": "4fb0b",
	"./surah/25_7.png": "9ae7",
	"./surah/25_70.png": "c6778",
	"./surah/25_71.png": "d358",
	"./surah/25_72.png": "e8dc",
	"./surah/25_73.png": "4397",
	"./surah/25_74.png": "fa28",
	"./surah/25_75.png": "eb89",
	"./surah/25_76.png": "f3f1",
	"./surah/25_77.png": "948e",
	"./surah/25_8.png": "038d",
	"./surah/25_9.png": "3e34",
	"./surah/26_1.png": "a7dd",
	"./surah/26_10.png": "cd59",
	"./surah/26_100.png": "2d7b",
	"./surah/26_101.png": "84f7",
	"./surah/26_102.png": "1af5",
	"./surah/26_103.png": "7753",
	"./surah/26_104.png": "c206",
	"./surah/26_105.png": "4d34",
	"./surah/26_106.png": "1ce0",
	"./surah/26_107.png": "05f0",
	"./surah/26_108.png": "8ceb",
	"./surah/26_109.png": "ffa3",
	"./surah/26_11.png": "8959",
	"./surah/26_110.png": "6dd6",
	"./surah/26_111.png": "ef44",
	"./surah/26_112.png": "515d",
	"./surah/26_113.png": "1af8",
	"./surah/26_114.png": "74e3",
	"./surah/26_115.png": "bd84",
	"./surah/26_116.png": "cfe9",
	"./surah/26_117.png": "b46b",
	"./surah/26_118.png": "6e52",
	"./surah/26_119.png": "fce3",
	"./surah/26_12.png": "779d",
	"./surah/26_120.png": "bb1d",
	"./surah/26_121.png": "f32e",
	"./surah/26_122.png": "3d81",
	"./surah/26_123.png": "68c5",
	"./surah/26_124.png": "397e",
	"./surah/26_125.png": "29a1",
	"./surah/26_126.png": "162bb",
	"./surah/26_127.png": "4465",
	"./surah/26_128.png": "6eec",
	"./surah/26_129.png": "6fae",
	"./surah/26_13.png": "a548",
	"./surah/26_130.png": "8d28",
	"./surah/26_131.png": "e817",
	"./surah/26_132.png": "3f52",
	"./surah/26_133.png": "4b5c",
	"./surah/26_134.png": "f059",
	"./surah/26_135.png": "1b50",
	"./surah/26_136.png": "1ec4",
	"./surah/26_137.png": "f757",
	"./surah/26_138.png": "1fb8",
	"./surah/26_139.png": "d6ee",
	"./surah/26_14.png": "c086",
	"./surah/26_140.png": "690f",
	"./surah/26_141.png": "9dfa",
	"./surah/26_142.png": "d94b",
	"./surah/26_143.png": "462e",
	"./surah/26_144.png": "7ced",
	"./surah/26_145.png": "33d0",
	"./surah/26_146.png": "1a7d",
	"./surah/26_147.png": "adec",
	"./surah/26_148.png": "48f3",
	"./surah/26_149.png": "e984",
	"./surah/26_15.png": "f309",
	"./surah/26_150.png": "689f",
	"./surah/26_151.png": "1e01",
	"./surah/26_152.png": "ae6c",
	"./surah/26_153.png": "c974",
	"./surah/26_154.png": "7e5f",
	"./surah/26_155.png": "7ec9",
	"./surah/26_156.png": "0dbf",
	"./surah/26_157.png": "288a",
	"./surah/26_158.png": "76b7",
	"./surah/26_159.png": "41db",
	"./surah/26_16.png": "c23f",
	"./surah/26_160.png": "fd8f",
	"./surah/26_161.png": "f007",
	"./surah/26_162.png": "642b",
	"./surah/26_163.png": "94a7",
	"./surah/26_164.png": "5bfa",
	"./surah/26_165.png": "4ca1",
	"./surah/26_166.png": "ba7f",
	"./surah/26_167.png": "c0fa",
	"./surah/26_168.png": "1e41",
	"./surah/26_169.png": "639b",
	"./surah/26_17.png": "0e09",
	"./surah/26_170.png": "fee5",
	"./surah/26_171.png": "4040",
	"./surah/26_172.png": "5152",
	"./surah/26_173.png": "dec1",
	"./surah/26_174.png": "e7f9",
	"./surah/26_175.png": "3a43",
	"./surah/26_176.png": "cfa1",
	"./surah/26_177.png": "62cf",
	"./surah/26_178.png": "0e12",
	"./surah/26_179.png": "7249",
	"./surah/26_18.png": "0cee",
	"./surah/26_180.png": "0da5",
	"./surah/26_181.png": "c0fd",
	"./surah/26_182.png": "a917c",
	"./surah/26_183.png": "83f9",
	"./surah/26_184.png": "8a51",
	"./surah/26_185.png": "86d2",
	"./surah/26_186.png": "f61e",
	"./surah/26_187.png": "2d9b0",
	"./surah/26_188.png": "2935",
	"./surah/26_189.png": "a272",
	"./surah/26_19.png": "7571",
	"./surah/26_190.png": "2a83",
	"./surah/26_191.png": "fdf1",
	"./surah/26_192.png": "b646",
	"./surah/26_193.png": "54bd",
	"./surah/26_194.png": "3b56",
	"./surah/26_195.png": "e1d6",
	"./surah/26_196.png": "caa0",
	"./surah/26_197.png": "0a8f",
	"./surah/26_198.png": "93af",
	"./surah/26_199.png": "829d",
	"./surah/26_2.png": "9fda",
	"./surah/26_20.png": "528d",
	"./surah/26_200.png": "f987",
	"./surah/26_201.png": "344f",
	"./surah/26_202.png": "15ae",
	"./surah/26_203.png": "ef4b",
	"./surah/26_204.png": "e5ea",
	"./surah/26_205.png": "9fa4",
	"./surah/26_206.png": "d1e9",
	"./surah/26_207.png": "8466",
	"./surah/26_208.png": "11f0",
	"./surah/26_209.png": "bdd5",
	"./surah/26_21.png": "33bb",
	"./surah/26_210.png": "bbfa",
	"./surah/26_211.png": "afec",
	"./surah/26_212.png": "3f75",
	"./surah/26_213.png": "5f9a",
	"./surah/26_214.png": "eb83",
	"./surah/26_215.png": "e1b3",
	"./surah/26_216.png": "2f2c",
	"./surah/26_217.png": "5bfd",
	"./surah/26_218.png": "9560",
	"./surah/26_219.png": "f357",
	"./surah/26_22.png": "6b04",
	"./surah/26_220.png": "8ede",
	"./surah/26_221.png": "d6e1",
	"./surah/26_222.png": "a9e33",
	"./surah/26_223.png": "9359d",
	"./surah/26_224.png": "be233",
	"./surah/26_225.png": "521d",
	"./surah/26_226.png": "ef5f",
	"./surah/26_227.png": "a66e",
	"./surah/26_23.png": "1f43",
	"./surah/26_24.png": "54b6",
	"./surah/26_25.png": "a8f1",
	"./surah/26_26.png": "d711",
	"./surah/26_27.png": "5219",
	"./surah/26_28.png": "88cd",
	"./surah/26_29.png": "afc7",
	"./surah/26_3.png": "e578",
	"./surah/26_30.png": "1583",
	"./surah/26_31.png": "89e4",
	"./surah/26_32.png": "927a",
	"./surah/26_33.png": "fbf9",
	"./surah/26_34.png": "5602",
	"./surah/26_35.png": "5bde",
	"./surah/26_36.png": "56cb",
	"./surah/26_37.png": "2121",
	"./surah/26_38.png": "b33f",
	"./surah/26_39.png": "bd8d",
	"./surah/26_4.png": "992e",
	"./surah/26_40.png": "430d",
	"./surah/26_41.png": "4925",
	"./surah/26_42.png": "2c01",
	"./surah/26_43.png": "03ba",
	"./surah/26_44.png": "e62b",
	"./surah/26_45.png": "ef85",
	"./surah/26_46.png": "4c44",
	"./surah/26_47.png": "f59a",
	"./surah/26_48.png": "716e",
	"./surah/26_49.png": "653e",
	"./surah/26_5.png": "d1be",
	"./surah/26_50.png": "1f82",
	"./surah/26_51.png": "5f3f",
	"./surah/26_52.png": "ce08",
	"./surah/26_53.png": "5296",
	"./surah/26_54.png": "9b0d",
	"./surah/26_55.png": "4d08",
	"./surah/26_56.png": "4f19",
	"./surah/26_57.png": "dd74",
	"./surah/26_58.png": "51d8",
	"./surah/26_59.png": "c35a",
	"./surah/26_6.png": "3826",
	"./surah/26_60.png": "bed2",
	"./surah/26_61.png": "4aca",
	"./surah/26_62.png": "4dcd",
	"./surah/26_63.png": "81d0",
	"./surah/26_64.png": "2476",
	"./surah/26_65.png": "8bb9",
	"./surah/26_66.png": "2ba9",
	"./surah/26_67.png": "1bd1",
	"./surah/26_68.png": "9bf3",
	"./surah/26_69.png": "c7bf",
	"./surah/26_7.png": "1663",
	"./surah/26_70.png": "f861",
	"./surah/26_71.png": "4fc9",
	"./surah/26_72.png": "4611",
	"./surah/26_73.png": "ae2a",
	"./surah/26_74.png": "b38d",
	"./surah/26_75.png": "40407",
	"./surah/26_76.png": "236a",
	"./surah/26_77.png": "67ef",
	"./surah/26_78.png": "5c6c2",
	"./surah/26_79.png": "fad0",
	"./surah/26_8.png": "e9eb",
	"./surah/26_80.png": "3882",
	"./surah/26_81.png": "ae9c",
	"./surah/26_82.png": "1199",
	"./surah/26_83.png": "5e27",
	"./surah/26_84.png": "8f57",
	"./surah/26_85.png": "e41e",
	"./surah/26_86.png": "ee3f",
	"./surah/26_87.png": "9974",
	"./surah/26_88.png": "65b4",
	"./surah/26_89.png": "b1d9",
	"./surah/26_9.png": "a040",
	"./surah/26_90.png": "c52e",
	"./surah/26_91.png": "e7fd",
	"./surah/26_92.png": "e2d4",
	"./surah/26_93.png": "f393",
	"./surah/26_94.png": "3b5d",
	"./surah/26_95.png": "6e67",
	"./surah/26_96.png": "b640",
	"./surah/26_97.png": "d091",
	"./surah/26_98.png": "e2dd",
	"./surah/26_99.png": "2d66",
	"./surah/27_1.png": "e1fd",
	"./surah/27_10.png": "1416",
	"./surah/27_11.png": "0d17",
	"./surah/27_12.png": "cdd25",
	"./surah/27_13.png": "ba09",
	"./surah/27_14.png": "a992",
	"./surah/27_15.png": "f039",
	"./surah/27_16.png": "a66e9",
	"./surah/27_17.png": "dffc",
	"./surah/27_18.png": "7212",
	"./surah/27_19.png": "af75",
	"./surah/27_2.png": "744b",
	"./surah/27_20.png": "ce3e",
	"./surah/27_21.png": "70d3",
	"./surah/27_22.png": "b97e",
	"./surah/27_23.png": "f8c3",
	"./surah/27_24.png": "6e8e",
	"./surah/27_25.png": "eba6",
	"./surah/27_26.png": "b299",
	"./surah/27_27.png": "bd82",
	"./surah/27_28.png": "551c",
	"./surah/27_29.png": "5b17",
	"./surah/27_3.png": "666f",
	"./surah/27_30.png": "b97a",
	"./surah/27_31.png": "1bf3",
	"./surah/27_32.png": "aa75",
	"./surah/27_33.png": "2e83",
	"./surah/27_34.png": "cd5f",
	"./surah/27_35.png": "04a8",
	"./surah/27_36.png": "c724",
	"./surah/27_37.png": "b159",
	"./surah/27_38.png": "14c6",
	"./surah/27_39.png": "35bb",
	"./surah/27_4.png": "0eac",
	"./surah/27_40.png": "008b",
	"./surah/27_41.png": "185b",
	"./surah/27_42.png": "1b0f",
	"./surah/27_43.png": "57ff",
	"./surah/27_44.png": "1422",
	"./surah/27_45.png": "96ea",
	"./surah/27_46.png": "3452",
	"./surah/27_47.png": "2b53",
	"./surah/27_48.png": "e3a0",
	"./surah/27_49.png": "19c4",
	"./surah/27_5.png": "6998",
	"./surah/27_50.png": "703d",
	"./surah/27_51.png": "9dfb",
	"./surah/27_52.png": "2f87",
	"./surah/27_53.png": "f01d0",
	"./surah/27_54.png": "eb77",
	"./surah/27_55.png": "ff8b",
	"./surah/27_56.png": "430df",
	"./surah/27_57.png": "e629",
	"./surah/27_58.png": "c6d7",
	"./surah/27_59.png": "1ec8",
	"./surah/27_6.png": "d55a",
	"./surah/27_60.png": "1263",
	"./surah/27_61.png": "c64a",
	"./surah/27_62.png": "e329",
	"./surah/27_63.png": "f03e",
	"./surah/27_64.png": "cf5f",
	"./surah/27_65.png": "3b00",
	"./surah/27_66.png": "6e50",
	"./surah/27_67.png": "3401",
	"./surah/27_68.png": "b297",
	"./surah/27_69.png": "6457",
	"./surah/27_7.png": "7bd3",
	"./surah/27_70.png": "b583",
	"./surah/27_71.png": "02c0",
	"./surah/27_72.png": "c311",
	"./surah/27_73.png": "f904",
	"./surah/27_74.png": "9fb6",
	"./surah/27_75.png": "8ef5",
	"./surah/27_76.png": "7c7f",
	"./surah/27_77.png": "32e6",
	"./surah/27_78.png": "8a61",
	"./surah/27_79.png": "e550",
	"./surah/27_8.png": "2aeb",
	"./surah/27_80.png": "aa08",
	"./surah/27_81.png": "fcf1",
	"./surah/27_82.png": "a33d",
	"./surah/27_83.png": "fea0",
	"./surah/27_84.png": "94ea",
	"./surah/27_85.png": "4a1f",
	"./surah/27_86.png": "29c8",
	"./surah/27_87.png": "9258",
	"./surah/27_88.png": "9615",
	"./surah/27_89.png": "95a3",
	"./surah/27_9.png": "d4da",
	"./surah/27_90.png": "02e0",
	"./surah/27_91.png": "c199",
	"./surah/27_92.png": "f3bf3",
	"./surah/27_93.png": "2274",
	"./surah/28_1.png": "620c",
	"./surah/28_10.png": "cb7b",
	"./surah/28_11.png": "20fc",
	"./surah/28_12.png": "2f8b",
	"./surah/28_13.png": "debc",
	"./surah/28_14.png": "bf17",
	"./surah/28_15.png": "ab64",
	"./surah/28_16.png": "85c8",
	"./surah/28_17.png": "898d",
	"./surah/28_18.png": "e9d7",
	"./surah/28_19.png": "b347",
	"./surah/28_2.png": "9d64",
	"./surah/28_20.png": "f3d8",
	"./surah/28_21.png": "ea43",
	"./surah/28_22.png": "84c1",
	"./surah/28_23.png": "39ef1",
	"./surah/28_24.png": "b41b",
	"./surah/28_25.png": "eeb0",
	"./surah/28_26.png": "225b",
	"./surah/28_27.png": "ce53",
	"./surah/28_28.png": "dfe7",
	"./surah/28_29.png": "b750",
	"./surah/28_3.png": "23de",
	"./surah/28_30.png": "085f",
	"./surah/28_31.png": "031f",
	"./surah/28_32.png": "5048",
	"./surah/28_33.png": "15e5",
	"./surah/28_34.png": "9869",
	"./surah/28_35.png": "8037",
	"./surah/28_36.png": "ee0d",
	"./surah/28_37.png": "cad0",
	"./surah/28_38.png": "fd9c",
	"./surah/28_39.png": "28f6",
	"./surah/28_4.png": "9334",
	"./surah/28_40.png": "2b7f8",
	"./surah/28_41.png": "8ef6",
	"./surah/28_42.png": "4d7b",
	"./surah/28_43.png": "8cd6",
	"./surah/28_44.png": "b425",
	"./surah/28_45.png": "ad50",
	"./surah/28_46.png": "5c84",
	"./surah/28_47.png": "28dd",
	"./surah/28_48.png": "9642",
	"./surah/28_49.png": "399c",
	"./surah/28_5.png": "e063",
	"./surah/28_50.png": "26e5",
	"./surah/28_51.png": "17c20",
	"./surah/28_52.png": "00be",
	"./surah/28_53.png": "8fce7",
	"./surah/28_54.png": "6281",
	"./surah/28_55.png": "bbe2",
	"./surah/28_56.png": "d16a",
	"./surah/28_57.png": "72d0",
	"./surah/28_58.png": "7c63",
	"./surah/28_59.png": "4e5f0",
	"./surah/28_6.png": "8e9d",
	"./surah/28_60.png": "a538",
	"./surah/28_61.png": "f847",
	"./surah/28_62.png": "3652",
	"./surah/28_63.png": "3fad",
	"./surah/28_64.png": "b6cd",
	"./surah/28_65.png": "917e",
	"./surah/28_66.png": "c043",
	"./surah/28_67.png": "be6e",
	"./surah/28_68.png": "f48d",
	"./surah/28_69.png": "46e8",
	"./surah/28_7.png": "992a",
	"./surah/28_70.png": "7c44",
	"./surah/28_71.png": "7fc6",
	"./surah/28_72.png": "7877",
	"./surah/28_73.png": "64c0",
	"./surah/28_74.png": "9e8a",
	"./surah/28_75.png": "a500",
	"./surah/28_76.png": "c110",
	"./surah/28_77.png": "30a1",
	"./surah/28_78.png": "aff9",
	"./surah/28_79.png": "a1d5",
	"./surah/28_8.png": "752c",
	"./surah/28_80.png": "f846",
	"./surah/28_81.png": "5d65",
	"./surah/28_82.png": "9eb4",
	"./surah/28_83.png": "9c8c",
	"./surah/28_84.png": "aa6e",
	"./surah/28_85.png": "84b2",
	"./surah/28_86.png": "d98a",
	"./surah/28_87.png": "8e1f",
	"./surah/28_88.png": "22d7",
	"./surah/28_9.png": "799e",
	"./surah/29_1.png": "17b1",
	"./surah/29_10.png": "2937",
	"./surah/29_11.png": "558c",
	"./surah/29_12.png": "960c",
	"./surah/29_13.png": "9ee3",
	"./surah/29_14.png": "3037",
	"./surah/29_15.png": "f3e8",
	"./surah/29_16.png": "f1eb",
	"./surah/29_17.png": "3cda6",
	"./surah/29_18.png": "8374",
	"./surah/29_19.png": "194f",
	"./surah/29_2.png": "155e",
	"./surah/29_20.png": "773c",
	"./surah/29_21.png": "7482",
	"./surah/29_22.png": "309a",
	"./surah/29_23.png": "47cc",
	"./surah/29_24.png": "09a0",
	"./surah/29_25.png": "1816",
	"./surah/29_26.png": "68ef",
	"./surah/29_27.png": "447a",
	"./surah/29_28.png": "735d",
	"./surah/29_29.png": "320e",
	"./surah/29_3.png": "fdaf",
	"./surah/29_30.png": "e995",
	"./surah/29_31.png": "4c49",
	"./surah/29_32.png": "83ed",
	"./surah/29_33.png": "7927e",
	"./surah/29_34.png": "cd28",
	"./surah/29_35.png": "9b20",
	"./surah/29_36.png": "8372",
	"./surah/29_37.png": "49c3",
	"./surah/29_38.png": "5c96",
	"./surah/29_39.png": "8c70",
	"./surah/29_4.png": "ffcf",
	"./surah/29_40.png": "b021",
	"./surah/29_41.png": "ddfa",
	"./surah/29_42.png": "17bf",
	"./surah/29_43.png": "f28a",
	"./surah/29_44.png": "cd1f",
	"./surah/29_45.png": "576d",
	"./surah/29_46.png": "1d2e",
	"./surah/29_47.png": "0d92",
	"./surah/29_48.png": "b45d",
	"./surah/29_49.png": "d2e7",
	"./surah/29_5.png": "f8da",
	"./surah/29_50.png": "90af",
	"./surah/29_51.png": "4acd",
	"./surah/29_52.png": "1eac",
	"./surah/29_53.png": "34e9",
	"./surah/29_54.png": "8682",
	"./surah/29_55.png": "1194",
	"./surah/29_56.png": "46ac",
	"./surah/29_57.png": "8a68",
	"./surah/29_58.png": "53407",
	"./surah/29_59.png": "1f38",
	"./surah/29_6.png": "84d8",
	"./surah/29_60.png": "2650",
	"./surah/29_61.png": "2a16",
	"./surah/29_62.png": "3c5f",
	"./surah/29_63.png": "5407",
	"./surah/29_64.png": "96aa",
	"./surah/29_65.png": "94be",
	"./surah/29_66.png": "cb3a",
	"./surah/29_67.png": "c9ac",
	"./surah/29_68.png": "6c7f",
	"./surah/29_69.png": "cd8c",
	"./surah/29_7.png": "812f",
	"./surah/29_8.png": "47cc3",
	"./surah/29_9.png": "7821",
	"./surah/2_1.png": "7516",
	"./surah/2_10.png": "cd1a",
	"./surah/2_100.png": "c39d",
	"./surah/2_101.png": "b33f1",
	"./surah/2_102.png": "629a",
	"./surah/2_103.png": "1e69",
	"./surah/2_104.png": "10af",
	"./surah/2_105.png": "6bbd",
	"./surah/2_106.png": "a918",
	"./surah/2_107.png": "0aa2",
	"./surah/2_108.png": "9d63",
	"./surah/2_109.png": "7bcb",
	"./surah/2_11.png": "cc0f",
	"./surah/2_110.png": "c440",
	"./surah/2_111.png": "acf9",
	"./surah/2_112.png": "4444",
	"./surah/2_113.png": "4b76",
	"./surah/2_114.png": "78b2",
	"./surah/2_115.png": "338c",
	"./surah/2_116.png": "6e17",
	"./surah/2_117.png": "c5f6",
	"./surah/2_118.png": "f780",
	"./surah/2_119.png": "42bc",
	"./surah/2_12.png": "c9d4c",
	"./surah/2_120.png": "a670",
	"./surah/2_121.png": "0d41",
	"./surah/2_122.png": "c79c",
	"./surah/2_123.png": "12d3",
	"./surah/2_124.png": "cac5",
	"./surah/2_125.png": "dcc1",
	"./surah/2_126.png": "61bb",
	"./surah/2_127.png": "d6d9",
	"./surah/2_128.png": "c2e1",
	"./surah/2_129.png": "0139",
	"./surah/2_13.png": "41cb",
	"./surah/2_130.png": "cf0b",
	"./surah/2_131.png": "d915",
	"./surah/2_132.png": "cf5c",
	"./surah/2_133.png": "7a75",
	"./surah/2_134.png": "0aa6",
	"./surah/2_135.png": "dfcf",
	"./surah/2_136.png": "850b",
	"./surah/2_137.png": "d179",
	"./surah/2_138.png": "ddc4",
	"./surah/2_139.png": "8295",
	"./surah/2_14.png": "bc51",
	"./surah/2_140.png": "2dc9",
	"./surah/2_141.png": "6b4f",
	"./surah/2_142.png": "8e39",
	"./surah/2_143.png": "7342",
	"./surah/2_144.png": "9e97",
	"./surah/2_145.png": "a0e2",
	"./surah/2_146.png": "93c0",
	"./surah/2_147.png": "2c3e",
	"./surah/2_148.png": "dd57",
	"./surah/2_149.png": "dae4",
	"./surah/2_15.png": "1dab",
	"./surah/2_150.png": "52a9",
	"./surah/2_151.png": "a24a",
	"./surah/2_152.png": "fe2c",
	"./surah/2_153.png": "b9da",
	"./surah/2_154.png": "474d",
	"./surah/2_155.png": "6cb6",
	"./surah/2_156.png": "9de0",
	"./surah/2_157.png": "e0a4",
	"./surah/2_158.png": "4713",
	"./surah/2_159.png": "ca99",
	"./surah/2_16.png": "b365",
	"./surah/2_160.png": "290e",
	"./surah/2_161.png": "2f53",
	"./surah/2_162.png": "6b3c",
	"./surah/2_163.png": "9247",
	"./surah/2_164.png": "16ca",
	"./surah/2_165.png": "7d3e",
	"./surah/2_166.png": "b635",
	"./surah/2_167.png": "de0e",
	"./surah/2_168.png": "b57c",
	"./surah/2_169.png": "a909",
	"./surah/2_17.png": "f27e",
	"./surah/2_170.png": "fc97",
	"./surah/2_171.png": "5c76",
	"./surah/2_172.png": "ece28",
	"./surah/2_173.png": "c036",
	"./surah/2_174.png": "62a5",
	"./surah/2_175.png": "24f1",
	"./surah/2_176.png": "fb11",
	"./surah/2_177.png": "3f87",
	"./surah/2_178.png": "801c",
	"./surah/2_179.png": "7ab9",
	"./surah/2_18.png": "8276",
	"./surah/2_180.png": "e4d8",
	"./surah/2_181.png": "b688",
	"./surah/2_182.png": "0831",
	"./surah/2_183.png": "2112",
	"./surah/2_184.png": "5d64",
	"./surah/2_185.png": "1b2a",
	"./surah/2_186.png": "71ea",
	"./surah/2_187.png": "2266a",
	"./surah/2_188.png": "6dc1",
	"./surah/2_189.png": "75c3",
	"./surah/2_19.png": "e9a6",
	"./surah/2_190.png": "9e64",
	"./surah/2_191.png": "8f2f",
	"./surah/2_192.png": "bdeb",
	"./surah/2_193.png": "eb93",
	"./surah/2_194.png": "0acc",
	"./surah/2_195.png": "175e",
	"./surah/2_196.png": "9739",
	"./surah/2_197.png": "2a9c",
	"./surah/2_198.png": "a4af",
	"./surah/2_199.png": "5d67",
	"./surah/2_2.png": "981d",
	"./surah/2_20.png": "1dd6",
	"./surah/2_200.png": "37b7",
	"./surah/2_201.png": "0f38",
	"./surah/2_202.png": "4148",
	"./surah/2_203.png": "590a",
	"./surah/2_204.png": "388d",
	"./surah/2_205.png": "8dd7",
	"./surah/2_206.png": "d215",
	"./surah/2_207.png": "3bb6",
	"./surah/2_208.png": "016f",
	"./surah/2_209.png": "356f",
	"./surah/2_21.png": "dbbb",
	"./surah/2_210.png": "f74a",
	"./surah/2_211.png": "3ad02",
	"./surah/2_212.png": "1dde9",
	"./surah/2_213.png": "26b0",
	"./surah/2_214.png": "f63c",
	"./surah/2_215.png": "9e5c",
	"./surah/2_216.png": "d0ce",
	"./surah/2_217.png": "d2b1",
	"./surah/2_218.png": "6115",
	"./surah/2_219.png": "af28",
	"./surah/2_22.png": "fcee",
	"./surah/2_220.png": "7d07",
	"./surah/2_221.png": "59b2",
	"./surah/2_222.png": "8795",
	"./surah/2_223.png": "20b89",
	"./surah/2_224.png": "18731",
	"./surah/2_225.png": "a5e0",
	"./surah/2_226.png": "72e6",
	"./surah/2_227.png": "b31a",
	"./surah/2_228.png": "07ca",
	"./surah/2_229.png": "2772",
	"./surah/2_23.png": "8b7a",
	"./surah/2_230.png": "8d94",
	"./surah/2_231.png": "8376",
	"./surah/2_232.png": "7115",
	"./surah/2_233.png": "8fd8",
	"./surah/2_234.png": "ae2aa",
	"./surah/2_235.png": "3410c",
	"./surah/2_236.png": "40ad",
	"./surah/2_237.png": "dfee",
	"./surah/2_238.png": "9330",
	"./surah/2_239.png": "fbd6",
	"./surah/2_24.png": "a2d6",
	"./surah/2_240.png": "b5e1",
	"./surah/2_241.png": "f9d8",
	"./surah/2_242.png": "6ef8",
	"./surah/2_243.png": "56de",
	"./surah/2_244.png": "63c1",
	"./surah/2_245.png": "3749",
	"./surah/2_246.png": "ed8c",
	"./surah/2_247.png": "714f",
	"./surah/2_248.png": "393e",
	"./surah/2_249.png": "0a62",
	"./surah/2_25.png": "8e00",
	"./surah/2_250.png": "463c",
	"./surah/2_251.png": "acdb",
	"./surah/2_252.png": "058f",
	"./surah/2_253.png": "0f46",
	"./surah/2_254.png": "b032",
	"./surah/2_255.png": "cacf",
	"./surah/2_256.png": "8593",
	"./surah/2_257.png": "a518",
	"./surah/2_258.png": "6e47",
	"./surah/2_259.png": "1cb3",
	"./surah/2_26.png": "de05",
	"./surah/2_260.png": "ac7e",
	"./surah/2_261.png": "57cb",
	"./surah/2_262.png": "4e95",
	"./surah/2_263.png": "eb52",
	"./surah/2_264.png": "8a24",
	"./surah/2_265.png": "06f3",
	"./surah/2_266.png": "5022",
	"./surah/2_267.png": "544b",
	"./surah/2_268.png": "c91b",
	"./surah/2_269.png": "47cf",
	"./surah/2_27.png": "6ba9",
	"./surah/2_270.png": "f984",
	"./surah/2_271.png": "33b0",
	"./surah/2_272.png": "7e04",
	"./surah/2_273.png": "de2b",
	"./surah/2_274.png": "8701",
	"./surah/2_275.png": "87d2",
	"./surah/2_276.png": "d2d4",
	"./surah/2_277.png": "bd50",
	"./surah/2_278.png": "d656",
	"./surah/2_279.png": "4a34",
	"./surah/2_28.png": "08b9a",
	"./surah/2_280.png": "32fd",
	"./surah/2_281.png": "5f6f",
	"./surah/2_282.png": "1673",
	"./surah/2_283.png": "5081",
	"./surah/2_284.png": "0f20",
	"./surah/2_285.png": "b7e6",
	"./surah/2_286.png": "f792",
	"./surah/2_29.png": "7fba",
	"./surah/2_3.png": "2d5f",
	"./surah/2_30.png": "3c21",
	"./surah/2_31.png": "c54e",
	"./surah/2_32.png": "0c91",
	"./surah/2_33.png": "f600",
	"./surah/2_34.png": "6a12",
	"./surah/2_35.png": "b367",
	"./surah/2_36.png": "328a",
	"./surah/2_37.png": "f4f5",
	"./surah/2_38.png": "4ebf",
	"./surah/2_39.png": "4c13",
	"./surah/2_4.png": "cada",
	"./surah/2_40.png": "a059",
	"./surah/2_41.png": "0bf0",
	"./surah/2_42.png": "df68",
	"./surah/2_43.png": "a060",
	"./surah/2_44.png": "33b8",
	"./surah/2_45.png": "d7da",
	"./surah/2_46.png": "640b",
	"./surah/2_47.png": "98d9",
	"./surah/2_48.png": "b557",
	"./surah/2_49.png": "22a6",
	"./surah/2_5.png": "857f",
	"./surah/2_50.png": "18c2",
	"./surah/2_51.png": "e1d6b",
	"./surah/2_52.png": "73c5",
	"./surah/2_53.png": "83e6",
	"./surah/2_54.png": "95ef",
	"./surah/2_55.png": "61e0",
	"./surah/2_56.png": "c74a",
	"./surah/2_57.png": "365b",
	"./surah/2_58.png": "d4dc",
	"./surah/2_59.png": "9032",
	"./surah/2_6.png": "db3f",
	"./surah/2_60.png": "e489",
	"./surah/2_61.png": "46f5",
	"./surah/2_62.png": "23eb",
	"./surah/2_63.png": "456f",
	"./surah/2_64.png": "ee52",
	"./surah/2_65.png": "abe9",
	"./surah/2_66.png": "1775",
	"./surah/2_67.png": "d602",
	"./surah/2_68.png": "d7ec",
	"./surah/2_69.png": "3559",
	"./surah/2_7.png": "ae2c",
	"./surah/2_70.png": "6d81",
	"./surah/2_71.png": "17c6",
	"./surah/2_72.png": "b3b1",
	"./surah/2_73.png": "7287",
	"./surah/2_74.png": "0c63",
	"./surah/2_75.png": "fc72",
	"./surah/2_76.png": "91c9",
	"./surah/2_77.png": "10d0",
	"./surah/2_78.png": "c4f1",
	"./surah/2_79.png": "93b4",
	"./surah/2_8.png": "03bc",
	"./surah/2_80.png": "f191",
	"./surah/2_81.png": "652b",
	"./surah/2_82.png": "8f5d",
	"./surah/2_83.png": "c77e",
	"./surah/2_84.png": "de5e",
	"./surah/2_85.png": "3a14",
	"./surah/2_86.png": "73d2",
	"./surah/2_87.png": "833b",
	"./surah/2_88.png": "2f7a",
	"./surah/2_89.png": "b855",
	"./surah/2_9.png": "0e80",
	"./surah/2_90.png": "a179",
	"./surah/2_91.png": "852bf",
	"./surah/2_92.png": "5b5b",
	"./surah/2_93.png": "7fea",
	"./surah/2_94.png": "14fb",
	"./surah/2_95.png": "62c7",
	"./surah/2_96.png": "a169",
	"./surah/2_97.png": "e1fd1",
	"./surah/2_98.png": "293b",
	"./surah/2_99.png": "f74e",
	"./surah/30_1.png": "445c",
	"./surah/30_10.png": "4208",
	"./surah/30_11.png": "cfa2",
	"./surah/30_12.png": "72df",
	"./surah/30_13.png": "04b4",
	"./surah/30_14.png": "2d61",
	"./surah/30_15.png": "066c",
	"./surah/30_16.png": "34f2d",
	"./surah/30_17.png": "c17c",
	"./surah/30_18.png": "e6aa",
	"./surah/30_19.png": "7494",
	"./surah/30_2.png": "542a",
	"./surah/30_20.png": "103b",
	"./surah/30_21.png": "89f1",
	"./surah/30_22.png": "5969",
	"./surah/30_23.png": "fe4d",
	"./surah/30_24.png": "d581",
	"./surah/30_25.png": "2f873",
	"./surah/30_26.png": "1a0d",
	"./surah/30_27.png": "186af",
	"./surah/30_28.png": "3df9",
	"./surah/30_29.png": "2d34",
	"./surah/30_3.png": "2bcf",
	"./surah/30_30.png": "c82a",
	"./surah/30_31.png": "35f8",
	"./surah/30_32.png": "2d01",
	"./surah/30_33.png": "439e",
	"./surah/30_34.png": "b3e0",
	"./surah/30_35.png": "e241",
	"./surah/30_36.png": "f1a5",
	"./surah/30_37.png": "251aa",
	"./surah/30_38.png": "48e8",
	"./surah/30_39.png": "8061",
	"./surah/30_4.png": "fdd6",
	"./surah/30_40.png": "0379",
	"./surah/30_41.png": "47a0",
	"./surah/30_42.png": "8480",
	"./surah/30_43.png": "64da",
	"./surah/30_44.png": "4749",
	"./surah/30_45.png": "23cc",
	"./surah/30_46.png": "e904",
	"./surah/30_47.png": "229d",
	"./surah/30_48.png": "43f7",
	"./surah/30_49.png": "2ffe",
	"./surah/30_5.png": "54ef",
	"./surah/30_50.png": "7089",
	"./surah/30_51.png": "1ebf",
	"./surah/30_52.png": "c32a",
	"./surah/30_53.png": "2560",
	"./surah/30_54.png": "de24",
	"./surah/30_55.png": "04c7",
	"./surah/30_56.png": "5ee4",
	"./surah/30_57.png": "a4c5",
	"./surah/30_58.png": "6e6a",
	"./surah/30_59.png": "d999",
	"./surah/30_6.png": "1495",
	"./surah/30_60.png": "f82ed",
	"./surah/30_7.png": "3d8b",
	"./surah/30_8.png": "3d1c",
	"./surah/30_9.png": "65d0",
	"./surah/31_1.png": "8ad0",
	"./surah/31_10.png": "56ce",
	"./surah/31_11.png": "8ac4",
	"./surah/31_12.png": "e16e",
	"./surah/31_13.png": "e8e4",
	"./surah/31_14.png": "c889",
	"./surah/31_15.png": "ffba",
	"./surah/31_16.png": "2c0c",
	"./surah/31_17.png": "4b09",
	"./surah/31_18.png": "bd21",
	"./surah/31_19.png": "424f",
	"./surah/31_2.png": "e9ae",
	"./surah/31_20.png": "0ed9",
	"./surah/31_21.png": "0494",
	"./surah/31_22.png": "b8e3",
	"./surah/31_23.png": "3745",
	"./surah/31_24.png": "07f0",
	"./surah/31_25.png": "2aa7",
	"./surah/31_26.png": "0629",
	"./surah/31_27.png": "7db4",
	"./surah/31_28.png": "7068",
	"./surah/31_29.png": "539c",
	"./surah/31_3.png": "1d57",
	"./surah/31_30.png": "1b8a",
	"./surah/31_31.png": "d82f",
	"./surah/31_32.png": "38b8",
	"./surah/31_33.png": "fc66",
	"./surah/31_34.png": "98d7",
	"./surah/31_4.png": "7631",
	"./surah/31_5.png": "265d",
	"./surah/31_6.png": "8be8",
	"./surah/31_7.png": "897b",
	"./surah/31_8.png": "288e",
	"./surah/31_9.png": "280e",
	"./surah/32_1.png": "2df5",
	"./surah/32_10.png": "1970",
	"./surah/32_11.png": "8b2e",
	"./surah/32_12.png": "b886",
	"./surah/32_13.png": "e52a",
	"./surah/32_14.png": "9fb9e",
	"./surah/32_15.png": "1db1",
	"./surah/32_16.png": "2624",
	"./surah/32_17.png": "bdaa",
	"./surah/32_18.png": "dd65",
	"./surah/32_19.png": "c3eb",
	"./surah/32_2.png": "4f00",
	"./surah/32_20.png": "de1f",
	"./surah/32_21.png": "a34d",
	"./surah/32_22.png": "3653",
	"./surah/32_23.png": "11aa",
	"./surah/32_24.png": "627b",
	"./surah/32_25.png": "d292",
	"./surah/32_26.png": "c100",
	"./surah/32_27.png": "0935",
	"./surah/32_28.png": "c111",
	"./surah/32_29.png": "6b05",
	"./surah/32_3.png": "b4f7",
	"./surah/32_30.png": "578a",
	"./surah/32_4.png": "7dce",
	"./surah/32_5.png": "e7fd2",
	"./surah/32_6.png": "6828",
	"./surah/32_7.png": "aa9f",
	"./surah/32_8.png": "1b23",
	"./surah/32_9.png": "03aa",
	"./surah/33_1.png": "d2d7",
	"./surah/33_10.png": "4455",
	"./surah/33_11.png": "8620",
	"./surah/33_12.png": "279b",
	"./surah/33_13.png": "52bc",
	"./surah/33_14.png": "293c",
	"./surah/33_15.png": "de6b",
	"./surah/33_16.png": "11fd",
	"./surah/33_17.png": "15ef",
	"./surah/33_18.png": "7ece",
	"./surah/33_19.png": "00b4f",
	"./surah/33_2.png": "706a",
	"./surah/33_20.png": "32eb",
	"./surah/33_21.png": "b866",
	"./surah/33_22.png": "8f9d",
	"./surah/33_23.png": "7403",
	"./surah/33_24.png": "1981",
	"./surah/33_25.png": "3b01",
	"./surah/33_26.png": "9252",
	"./surah/33_27.png": "10d7",
	"./surah/33_28.png": "7541",
	"./surah/33_29.png": "ca88",
	"./surah/33_3.png": "704d",
	"./surah/33_30.png": "c2c3",
	"./surah/33_31.png": "fe74",
	"./surah/33_32.png": "d8a3",
	"./surah/33_33.png": "72e4",
	"./surah/33_34.png": "e5a7",
	"./surah/33_35.png": "2893",
	"./surah/33_36.png": "9cec",
	"./surah/33_37.png": "fd10",
	"./surah/33_38.png": "65fc",
	"./surah/33_39.png": "2fed",
	"./surah/33_4.png": "5dd6",
	"./surah/33_40.png": "c74e",
	"./surah/33_41.png": "c6bc",
	"./surah/33_42.png": "059c",
	"./surah/33_43.png": "9092",
	"./surah/33_44.png": "adbd",
	"./surah/33_45.png": "0b3fa",
	"./surah/33_46.png": "773a",
	"./surah/33_47.png": "30c0",
	"./surah/33_48.png": "6b24",
	"./surah/33_49.png": "d0d4",
	"./surah/33_5.png": "e5a1",
	"./surah/33_50.png": "28db",
	"./surah/33_51.png": "8b08",
	"./surah/33_52.png": "03f4",
	"./surah/33_53.png": "146e",
	"./surah/33_54.png": "c103",
	"./surah/33_55.png": "f8ab",
	"./surah/33_56.png": "7392",
	"./surah/33_57.png": "ec94",
	"./surah/33_58.png": "f2cff",
	"./surah/33_59.png": "1f77",
	"./surah/33_6.png": "5d71",
	"./surah/33_60.png": "1b5e",
	"./surah/33_61.png": "6c6a",
	"./surah/33_62.png": "f082",
	"./surah/33_63.png": "f9c3",
	"./surah/33_64.png": "ad40",
	"./surah/33_65.png": "9de8",
	"./surah/33_66.png": "e06a",
	"./surah/33_67.png": "b2cf4",
	"./surah/33_68.png": "9dc1",
	"./surah/33_69.png": "c301",
	"./surah/33_7.png": "99d9",
	"./surah/33_70.png": "42281",
	"./surah/33_71.png": "3ea7",
	"./surah/33_72.png": "9b3b",
	"./surah/33_73.png": "dc97",
	"./surah/33_8.png": "0316",
	"./surah/33_9.png": "1218",
	"./surah/34_1.png": "bf9c",
	"./surah/34_10.png": "d6c07",
	"./surah/34_11.png": "9198",
	"./surah/34_12.png": "ca0c",
	"./surah/34_13.png": "d56e",
	"./surah/34_14.png": "11f5e",
	"./surah/34_15.png": "1bd7",
	"./surah/34_16.png": "4749f",
	"./surah/34_17.png": "e20c",
	"./surah/34_18.png": "7658",
	"./surah/34_19.png": "2f07",
	"./surah/34_2.png": "8faa",
	"./surah/34_20.png": "39c1",
	"./surah/34_21.png": "da9f",
	"./surah/34_22.png": "d1ef",
	"./surah/34_23.png": "d356",
	"./surah/34_24.png": "d695",
	"./surah/34_25.png": "c57e",
	"./surah/34_26.png": "ffdf",
	"./surah/34_27.png": "f615",
	"./surah/34_28.png": "1099",
	"./surah/34_29.png": "5f7c",
	"./surah/34_3.png": "d6eb",
	"./surah/34_30.png": "1897f",
	"./surah/34_31.png": "cafe",
	"./surah/34_32.png": "214a",
	"./surah/34_33.png": "67ac",
	"./surah/34_34.png": "350d",
	"./surah/34_35.png": "825e",
	"./surah/34_36.png": "d598",
	"./surah/34_37.png": "5675",
	"./surah/34_38.png": "92b7",
	"./surah/34_39.png": "bcc0e",
	"./surah/34_4.png": "6673",
	"./surah/34_40.png": "a5d6",
	"./surah/34_41.png": "a1d9",
	"./surah/34_42.png": "0444",
	"./surah/34_43.png": "d36f",
	"./surah/34_44.png": "c7e8",
	"./surah/34_45.png": "cd62",
	"./surah/34_46.png": "996f",
	"./surah/34_47.png": "9a19",
	"./surah/34_48.png": "bece",
	"./surah/34_49.png": "56b0",
	"./surah/34_5.png": "2f26",
	"./surah/34_50.png": "0a68",
	"./surah/34_51.png": "8fc4",
	"./surah/34_52.png": "6edb",
	"./surah/34_53.png": "dca9",
	"./surah/34_54.png": "fab6",
	"./surah/34_6.png": "4817",
	"./surah/34_7.png": "01fc",
	"./surah/34_8.png": "b505",
	"./surah/34_9.png": "c654",
	"./surah/35_1.png": "acce",
	"./surah/35_10.png": "2abb",
	"./surah/35_11.png": "6610",
	"./surah/35_12.png": "8079",
	"./surah/35_13.png": "0831d",
	"./surah/35_14.png": "92a7",
	"./surah/35_15.png": "4c92",
	"./surah/35_16.png": "471b",
	"./surah/35_17.png": "a361",
	"./surah/35_18.png": "f215",
	"./surah/35_19.png": "9d51",
	"./surah/35_2.png": "5b70",
	"./surah/35_20.png": "7834",
	"./surah/35_21.png": "e056",
	"./surah/35_22.png": "d044",
	"./surah/35_23.png": "86e1",
	"./surah/35_24.png": "3a67",
	"./surah/35_25.png": "003d",
	"./surah/35_26.png": "e4fd",
	"./surah/35_27.png": "e463",
	"./surah/35_28.png": "cc37",
	"./surah/35_29.png": "0cb3",
	"./surah/35_3.png": "5947",
	"./surah/35_30.png": "fad4",
	"./surah/35_31.png": "3ae9d",
	"./surah/35_32.png": "0bc6",
	"./surah/35_33.png": "0f2a",
	"./surah/35_34.png": "d45e",
	"./surah/35_35.png": "5ece",
	"./surah/35_36.png": "fb4a",
	"./surah/35_37.png": "acc8",
	"./surah/35_38.png": "6b00",
	"./surah/35_39.png": "a8c3",
	"./surah/35_4.png": "a785",
	"./surah/35_40.png": "0dba",
	"./surah/35_41.png": "56c1",
	"./surah/35_42.png": "9127",
	"./surah/35_43.png": "939b",
	"./surah/35_44.png": "288e2",
	"./surah/35_45.png": "40b5",
	"./surah/35_5.png": "ef0c",
	"./surah/35_6.png": "0707",
	"./surah/35_7.png": "f0db",
	"./surah/35_8.png": "8c7b",
	"./surah/35_9.png": "7252",
	"./surah/36_1.png": "b6ce",
	"./surah/36_10.png": "c4ed",
	"./surah/36_11.png": "f8b9",
	"./surah/36_12.png": "0ee6",
	"./surah/36_13.png": "ec7a",
	"./surah/36_14.png": "4342",
	"./surah/36_15.png": "124a",
	"./surah/36_16.png": "ef9c",
	"./surah/36_17.png": "2e08",
	"./surah/36_18.png": "1251",
	"./surah/36_19.png": "15dc",
	"./surah/36_2.png": "8e13",
	"./surah/36_20.png": "ce6e",
	"./surah/36_21.png": "001f",
	"./surah/36_22.png": "f7a0",
	"./surah/36_23.png": "c3bf",
	"./surah/36_24.png": "aa60",
	"./surah/36_25.png": "7c8d",
	"./surah/36_26.png": "621a",
	"./surah/36_27.png": "fe05",
	"./surah/36_28.png": "a843",
	"./surah/36_29.png": "df14",
	"./surah/36_3.png": "ebee",
	"./surah/36_30.png": "225c",
	"./surah/36_31.png": "f608",
	"./surah/36_32.png": "1221",
	"./surah/36_33.png": "91a0",
	"./surah/36_34.png": "b78a",
	"./surah/36_35.png": "8291",
	"./surah/36_36.png": "7ca7",
	"./surah/36_37.png": "d0dd",
	"./surah/36_38.png": "45bc",
	"./surah/36_39.png": "eaea",
	"./surah/36_4.png": "d5810",
	"./surah/36_40.png": "64b0",
	"./surah/36_41.png": "4f99",
	"./surah/36_42.png": "c2b4",
	"./surah/36_43.png": "1a48",
	"./surah/36_44.png": "a8fe",
	"./surah/36_45.png": "ea26",
	"./surah/36_46.png": "9d54",
	"./surah/36_47.png": "29db",
	"./surah/36_48.png": "14ed",
	"./surah/36_49.png": "70aa",
	"./surah/36_5.png": "f4e7",
	"./surah/36_50.png": "2270",
	"./surah/36_51.png": "c18d",
	"./surah/36_52.png": "ab18",
	"./surah/36_53.png": "46fb",
	"./surah/36_54.png": "32c0",
	"./surah/36_55.png": "90b3",
	"./surah/36_56.png": "c082",
	"./surah/36_57.png": "2b7b",
	"./surah/36_58.png": "2a20",
	"./surah/36_59.png": "831d",
	"./surah/36_6.png": "2e063",
	"./surah/36_60.png": "fd6e",
	"./surah/36_61.png": "8265",
	"./surah/36_62.png": "7c07",
	"./surah/36_63.png": "d403",
	"./surah/36_64.png": "a6a1",
	"./surah/36_65.png": "3005",
	"./surah/36_66.png": "f86a",
	"./surah/36_67.png": "75f9",
	"./surah/36_68.png": "0587",
	"./surah/36_69.png": "4c97",
	"./surah/36_7.png": "3a09",
	"./surah/36_70.png": "ee23",
	"./surah/36_71.png": "aaf8",
	"./surah/36_72.png": "c520",
	"./surah/36_73.png": "d27b",
	"./surah/36_74.png": "5caa",
	"./surah/36_75.png": "01b5",
	"./surah/36_76.png": "5eea",
	"./surah/36_77.png": "115c",
	"./surah/36_78.png": "a956",
	"./surah/36_79.png": "a149",
	"./surah/36_8.png": "e3754",
	"./surah/36_80.png": "134c",
	"./surah/36_81.png": "84a8",
	"./surah/36_82.png": "28e7",
	"./surah/36_83.png": "e4c6",
	"./surah/36_9.png": "8d9c",
	"./surah/37_1.png": "6c3d7",
	"./surah/37_10.png": "6f84",
	"./surah/37_100.png": "892d",
	"./surah/37_101.png": "4c04",
	"./surah/37_102.png": "cbdb",
	"./surah/37_103.png": "70d9",
	"./surah/37_104.png": "9cb4",
	"./surah/37_105.png": "4651",
	"./surah/37_106.png": "f815",
	"./surah/37_107.png": "397e5",
	"./surah/37_108.png": "bbf9",
	"./surah/37_109.png": "3d66",
	"./surah/37_11.png": "ef5b",
	"./surah/37_110.png": "5094",
	"./surah/37_111.png": "9040",
	"./surah/37_112.png": "d181",
	"./surah/37_113.png": "d204",
	"./surah/37_114.png": "8d3a",
	"./surah/37_115.png": "9a71",
	"./surah/37_116.png": "45ed",
	"./surah/37_117.png": "94ca7",
	"./surah/37_118.png": "e1f2",
	"./surah/37_119.png": "e004",
	"./surah/37_12.png": "39f0",
	"./surah/37_120.png": "b389",
	"./surah/37_121.png": "af60",
	"./surah/37_122.png": "be54",
	"./surah/37_123.png": "de60",
	"./surah/37_124.png": "1cc6",
	"./surah/37_125.png": "5a11",
	"./surah/37_126.png": "c0ea",
	"./surah/37_127.png": "89f6",
	"./surah/37_128.png": "9c00",
	"./surah/37_129.png": "200f",
	"./surah/37_13.png": "c597",
	"./surah/37_130.png": "5575",
	"./surah/37_131.png": "0e95",
	"./surah/37_132.png": "30ef",
	"./surah/37_133.png": "1235",
	"./surah/37_134.png": "f67a",
	"./surah/37_135.png": "2f2f",
	"./surah/37_136.png": "770e",
	"./surah/37_137.png": "bfea",
	"./surah/37_138.png": "7ee9",
	"./surah/37_139.png": "fb9c",
	"./surah/37_14.png": "f04c",
	"./surah/37_140.png": "e486",
	"./surah/37_141.png": "edc2",
	"./surah/37_142.png": "1c028",
	"./surah/37_143.png": "2f5b",
	"./surah/37_144.png": "405f",
	"./surah/37_145.png": "92fe",
	"./surah/37_146.png": "bb80",
	"./surah/37_147.png": "54a8",
	"./surah/37_148.png": "93c7",
	"./surah/37_149.png": "98e3",
	"./surah/37_15.png": "0e5a",
	"./surah/37_150.png": "71db",
	"./surah/37_151.png": "a3b0",
	"./surah/37_152.png": "5d29",
	"./surah/37_153.png": "1096",
	"./surah/37_154.png": "f2ae",
	"./surah/37_155.png": "b95c",
	"./surah/37_156.png": "91b3",
	"./surah/37_157.png": "75c4",
	"./surah/37_158.png": "e528",
	"./surah/37_159.png": "6373",
	"./surah/37_16.png": "8b70",
	"./surah/37_160.png": "b961",
	"./surah/37_161.png": "56e3",
	"./surah/37_162.png": "44cb",
	"./surah/37_163.png": "a10c",
	"./surah/37_164.png": "ade4",
	"./surah/37_165.png": "1f5f",
	"./surah/37_166.png": "2686",
	"./surah/37_167.png": "1076",
	"./surah/37_168.png": "99fd",
	"./surah/37_169.png": "a510",
	"./surah/37_17.png": "4ade",
	"./surah/37_170.png": "f864",
	"./surah/37_171.png": "18bf",
	"./surah/37_172.png": "5df6",
	"./surah/37_173.png": "fe00",
	"./surah/37_174.png": "077a",
	"./surah/37_175.png": "b761",
	"./surah/37_176.png": "0e09c",
	"./surah/37_177.png": "6228",
	"./surah/37_178.png": "8de9",
	"./surah/37_179.png": "5b68",
	"./surah/37_18.png": "4b67",
	"./surah/37_180.png": "5138",
	"./surah/37_181.png": "4d87",
	"./surah/37_182.png": "36b2",
	"./surah/37_19.png": "1fea",
	"./surah/37_2.png": "dc13",
	"./surah/37_20.png": "afb3",
	"./surah/37_21.png": "8cc9",
	"./surah/37_22.png": "a9ca",
	"./surah/37_23.png": "d98d",
	"./surah/37_24.png": "ff45",
	"./surah/37_25.png": "fe45",
	"./surah/37_26.png": "e7ac",
	"./surah/37_27.png": "720c",
	"./surah/37_28.png": "84b2c",
	"./surah/37_29.png": "b9b2",
	"./surah/37_3.png": "6d04",
	"./surah/37_30.png": "b2e4",
	"./surah/37_31.png": "6dbd",
	"./surah/37_32.png": "8741",
	"./surah/37_33.png": "1836",
	"./surah/37_34.png": "c688",
	"./surah/37_35.png": "f279a",
	"./surah/37_36.png": "5aeb",
	"./surah/37_37.png": "7707",
	"./surah/37_38.png": "aa4a",
	"./surah/37_39.png": "81b1",
	"./surah/37_4.png": "755b",
	"./surah/37_40.png": "bc01",
	"./surah/37_41.png": "344b",
	"./surah/37_42.png": "25e0",
	"./surah/37_43.png": "692d",
	"./surah/37_44.png": "41f2",
	"./surah/37_45.png": "d68e",
	"./surah/37_46.png": "3caf",
	"./surah/37_47.png": "1391",
	"./surah/37_48.png": "cf7f",
	"./surah/37_49.png": "4b41",
	"./surah/37_5.png": "d200",
	"./surah/37_50.png": "278b",
	"./surah/37_51.png": "351c",
	"./surah/37_52.png": "f0f8",
	"./surah/37_53.png": "403d",
	"./surah/37_54.png": "54d2",
	"./surah/37_55.png": "afd8",
	"./surah/37_56.png": "43fa",
	"./surah/37_57.png": "c815",
	"./surah/37_58.png": "bc829",
	"./surah/37_59.png": "583e",
	"./surah/37_6.png": "007e",
	"./surah/37_60.png": "ab6f",
	"./surah/37_61.png": "1f93",
	"./surah/37_62.png": "d2e6",
	"./surah/37_63.png": "525c",
	"./surah/37_64.png": "e7e8",
	"./surah/37_65.png": "7b63",
	"./surah/37_66.png": "0f9a",
	"./surah/37_67.png": "fd3d",
	"./surah/37_68.png": "3416",
	"./surah/37_69.png": "16be",
	"./surah/37_7.png": "170c",
	"./surah/37_70.png": "c26b",
	"./surah/37_71.png": "8134",
	"./surah/37_72.png": "3674",
	"./surah/37_73.png": "049a",
	"./surah/37_74.png": "04e4",
	"./surah/37_75.png": "bae4",
	"./surah/37_76.png": "2363",
	"./surah/37_77.png": "59ac",
	"./surah/37_78.png": "ca42",
	"./surah/37_79.png": "a0bf",
	"./surah/37_8.png": "f33ef",
	"./surah/37_80.png": "d488",
	"./surah/37_81.png": "35b5",
	"./surah/37_82.png": "f538",
	"./surah/37_83.png": "a741",
	"./surah/37_84.png": "606f",
	"./surah/37_85.png": "62a9",
	"./surah/37_86.png": "496b",
	"./surah/37_87.png": "34ba",
	"./surah/37_88.png": "3159",
	"./surah/37_89.png": "5041",
	"./surah/37_9.png": "46e5",
	"./surah/37_90.png": "b4db",
	"./surah/37_91.png": "62cc",
	"./surah/37_92.png": "9574",
	"./surah/37_93.png": "3c45",
	"./surah/37_94.png": "8559",
	"./surah/37_95.png": "b1e0",
	"./surah/37_96.png": "b7fb",
	"./surah/37_97.png": "8659",
	"./surah/37_98.png": "d930",
	"./surah/37_99.png": "c72f",
	"./surah/38_1.png": "fb00",
	"./surah/38_10.png": "43fa3",
	"./surah/38_11.png": "faa9",
	"./surah/38_12.png": "5e09",
	"./surah/38_13.png": "7930",
	"./surah/38_14.png": "96aa7",
	"./surah/38_15.png": "0cbd",
	"./surah/38_16.png": "df25",
	"./surah/38_17.png": "422b",
	"./surah/38_18.png": "a670a",
	"./surah/38_19.png": "aa0b",
	"./surah/38_2.png": "448e",
	"./surah/38_20.png": "e725",
	"./surah/38_21.png": "0013",
	"./surah/38_22.png": "21f2",
	"./surah/38_23.png": "70b2",
	"./surah/38_24.png": "de60e",
	"./surah/38_25.png": "e58f",
	"./surah/38_26.png": "6fdb",
	"./surah/38_27.png": "c0b1",
	"./surah/38_28.png": "c939",
	"./surah/38_29.png": "c4f3",
	"./surah/38_3.png": "b221a",
	"./surah/38_30.png": "777e",
	"./surah/38_31.png": "9abc",
	"./surah/38_32.png": "4c61",
	"./surah/38_33.png": "55a5b",
	"./surah/38_34.png": "873a",
	"./surah/38_35.png": "57b0",
	"./surah/38_36.png": "56b7",
	"./surah/38_37.png": "ab82",
	"./surah/38_38.png": "5301",
	"./surah/38_39.png": "4f198",
	"./surah/38_4.png": "f033",
	"./surah/38_40.png": "34e9c",
	"./surah/38_41.png": "7750",
	"./surah/38_42.png": "6b58",
	"./surah/38_43.png": "bd10",
	"./surah/38_44.png": "3792",
	"./surah/38_45.png": "9a6c",
	"./surah/38_46.png": "e5d9",
	"./surah/38_47.png": "0fc1",
	"./surah/38_48.png": "0b6a",
	"./surah/38_49.png": "d476",
	"./surah/38_5.png": "ad19",
	"./surah/38_50.png": "2d48",
	"./surah/38_51.png": "db4d",
	"./surah/38_52.png": "b1c7",
	"./surah/38_53.png": "9e94",
	"./surah/38_54.png": "4a5f",
	"./surah/38_55.png": "cf7b",
	"./surah/38_56.png": "01a8",
	"./surah/38_57.png": "1db8",
	"./surah/38_58.png": "0a0a",
	"./surah/38_59.png": "3a80",
	"./surah/38_6.png": "5ccd",
	"./surah/38_60.png": "1fb4",
	"./surah/38_61.png": "89f2",
	"./surah/38_62.png": "5aa9",
	"./surah/38_63.png": "ad7c",
	"./surah/38_64.png": "24db",
	"./surah/38_65.png": "1db4",
	"./surah/38_66.png": "51de",
	"./surah/38_67.png": "fdf3",
	"./surah/38_68.png": "0b06",
	"./surah/38_69.png": "8dd5",
	"./surah/38_7.png": "6d98",
	"./surah/38_70.png": "7b06",
	"./surah/38_71.png": "47c8",
	"./surah/38_72.png": "2bc6",
	"./surah/38_73.png": "2577",
	"./surah/38_74.png": "0276",
	"./surah/38_75.png": "a6fa",
	"./surah/38_76.png": "2e63",
	"./surah/38_77.png": "3ad6",
	"./surah/38_78.png": "0308",
	"./surah/38_79.png": "50223",
	"./surah/38_8.png": "5270a",
	"./surah/38_80.png": "94db",
	"./surah/38_81.png": "8a35",
	"./surah/38_82.png": "d51f",
	"./surah/38_83.png": "7f0d",
	"./surah/38_84.png": "939c",
	"./surah/38_85.png": "1f9c",
	"./surah/38_86.png": "19ff",
	"./surah/38_87.png": "40ef",
	"./surah/38_88.png": "02eb",
	"./surah/38_9.png": "7389",
	"./surah/39_1.png": "50a9",
	"./surah/39_10.png": "77d9",
	"./surah/39_11.png": "2962",
	"./surah/39_12.png": "c65e",
	"./surah/39_13.png": "81be",
	"./surah/39_14.png": "cda8",
	"./surah/39_15.png": "a63b",
	"./surah/39_16.png": "be31",
	"./surah/39_17.png": "35b3",
	"./surah/39_18.png": "db17",
	"./surah/39_19.png": "2e48",
	"./surah/39_2.png": "7789",
	"./surah/39_20.png": "6816",
	"./surah/39_21.png": "e68d",
	"./surah/39_22.png": "8704",
	"./surah/39_23.png": "46fe",
	"./surah/39_24.png": "9d50",
	"./surah/39_25.png": "5f9af",
	"./surah/39_26.png": "5ee9",
	"./surah/39_27.png": "f5aa",
	"./surah/39_28.png": "0f3b",
	"./surah/39_29.png": "cfb3",
	"./surah/39_3.png": "b4e9",
	"./surah/39_30.png": "e2be",
	"./surah/39_31.png": "9dbc",
	"./surah/39_32.png": "e072",
	"./surah/39_33.png": "7b64",
	"./surah/39_34.png": "2fc2",
	"./surah/39_35.png": "dcc7",
	"./surah/39_36.png": "869d",
	"./surah/39_37.png": "fcdb",
	"./surah/39_38.png": "07d61",
	"./surah/39_39.png": "e300",
	"./surah/39_4.png": "8461",
	"./surah/39_40.png": "ff53",
	"./surah/39_41.png": "dc2a",
	"./surah/39_42.png": "df70",
	"./surah/39_43.png": "9400",
	"./surah/39_44.png": "b61d",
	"./surah/39_45.png": "6f34",
	"./surah/39_46.png": "b152",
	"./surah/39_47.png": "7f68",
	"./surah/39_48.png": "cb34",
	"./surah/39_49.png": "3cb7",
	"./surah/39_5.png": "61d3",
	"./surah/39_50.png": "9f58",
	"./surah/39_51.png": "130e8",
	"./surah/39_52.png": "f7dd",
	"./surah/39_53.png": "7fe1",
	"./surah/39_54.png": "80f1",
	"./surah/39_55.png": "781bf",
	"./surah/39_56.png": "2425",
	"./surah/39_57.png": "afb3b",
	"./surah/39_58.png": "d300",
	"./surah/39_59.png": "69d0",
	"./surah/39_6.png": "1a2c",
	"./surah/39_60.png": "c01b",
	"./surah/39_61.png": "6aa2",
	"./surah/39_62.png": "3fed",
	"./surah/39_63.png": "e285",
	"./surah/39_64.png": "fd87",
	"./surah/39_65.png": "2c23",
	"./surah/39_66.png": "e5db",
	"./surah/39_67.png": "51cd",
	"./surah/39_68.png": "f7f9",
	"./surah/39_69.png": "b387",
	"./surah/39_7.png": "734e",
	"./surah/39_70.png": "b677",
	"./surah/39_71.png": "884d6",
	"./surah/39_72.png": "e2c7",
	"./surah/39_73.png": "d194",
	"./surah/39_74.png": "fe82",
	"./surah/39_75.png": "ece4",
	"./surah/39_8.png": "5981",
	"./surah/39_9.png": "ca9c",
	"./surah/3_1.png": "f969",
	"./surah/3_10.png": "5d28",
	"./surah/3_100.png": "05d2",
	"./surah/3_101.png": "4a4f",
	"./surah/3_102.png": "6e04",
	"./surah/3_103.png": "a6d5",
	"./surah/3_104.png": "f6a7",
	"./surah/3_105.png": "dd99",
	"./surah/3_106.png": "fcd1",
	"./surah/3_107.png": "8399",
	"./surah/3_108.png": "c7d8",
	"./surah/3_109.png": "73fb",
	"./surah/3_11.png": "3a96",
	"./surah/3_110.png": "6f5a",
	"./surah/3_111.png": "9626",
	"./surah/3_112.png": "1702",
	"./surah/3_113.png": "655f",
	"./surah/3_114.png": "4cc4",
	"./surah/3_115.png": "f708",
	"./surah/3_116.png": "5f60",
	"./surah/3_117.png": "eb3c",
	"./surah/3_118.png": "e544",
	"./surah/3_119.png": "9821",
	"./surah/3_12.png": "80a5",
	"./surah/3_120.png": "c95f",
	"./surah/3_121.png": "4464",
	"./surah/3_122.png": "a082",
	"./surah/3_123.png": "15f0",
	"./surah/3_124.png": "9503",
	"./surah/3_125.png": "0820",
	"./surah/3_126.png": "bd6e",
	"./surah/3_127.png": "c6bb",
	"./surah/3_128.png": "c97a",
	"./surah/3_129.png": "6095",
	"./surah/3_13.png": "5fd7",
	"./surah/3_130.png": "ff5d",
	"./surah/3_131.png": "70ec",
	"./surah/3_132.png": "95027",
	"./surah/3_133.png": "e000",
	"./surah/3_134.png": "dfe3",
	"./surah/3_135.png": "a07b",
	"./surah/3_136.png": "f78f",
	"./surah/3_137.png": "5fab",
	"./surah/3_138.png": "5373",
	"./surah/3_139.png": "ae26",
	"./surah/3_14.png": "e347",
	"./surah/3_140.png": "e312",
	"./surah/3_141.png": "3204",
	"./surah/3_142.png": "b887",
	"./surah/3_143.png": "dc50",
	"./surah/3_144.png": "f0e8",
	"./surah/3_145.png": "1f57",
	"./surah/3_146.png": "41a1",
	"./surah/3_147.png": "8510",
	"./surah/3_148.png": "c2c2",
	"./surah/3_149.png": "c3e7",
	"./surah/3_15.png": "6d0b",
	"./surah/3_150.png": "80b6",
	"./surah/3_151.png": "f5f0",
	"./surah/3_152.png": "8981",
	"./surah/3_153.png": "6329",
	"./surah/3_154.png": "e37b",
	"./surah/3_155.png": "35f0",
	"./surah/3_156.png": "9461",
	"./surah/3_157.png": "f18d",
	"./surah/3_158.png": "5675d",
	"./surah/3_159.png": "e259",
	"./surah/3_16.png": "8c6c",
	"./surah/3_160.png": "009f",
	"./surah/3_161.png": "d755",
	"./surah/3_162.png": "8065",
	"./surah/3_163.png": "a4f4",
	"./surah/3_164.png": "d518",
	"./surah/3_165.png": "6d82",
	"./surah/3_166.png": "b5ea",
	"./surah/3_167.png": "c309",
	"./surah/3_168.png": "88a0",
	"./surah/3_169.png": "3589",
	"./surah/3_17.png": "a81d",
	"./surah/3_170.png": "2e58",
	"./surah/3_171.png": "5a8a",
	"./surah/3_172.png": "a0b7",
	"./surah/3_173.png": "deec",
	"./surah/3_174.png": "d607",
	"./surah/3_175.png": "ffeb",
	"./surah/3_176.png": "abdc",
	"./surah/3_177.png": "de47",
	"./surah/3_178.png": "72e45",
	"./surah/3_179.png": "4fd3",
	"./surah/3_18.png": "e712",
	"./surah/3_180.png": "61b6",
	"./surah/3_181.png": "5983",
	"./surah/3_182.png": "2221",
	"./surah/3_183.png": "ef05",
	"./surah/3_184.png": "a341",
	"./surah/3_185.png": "500d",
	"./surah/3_186.png": "877b",
	"./surah/3_187.png": "5dc3",
	"./surah/3_188.png": "3f10",
	"./surah/3_189.png": "cd76",
	"./surah/3_19.png": "5c23",
	"./surah/3_190.png": "f4eb",
	"./surah/3_191.png": "ad12",
	"./surah/3_192.png": "ac7a",
	"./surah/3_193.png": "6aaf",
	"./surah/3_194.png": "4be5",
	"./surah/3_195.png": "208d",
	"./surah/3_196.png": "5850",
	"./surah/3_197.png": "4007",
	"./surah/3_198.png": "b05d",
	"./surah/3_199.png": "ddb2",
	"./surah/3_2.png": "1d76",
	"./surah/3_20.png": "5e0c",
	"./surah/3_200.png": "23ee",
	"./surah/3_21.png": "a2c1",
	"./surah/3_22.png": "3901",
	"./surah/3_23.png": "7220",
	"./surah/3_24.png": "8ec8",
	"./surah/3_25.png": "f9f7",
	"./surah/3_26.png": "bc89",
	"./surah/3_27.png": "03f0",
	"./surah/3_28.png": "009c",
	"./surah/3_29.png": "b71d",
	"./surah/3_3.png": "2c24",
	"./surah/3_30.png": "90e5",
	"./surah/3_31.png": "b098",
	"./surah/3_32.png": "5e7f",
	"./surah/3_33.png": "1973",
	"./surah/3_34.png": "9133",
	"./surah/3_35.png": "05e2",
	"./surah/3_36.png": "dbf9",
	"./surah/3_37.png": "6422",
	"./surah/3_38.png": "21bc",
	"./surah/3_39.png": "0634",
	"./surah/3_4.png": "4a1b",
	"./surah/3_40.png": "190a",
	"./surah/3_41.png": "7ae5",
	"./surah/3_42.png": "4458",
	"./surah/3_43.png": "6c9f",
	"./surah/3_44.png": "5057",
	"./surah/3_45.png": "3bfc",
	"./surah/3_46.png": "1d59",
	"./surah/3_47.png": "5ef7",
	"./surah/3_48.png": "bec7",
	"./surah/3_49.png": "fc6d",
	"./surah/3_5.png": "6d3a",
	"./surah/3_50.png": "b2aa",
	"./surah/3_51.png": "9667",
	"./surah/3_52.png": "469c",
	"./surah/3_53.png": "1b73",
	"./surah/3_54.png": "0490",
	"./surah/3_55.png": "b56a",
	"./surah/3_56.png": "1ba6",
	"./surah/3_57.png": "c7a7",
	"./surah/3_58.png": "ed36",
	"./surah/3_59.png": "70eb",
	"./surah/3_6.png": "90b3f",
	"./surah/3_60.png": "de95",
	"./surah/3_61.png": "5e59",
	"./surah/3_62.png": "ee02",
	"./surah/3_63.png": "1833",
	"./surah/3_64.png": "c083",
	"./surah/3_65.png": "dedb",
	"./surah/3_66.png": "f5a4",
	"./surah/3_67.png": "26508",
	"./surah/3_68.png": "5a92",
	"./surah/3_69.png": "ec84",
	"./surah/3_7.png": "54ae",
	"./surah/3_70.png": "f52b",
	"./surah/3_71.png": "42bd",
	"./surah/3_72.png": "98ab",
	"./surah/3_73.png": "a477",
	"./surah/3_74.png": "c590",
	"./surah/3_75.png": "0120",
	"./surah/3_76.png": "0d10",
	"./surah/3_77.png": "1047",
	"./surah/3_78.png": "b2a1e",
	"./surah/3_79.png": "bb29",
	"./surah/3_8.png": "6eb6",
	"./surah/3_80.png": "806c",
	"./surah/3_81.png": "50574",
	"./surah/3_82.png": "21da",
	"./surah/3_83.png": "bd42",
	"./surah/3_84.png": "ada5",
	"./surah/3_85.png": "95f1",
	"./surah/3_86.png": "92513",
	"./surah/3_87.png": "431c",
	"./surah/3_88.png": "3bfa",
	"./surah/3_89.png": "9936",
	"./surah/3_9.png": "d2ac",
	"./surah/3_90.png": "5b12",
	"./surah/3_91.png": "90a5",
	"./surah/3_92.png": "276f",
	"./surah/3_93.png": "3130",
	"./surah/3_94.png": "6ebd",
	"./surah/3_95.png": "bf60",
	"./surah/3_96.png": "6aca",
	"./surah/3_97.png": "84a5",
	"./surah/3_98.png": "56e7",
	"./surah/3_99.png": "3251",
	"./surah/40_1.png": "52bb",
	"./surah/40_10.png": "bfb2",
	"./surah/40_11.png": "cbd0",
	"./surah/40_12.png": "ad3c",
	"./surah/40_13.png": "08bd",
	"./surah/40_14.png": "11e1",
	"./surah/40_15.png": "25df",
	"./surah/40_16.png": "2352",
	"./surah/40_17.png": "9ae0",
	"./surah/40_18.png": "bbff",
	"./surah/40_19.png": "1329",
	"./surah/40_2.png": "0646",
	"./surah/40_20.png": "c3d3",
	"./surah/40_21.png": "a86e",
	"./surah/40_22.png": "2e61",
	"./surah/40_23.png": "23d3",
	"./surah/40_24.png": "4c68",
	"./surah/40_25.png": "9fdae",
	"./surah/40_26.png": "a925",
	"./surah/40_27.png": "7cb4",
	"./surah/40_28.png": "8539",
	"./surah/40_29.png": "6f6a",
	"./surah/40_3.png": "5611",
	"./surah/40_30.png": "6704",
	"./surah/40_31.png": "07f5",
	"./surah/40_32.png": "9acf",
	"./surah/40_33.png": "be0d",
	"./surah/40_34.png": "2fcf",
	"./surah/40_35.png": "b671bd",
	"./surah/40_36.png": "5eac",
	"./surah/40_37.png": "43d2",
	"./surah/40_38.png": "e2e2",
	"./surah/40_39.png": "0590",
	"./surah/40_4.png": "5a22",
	"./surah/40_40.png": "e1f0",
	"./surah/40_41.png": "4d93",
	"./surah/40_42.png": "7e22",
	"./surah/40_43.png": "29e2",
	"./surah/40_44.png": "3b3c",
	"./surah/40_45.png": "598b",
	"./surah/40_46.png": "a81e",
	"./surah/40_47.png": "f78d",
	"./surah/40_48.png": "0148",
	"./surah/40_49.png": "7775",
	"./surah/40_5.png": "eb22",
	"./surah/40_50.png": "75880",
	"./surah/40_51.png": "4704",
	"./surah/40_52.png": "23f0",
	"./surah/40_53.png": "f24d",
	"./surah/40_54.png": "a23f6",
	"./surah/40_55.png": "d2a9",
	"./surah/40_56.png": "1967",
	"./surah/40_57.png": "6014",
	"./surah/40_58.png": "9493",
	"./surah/40_59.png": "89a2",
	"./surah/40_6.png": "95f5",
	"./surah/40_60.png": "bf60d",
	"./surah/40_61.png": "27a0",
	"./surah/40_62.png": "cd9b",
	"./surah/40_63.png": "1dfe",
	"./surah/40_64.png": "b5e1e",
	"./surah/40_65.png": "fe18",
	"./surah/40_66.png": "b5d1",
	"./surah/40_67.png": "9455",
	"./surah/40_68.png": "d4d6",
	"./surah/40_69.png": "fd50",
	"./surah/40_7.png": "2bc4",
	"./surah/40_70.png": "2c8e",
	"./surah/40_71.png": "0715",
	"./surah/40_72.png": "98a7",
	"./surah/40_73.png": "2c8a",
	"./surah/40_74.png": "861e",
	"./surah/40_75.png": "2a09",
	"./surah/40_76.png": "dc80",
	"./surah/40_77.png": "c570",
	"./surah/40_78.png": "6ad5",
	"./surah/40_79.png": "d826",
	"./surah/40_8.png": "f3ee",
	"./surah/40_80.png": "ab7d",
	"./surah/40_81.png": "ce98",
	"./surah/40_82.png": "1759",
	"./surah/40_83.png": "766d",
	"./surah/40_84.png": "b050",
	"./surah/40_85.png": "b70bd",
	"./surah/40_9.png": "3e3f",
	"./surah/41_1.png": "1360",
	"./surah/41_10.png": "7368",
	"./surah/41_11.png": "2cf1",
	"./surah/41_12.png": "1395",
	"./surah/41_13.png": "dc56",
	"./surah/41_14.png": "1866",
	"./surah/41_15.png": "091f",
	"./surah/41_16.png": "d54e",
	"./surah/41_17.png": "b65f",
	"./surah/41_18.png": "1b40",
	"./surah/41_19.png": "ad98",
	"./surah/41_2.png": "918d",
	"./surah/41_20.png": "8703",
	"./surah/41_21.png": "683c",
	"./surah/41_22.png": "b542",
	"./surah/41_23.png": "18ff",
	"./surah/41_24.png": "7629",
	"./surah/41_25.png": "fef3",
	"./surah/41_26.png": "3060",
	"./surah/41_27.png": "5b32",
	"./surah/41_28.png": "fa8b",
	"./surah/41_29.png": "7e49",
	"./surah/41_3.png": "899a",
	"./surah/41_30.png": "be64",
	"./surah/41_31.png": "9fd1",
	"./surah/41_32.png": "44e1",
	"./surah/41_33.png": "8a94",
	"./surah/41_34.png": "9e5e",
	"./surah/41_35.png": "95c5",
	"./surah/41_36.png": "382c",
	"./surah/41_37.png": "bdb6",
	"./surah/41_38.png": "b353",
	"./surah/41_39.png": "838b",
	"./surah/41_4.png": "035c",
	"./surah/41_40.png": "50dd",
	"./surah/41_41.png": "1fa9",
	"./surah/41_42.png": "880c",
	"./surah/41_43.png": "04751",
	"./surah/41_44.png": "293bf",
	"./surah/41_45.png": "39a5",
	"./surah/41_46.png": "2cdb",
	"./surah/41_47.png": "620d",
	"./surah/41_48.png": "d1b9",
	"./surah/41_49.png": "b0aa",
	"./surah/41_5.png": "4e26",
	"./surah/41_50.png": "3894",
	"./surah/41_51.png": "e723",
	"./surah/41_52.png": "7182",
	"./surah/41_53.png": "eff8",
	"./surah/41_54.png": "bdea",
	"./surah/41_6.png": "cf9c",
	"./surah/41_7.png": "9e2a",
	"./surah/41_8.png": "3dcb",
	"./surah/41_9.png": "18e5",
	"./surah/42_1.png": "dfa8",
	"./surah/42_10.png": "2a15",
	"./surah/42_11.png": "07da",
	"./surah/42_12.png": "ebcf",
	"./surah/42_13.png": "571a",
	"./surah/42_14.png": "f2fe",
	"./surah/42_15.png": "25ea",
	"./surah/42_16.png": "f6cf",
	"./surah/42_17.png": "3ca4",
	"./surah/42_18.png": "042f",
	"./surah/42_19.png": "5e88",
	"./surah/42_2.png": "0453",
	"./surah/42_20.png": "73e6",
	"./surah/42_21.png": "edf2",
	"./surah/42_22.png": "4fd9",
	"./surah/42_23.png": "4c0e",
	"./surah/42_24.png": "d09c",
	"./surah/42_25.png": "b5e5",
	"./surah/42_26.png": "05f2",
	"./surah/42_27.png": "bdd9",
	"./surah/42_28.png": "63e2",
	"./surah/42_29.png": "76b0",
	"./surah/42_3.png": "390b",
	"./surah/42_30.png": "f59e",
	"./surah/42_31.png": "c167",
	"./surah/42_32.png": "a079",
	"./surah/42_33.png": "4793",
	"./surah/42_34.png": "2afe",
	"./surah/42_35.png": "db2a",
	"./surah/42_36.png": "ad83",
	"./surah/42_37.png": "25ac",
	"./surah/42_38.png": "07c6",
	"./surah/42_39.png": "92ce",
	"./surah/42_4.png": "94fe",
	"./surah/42_40.png": "f7e0",
	"./surah/42_41.png": "44e0",
	"./surah/42_42.png": "f5f8",
	"./surah/42_43.png": "48c6",
	"./surah/42_44.png": "ab7db",
	"./surah/42_45.png": "09b3",
	"./surah/42_46.png": "5c63",
	"./surah/42_47.png": "fa67",
	"./surah/42_48.png": "4b07",
	"./surah/42_49.png": "8b5f",
	"./surah/42_5.png": "4057",
	"./surah/42_50.png": "461f",
	"./surah/42_51.png": "32d1",
	"./surah/42_52.png": "cc6e",
	"./surah/42_53.png": "3a78",
	"./surah/42_6.png": "d4c3",
	"./surah/42_7.png": "2fc4",
	"./surah/42_8.png": "3fb8",
	"./surah/42_9.png": "a64a",
	"./surah/43_1.png": "8a1f",
	"./surah/43_10.png": "01fd",
	"./surah/43_11.png": "85a1",
	"./surah/43_12.png": "a474",
	"./surah/43_13.png": "81b2",
	"./surah/43_14.png": "24c5",
	"./surah/43_15.png": "20b1",
	"./surah/43_16.png": "dac7",
	"./surah/43_17.png": "105f",
	"./surah/43_18.png": "ff88",
	"./surah/43_19.png": "6cec",
	"./surah/43_2.png": "53b9",
	"./surah/43_20.png": "8585",
	"./surah/43_21.png": "e152",
	"./surah/43_22.png": "4231",
	"./surah/43_23.png": "fd09",
	"./surah/43_24.png": "9259",
	"./surah/43_25.png": "431d",
	"./surah/43_26.png": "7b23",
	"./surah/43_27.png": "7d1f",
	"./surah/43_28.png": "4781",
	"./surah/43_29.png": "eacd",
	"./surah/43_3.png": "eda4",
	"./surah/43_30.png": "b108",
	"./surah/43_31.png": "c173",
	"./surah/43_32.png": "7fed",
	"./surah/43_33.png": "aa01",
	"./surah/43_34.png": "462a",
	"./surah/43_35.png": "4d8a",
	"./surah/43_36.png": "146d",
	"./surah/43_37.png": "cd90",
	"./surah/43_38.png": "4610",
	"./surah/43_39.png": "70d5",
	"./surah/43_4.png": "9c81",
	"./surah/43_40.png": "4903",
	"./surah/43_41.png": "91fa",
	"./surah/43_42.png": "3b1c",
	"./surah/43_43.png": "ebb4",
	"./surah/43_44.png": "5948",
	"./surah/43_45.png": "d0aac",
	"./surah/43_46.png": "bdcb",
	"./surah/43_47.png": "7c49",
	"./surah/43_48.png": "9ba4",
	"./surah/43_49.png": "0ecc",
	"./surah/43_5.png": "6bf6",
	"./surah/43_50.png": "c3f8",
	"./surah/43_51.png": "4bbd",
	"./surah/43_52.png": "677a",
	"./surah/43_53.png": "bb9b",
	"./surah/43_54.png": "02b5",
	"./surah/43_55.png": "722a",
	"./surah/43_56.png": "5579",
	"./surah/43_57.png": "8696",
	"./surah/43_58.png": "58b8",
	"./surah/43_59.png": "8680",
	"./surah/43_6.png": "90841",
	"./surah/43_60.png": "4487",
	"./surah/43_61.png": "73d3",
	"./surah/43_62.png": "c502",
	"./surah/43_63.png": "63a2",
	"./surah/43_64.png": "312f",
	"./surah/43_65.png": "0c86",
	"./surah/43_66.png": "6669",
	"./surah/43_67.png": "b95b",
	"./surah/43_68.png": "9e9b",
	"./surah/43_69.png": "d936",
	"./surah/43_7.png": "9bed",
	"./surah/43_70.png": "caae",
	"./surah/43_71.png": "1faf",
	"./surah/43_72.png": "52fd",
	"./surah/43_73.png": "c3f9",
	"./surah/43_74.png": "c1e5",
	"./surah/43_75.png": "e694",
	"./surah/43_76.png": "8220",
	"./surah/43_77.png": "6c5e",
	"./surah/43_78.png": "8a8f",
	"./surah/43_79.png": "b954",
	"./surah/43_8.png": "b36a",
	"./surah/43_80.png": "462e3",
	"./surah/43_81.png": "9edc",
	"./surah/43_82.png": "e283",
	"./surah/43_83.png": "a657",
	"./surah/43_84.png": "65a7",
	"./surah/43_85.png": "08d5",
	"./surah/43_86.png": "9593",
	"./surah/43_87.png": "8b3e",
	"./surah/43_88.png": "8170",
	"./surah/43_89.png": "db18",
	"./surah/43_9.png": "5630",
	"./surah/44_1.png": "1418",
	"./surah/44_10.png": "807e",
	"./surah/44_11.png": "ad57",
	"./surah/44_12.png": "9150",
	"./surah/44_13.png": "39e5",
	"./surah/44_14.png": "b767",
	"./surah/44_15.png": "980b",
	"./surah/44_16.png": "61fb",
	"./surah/44_17.png": "a698",
	"./surah/44_18.png": "0164",
	"./surah/44_19.png": "d3c4",
	"./surah/44_2.png": "19f8",
	"./surah/44_20.png": "c42f",
	"./surah/44_21.png": "0b13",
	"./surah/44_22.png": "0dac",
	"./surah/44_23.png": "22c6",
	"./surah/44_24.png": "796d",
	"./surah/44_25.png": "4285",
	"./surah/44_26.png": "7f8a",
	"./surah/44_27.png": "6617",
	"./surah/44_28.png": "c360",
	"./surah/44_29.png": "63fb",
	"./surah/44_3.png": "e4e0",
	"./surah/44_30.png": "61e8",
	"./surah/44_31.png": "e354",
	"./surah/44_32.png": "01c8",
	"./surah/44_33.png": "00d4",
	"./surah/44_34.png": "2d6e",
	"./surah/44_35.png": "e884",
	"./surah/44_36.png": "b6f4",
	"./surah/44_37.png": "953a",
	"./surah/44_38.png": "27728",
	"./surah/44_39.png": "b7a4",
	"./surah/44_4.png": "51fc",
	"./surah/44_40.png": "16dd",
	"./surah/44_41.png": "6251",
	"./surah/44_42.png": "3333",
	"./surah/44_43.png": "2b56",
	"./surah/44_44.png": "67e8",
	"./surah/44_45.png": "deda",
	"./surah/44_46.png": "a427",
	"./surah/44_47.png": "955e",
	"./surah/44_48.png": "0e73",
	"./surah/44_49.png": "a0e0",
	"./surah/44_5.png": "89ab",
	"./surah/44_50.png": "33ba",
	"./surah/44_51.png": "c28a",
	"./surah/44_52.png": "4b74",
	"./surah/44_53.png": "ca49",
	"./surah/44_54.png": "00dd",
	"./surah/44_55.png": "fbb1",
	"./surah/44_56.png": "18fd",
	"./surah/44_57.png": "a037",
	"./surah/44_58.png": "79e4",
	"./surah/44_59.png": "e4392",
	"./surah/44_6.png": "75fd",
	"./surah/44_7.png": "58a9",
	"./surah/44_8.png": "226b",
	"./surah/44_9.png": "5ddd",
	"./surah/45_1.png": "ba71",
	"./surah/45_10.png": "1949",
	"./surah/45_11.png": "b37e",
	"./surah/45_12.png": "2ad8",
	"./surah/45_13.png": "40b3",
	"./surah/45_14.png": "42c5",
	"./surah/45_15.png": "8ddd",
	"./surah/45_16.png": "95e6",
	"./surah/45_17.png": "91c0",
	"./surah/45_18.png": "1c1d",
	"./surah/45_19.png": "a42d",
	"./surah/45_2.png": "32c5",
	"./surah/45_20.png": "7151",
	"./surah/45_21.png": "5087",
	"./surah/45_22.png": "c2f6",
	"./surah/45_23.png": "3021",
	"./surah/45_24.png": "8fd9",
	"./surah/45_25.png": "757f",
	"./surah/45_26.png": "4efc",
	"./surah/45_27.png": "c37d",
	"./surah/45_28.png": "8183",
	"./surah/45_29.png": "174a",
	"./surah/45_3.png": "b5ed5",
	"./surah/45_30.png": "1988",
	"./surah/45_31.png": "c808",
	"./surah/45_32.png": "2a1d",
	"./surah/45_33.png": "7135",
	"./surah/45_34.png": "fe0f",
	"./surah/45_35.png": "5265",
	"./surah/45_36.png": "2418",
	"./surah/45_37.png": "8209",
	"./surah/45_4.png": "8974",
	"./surah/45_5.png": "e8f5",
	"./surah/45_6.png": "9525",
	"./surah/45_7.png": "ad89",
	"./surah/45_8.png": "82a7",
	"./surah/45_9.png": "2494",
	"./surah/46_1.png": "fdde",
	"./surah/46_10.png": "2c9e",
	"./surah/46_11.png": "3fe8",
	"./surah/46_12.png": "01af",
	"./surah/46_13.png": "ac3e",
	"./surah/46_14.png": "bc4c",
	"./surah/46_15.png": "d9a2",
	"./surah/46_16.png": "9300",
	"./surah/46_17.png": "de6c1",
	"./surah/46_18.png": "66ed",
	"./surah/46_19.png": "89e6",
	"./surah/46_2.png": "bbeb",
	"./surah/46_20.png": "5c4d",
	"./surah/46_21.png": "5fde",
	"./surah/46_22.png": "f601",
	"./surah/46_23.png": "8a97",
	"./surah/46_24.png": "e5b9",
	"./surah/46_25.png": "cc99",
	"./surah/46_26.png": "b285",
	"./surah/46_27.png": "a676",
	"./surah/46_28.png": "0464",
	"./surah/46_29.png": "88a5",
	"./surah/46_3.png": "eb97",
	"./surah/46_30.png": "ad79",
	"./surah/46_31.png": "b8db",
	"./surah/46_32.png": "59bb",
	"./surah/46_33.png": "edc7",
	"./surah/46_34.png": "6c2d",
	"./surah/46_35.png": "fa18",
	"./surah/46_4.png": "d221",
	"./surah/46_5.png": "6c4c",
	"./surah/46_6.png": "0dd8",
	"./surah/46_7.png": "dbc5",
	"./surah/46_8.png": "268f",
	"./surah/46_9.png": "68de",
	"./surah/47_1.png": "89ba",
	"./surah/47_10.png": "86f9",
	"./surah/47_11.png": "22d4",
	"./surah/47_12.png": "f5db",
	"./surah/47_13.png": "4ee4",
	"./surah/47_14.png": "a820",
	"./surah/47_15.png": "d44a",
	"./surah/47_16.png": "8cfe",
	"./surah/47_17.png": "b44a",
	"./surah/47_18.png": "bfdb",
	"./surah/47_19.png": "0c7b",
	"./surah/47_2.png": "75fd7",
	"./surah/47_20.png": "8b4b",
	"./surah/47_21.png": "51b1",
	"./surah/47_22.png": "a6ac",
	"./surah/47_23.png": "30c8",
	"./surah/47_24.png": "afd87",
	"./surah/47_25.png": "1ebf3",
	"./surah/47_26.png": "ff15",
	"./surah/47_27.png": "559a",
	"./surah/47_28.png": "5da4",
	"./surah/47_29.png": "14d3",
	"./surah/47_3.png": "c4cb",
	"./surah/47_30.png": "3ce6",
	"./surah/47_31.png": "4db7f",
	"./surah/47_32.png": "38d8",
	"./surah/47_33.png": "1d09",
	"./surah/47_34.png": "3d73",
	"./surah/47_35.png": "33a0",
	"./surah/47_36.png": "8bb2",
	"./surah/47_37.png": "3e8c",
	"./surah/47_38.png": "921a",
	"./surah/47_4.png": "ca5e",
	"./surah/47_5.png": "9d22",
	"./surah/47_6.png": "38637",
	"./surah/47_7.png": "299f",
	"./surah/47_8.png": "1983",
	"./surah/47_9.png": "5807",
	"./surah/48_1.png": "9db9",
	"./surah/48_10.png": "5544",
	"./surah/48_11.png": "e0de",
	"./surah/48_12.png": "c1e3",
	"./surah/48_13.png": "fb53",
	"./surah/48_14.png": "a77f",
	"./surah/48_15.png": "46e7",
	"./surah/48_16.png": "8f1e",
	"./surah/48_17.png": "a9d5",
	"./surah/48_18.png": "7e2c",
	"./surah/48_19.png": "d106",
	"./surah/48_2.png": "bfc2",
	"./surah/48_20.png": "6878",
	"./surah/48_21.png": "6637",
	"./surah/48_22.png": "1dfa",
	"./surah/48_23.png": "b7db",
	"./surah/48_24.png": "dcc9",
	"./surah/48_25.png": "b56c",
	"./surah/48_26.png": "8208",
	"./surah/48_27.png": "8ba6",
	"./surah/48_28.png": "6459",
	"./surah/48_29.png": "7f1d",
	"./surah/48_3.png": "a70b",
	"./surah/48_4.png": "2fc6",
	"./surah/48_5.png": "976c",
	"./surah/48_6.png": "0be6",
	"./surah/48_7.png": "b687",
	"./surah/48_8.png": "3546",
	"./surah/48_9.png": "c97c",
	"./surah/49_1.png": "6f4a",
	"./surah/49_10.png": "6be6",
	"./surah/49_11.png": "1643",
	"./surah/49_12.png": "e526",
	"./surah/49_13.png": "163b",
	"./surah/49_14.png": "06cb",
	"./surah/49_15.png": "02b57",
	"./surah/49_16.png": "33bb0",
	"./surah/49_17.png": "6983",
	"./surah/49_18.png": "2a21",
	"./surah/49_2.png": "8932",
	"./surah/49_3.png": "a298",
	"./surah/49_4.png": "30b1",
	"./surah/49_5.png": "7c56",
	"./surah/49_6.png": "b9a9",
	"./surah/49_7.png": "cfb7",
	"./surah/49_8.png": "b79c",
	"./surah/49_9.png": "997e",
	"./surah/4_1.png": "4b85",
	"./surah/4_10.png": "bc0b",
	"./surah/4_100.png": "bcd4",
	"./surah/4_101.png": "52a3",
	"./surah/4_102.png": "5acb",
	"./surah/4_103.png": "54ab",
	"./surah/4_104.png": "6ebdf",
	"./surah/4_105.png": "0318",
	"./surah/4_106.png": "768e",
	"./surah/4_107.png": "b904",
	"./surah/4_108.png": "68ad",
	"./surah/4_109.png": "0dc6",
	"./surah/4_11.png": "05e0",
	"./surah/4_110.png": "e443",
	"./surah/4_111.png": "a877",
	"./surah/4_112.png": "6c1b",
	"./surah/4_113.png": "91ca",
	"./surah/4_114.png": "30da",
	"./surah/4_115.png": "8d4e",
	"./surah/4_116.png": "6ed0",
	"./surah/4_117.png": "24a1",
	"./surah/4_118.png": "f0ab",
	"./surah/4_119.png": "5024",
	"./surah/4_12.png": "8b00",
	"./surah/4_120.png": "3f5e",
	"./surah/4_121.png": "7d52",
	"./surah/4_122.png": "afd6",
	"./surah/4_123.png": "3eca",
	"./surah/4_124.png": "1f7b",
	"./surah/4_125.png": "3672",
	"./surah/4_126.png": "fff2",
	"./surah/4_127.png": "268d",
	"./surah/4_128.png": "b48a",
	"./surah/4_129.png": "9250",
	"./surah/4_13.png": "67a6",
	"./surah/4_130.png": "5067",
	"./surah/4_131.png": "1b92",
	"./surah/4_132.png": "31a1",
	"./surah/4_133.png": "e56e",
	"./surah/4_134.png": "f5a8",
	"./surah/4_135.png": "5114",
	"./surah/4_136.png": "2c8b",
	"./surah/4_137.png": "2e6c",
	"./surah/4_138.png": "e892",
	"./surah/4_139.png": "eba9",
	"./surah/4_14.png": "b154",
	"./surah/4_140.png": "ed6c",
	"./surah/4_141.png": "8aa0",
	"./surah/4_142.png": "24c7",
	"./surah/4_143.png": "e447",
	"./surah/4_144.png": "5f6a",
	"./surah/4_145.png": "f2ec",
	"./surah/4_146.png": "a733",
	"./surah/4_147.png": "5ada",
	"./surah/4_148.png": "2c56",
	"./surah/4_149.png": "a40b",
	"./surah/4_15.png": "7339",
	"./surah/4_150.png": "7078",
	"./surah/4_151.png": "fb6ab",
	"./surah/4_152.png": "d748",
	"./surah/4_153.png": "ce1cf",
	"./surah/4_154.png": "eac6",
	"./surah/4_155.png": "3dd8",
	"./surah/4_156.png": "d96e",
	"./surah/4_157.png": "fef4",
	"./surah/4_158.png": "7354",
	"./surah/4_159.png": "dc9c",
	"./surah/4_16.png": "65f6",
	"./surah/4_160.png": "96677",
	"./surah/4_161.png": "007f",
	"./surah/4_162.png": "1e4e",
	"./surah/4_163.png": "360b",
	"./surah/4_164.png": "b9df",
	"./surah/4_165.png": "f55c",
	"./surah/4_166.png": "3413",
	"./surah/4_167.png": "8d1a",
	"./surah/4_168.png": "e245",
	"./surah/4_169.png": "ed30",
	"./surah/4_17.png": "d205",
	"./surah/4_170.png": "9f7d",
	"./surah/4_171.png": "a139",
	"./surah/4_172.png": "d4fa",
	"./surah/4_173.png": "81df",
	"./surah/4_174.png": "ca20",
	"./surah/4_175.png": "9dfc",
	"./surah/4_176.png": "540f",
	"./surah/4_18.png": "c886",
	"./surah/4_19.png": "4b32",
	"./surah/4_2.png": "8781",
	"./surah/4_20.png": "3508",
	"./surah/4_21.png": "a90c",
	"./surah/4_22.png": "4e5f07",
	"./surah/4_23.png": "b5f7",
	"./surah/4_24.png": "ab09",
	"./surah/4_25.png": "dfbf",
	"./surah/4_26.png": "c099",
	"./surah/4_27.png": "9d22a",
	"./surah/4_28.png": "6138",
	"./surah/4_29.png": "6313",
	"./surah/4_3.png": "c9ae",
	"./surah/4_30.png": "3acc",
	"./surah/4_31.png": "df0e",
	"./surah/4_32.png": "1db8d",
	"./surah/4_33.png": "a868",
	"./surah/4_34.png": "f92c",
	"./surah/4_35.png": "9f6f",
	"./surah/4_36.png": "d233",
	"./surah/4_37.png": "3f6e",
	"./surah/4_38.png": "efab",
	"./surah/4_39.png": "9ba49",
	"./surah/4_4.png": "5573",
	"./surah/4_40.png": "8f6f7",
	"./surah/4_41.png": "01a0b",
	"./surah/4_42.png": "d2ce",
	"./surah/4_43.png": "d533b",
	"./surah/4_44.png": "18ae",
	"./surah/4_45.png": "c48d",
	"./surah/4_46.png": "d167",
	"./surah/4_47.png": "48e5",
	"./surah/4_48.png": "c174",
	"./surah/4_49.png": "c727",
	"./surah/4_5.png": "027e",
	"./surah/4_50.png": "9666",
	"./surah/4_51.png": "872c",
	"./surah/4_52.png": "3974",
	"./surah/4_53.png": "5de8",
	"./surah/4_54.png": "9990",
	"./surah/4_55.png": "1131",
	"./surah/4_56.png": "0e58",
	"./surah/4_57.png": "0f1d",
	"./surah/4_58.png": "f1f1",
	"./surah/4_59.png": "b380",
	"./surah/4_6.png": "a49c",
	"./surah/4_60.png": "1fdb",
	"./surah/4_61.png": "585b",
	"./surah/4_62.png": "6527",
	"./surah/4_63.png": "8ec4",
	"./surah/4_64.png": "460cc",
	"./surah/4_65.png": "54bc",
	"./surah/4_66.png": "b7c5",
	"./surah/4_67.png": "1056",
	"./surah/4_68.png": "ab87",
	"./surah/4_69.png": "59c5",
	"./surah/4_7.png": "7f40",
	"./surah/4_70.png": "94d3",
	"./surah/4_71.png": "4943",
	"./surah/4_72.png": "5fec",
	"./surah/4_73.png": "c2f3",
	"./surah/4_74.png": "d060",
	"./surah/4_75.png": "b091",
	"./surah/4_76.png": "a446",
	"./surah/4_77.png": "cd19",
	"./surah/4_78.png": "a24c",
	"./surah/4_79.png": "0b25",
	"./surah/4_8.png": "0a45",
	"./surah/4_80.png": "3cc4",
	"./surah/4_81.png": "2205",
	"./surah/4_82.png": "67ca",
	"./surah/4_83.png": "774c3",
	"./surah/4_84.png": "eec1",
	"./surah/4_85.png": "5f6d",
	"./surah/4_86.png": "64b8",
	"./surah/4_87.png": "4252",
	"./surah/4_88.png": "69ae",
	"./surah/4_89.png": "7a9b",
	"./surah/4_9.png": "e268",
	"./surah/4_90.png": "4770",
	"./surah/4_91.png": "0d416",
	"./surah/4_92.png": "cf9a",
	"./surah/4_93.png": "331a",
	"./surah/4_94.png": "33d4",
	"./surah/4_95.png": "ef19",
	"./surah/4_96.png": "bacd",
	"./surah/4_97.png": "50dc",
	"./surah/4_98.png": "5ea5",
	"./surah/4_99.png": "4783",
	"./surah/50_1.png": "eeee",
	"./surah/50_10.png": "f987d",
	"./surah/50_11.png": "7de8",
	"./surah/50_12.png": "4ca12",
	"./surah/50_13.png": "2b22",
	"./surah/50_14.png": "7743",
	"./surah/50_15.png": "f431",
	"./surah/50_16.png": "9d5a",
	"./surah/50_17.png": "1abe",
	"./surah/50_18.png": "4ce3",
	"./surah/50_19.png": "d025",
	"./surah/50_2.png": "d45d",
	"./surah/50_20.png": "4ab4",
	"./surah/50_21.png": "ea49",
	"./surah/50_22.png": "9fc9",
	"./surah/50_23.png": "1f79",
	"./surah/50_24.png": "a2c5",
	"./surah/50_25.png": "5cdc",
	"./surah/50_26.png": "b11e",
	"./surah/50_27.png": "05b6",
	"./surah/50_28.png": "2cd7",
	"./surah/50_29.png": "b12a",
	"./surah/50_3.png": "19d5",
	"./surah/50_30.png": "1274",
	"./surah/50_31.png": "a6ea",
	"./surah/50_32.png": "520a",
	"./surah/50_33.png": "137a",
	"./surah/50_34.png": "3821",
	"./surah/50_35.png": "b711",
	"./surah/50_36.png": "9abf",
	"./surah/50_37.png": "0e738",
	"./surah/50_38.png": "9fd0",
	"./surah/50_39.png": "77e9",
	"./surah/50_4.png": "b1d2",
	"./surah/50_40.png": "f02c",
	"./surah/50_41.png": "f626",
	"./surah/50_42.png": "5457",
	"./surah/50_43.png": "e37d",
	"./surah/50_44.png": "9f1c",
	"./surah/50_45.png": "dabc",
	"./surah/50_5.png": "593e",
	"./surah/50_6.png": "f637",
	"./surah/50_7.png": "e2f3",
	"./surah/50_8.png": "6609",
	"./surah/50_9.png": "922d",
	"./surah/51_1.png": "9d92",
	"./surah/51_10.png": "260d",
	"./surah/51_11.png": "6485",
	"./surah/51_12.png": "805b",
	"./surah/51_13.png": "765f",
	"./surah/51_14.png": "8bc4",
	"./surah/51_15.png": "69b9",
	"./surah/51_16.png": "3273",
	"./surah/51_17.png": "7e68",
	"./surah/51_18.png": "7c88",
	"./surah/51_19.png": "58c3",
	"./surah/51_2.png": "2bd8",
	"./surah/51_20.png": "fcd2",
	"./surah/51_21.png": "a1e6",
	"./surah/51_22.png": "7447",
	"./surah/51_23.png": "c874",
	"./surah/51_24.png": "9893",
	"./surah/51_25.png": "7561",
	"./surah/51_26.png": "48ea",
	"./surah/51_27.png": "79f5",
	"./surah/51_28.png": "8396",
	"./surah/51_29.png": "f114",
	"./surah/51_3.png": "e386",
	"./surah/51_30.png": "7948",
	"./surah/51_31.png": "28b5",
	"./surah/51_32.png": "f624",
	"./surah/51_33.png": "d06e",
	"./surah/51_34.png": "fbc4",
	"./surah/51_35.png": "ce14",
	"./surah/51_36.png": "40da",
	"./surah/51_37.png": "b2c1",
	"./surah/51_38.png": "84b6e",
	"./surah/51_39.png": "7cb7",
	"./surah/51_4.png": "42e3",
	"./surah/51_40.png": "600f",
	"./surah/51_41.png": "c80f",
	"./surah/51_42.png": "ce33",
	"./surah/51_43.png": "bedf",
	"./surah/51_44.png": "5476",
	"./surah/51_45.png": "6f91",
	"./surah/51_46.png": "c9d1",
	"./surah/51_47.png": "2e62",
	"./surah/51_48.png": "84bb",
	"./surah/51_49.png": "5168",
	"./surah/51_5.png": "d9ba",
	"./surah/51_50.png": "2de0",
	"./surah/51_51.png": "f9a0",
	"./surah/51_52.png": "e125",
	"./surah/51_53.png": "66c6",
	"./surah/51_54.png": "0599",
	"./surah/51_55.png": "e6bb",
	"./surah/51_56.png": "f057",
	"./surah/51_57.png": "a944",
	"./surah/51_58.png": "873c",
	"./surah/51_59.png": "4156",
	"./surah/51_6.png": "3169",
	"./surah/51_60.png": "c2c0",
	"./surah/51_7.png": "97f59",
	"./surah/51_8.png": "f2cb",
	"./surah/51_9.png": "f86b",
	"./surah/52_1.png": "7cdb",
	"./surah/52_10.png": "04f1",
	"./surah/52_11.png": "9907",
	"./surah/52_12.png": "30c5",
	"./surah/52_13.png": "1ec1",
	"./surah/52_14.png": "702f",
	"./surah/52_15.png": "accf",
	"./surah/52_16.png": "2fd6",
	"./surah/52_17.png": "3fe4",
	"./surah/52_18.png": "aebc",
	"./surah/52_19.png": "614f",
	"./surah/52_2.png": "dd94",
	"./surah/52_20.png": "929f",
	"./surah/52_21.png": "8f91",
	"./surah/52_22.png": "46f9",
	"./surah/52_23.png": "7b40",
	"./surah/52_24.png": "f6f7",
	"./surah/52_25.png": "0496",
	"./surah/52_26.png": "616b",
	"./surah/52_27.png": "658bb",
	"./surah/52_28.png": "2928",
	"./surah/52_29.png": "c35e",
	"./surah/52_3.png": "d56ed",
	"./surah/52_30.png": "f683",
	"./surah/52_31.png": "fe87",
	"./surah/52_32.png": "35ed",
	"./surah/52_33.png": "365f",
	"./surah/52_34.png": "ec350",
	"./surah/52_35.png": "a98b",
	"./surah/52_36.png": "3d39",
	"./surah/52_37.png": "5c1a",
	"./surah/52_38.png": "c113",
	"./surah/52_39.png": "af58",
	"./surah/52_4.png": "12f6",
	"./surah/52_40.png": "7e59",
	"./surah/52_41.png": "a97b",
	"./surah/52_42.png": "45fd",
	"./surah/52_43.png": "4de7",
	"./surah/52_44.png": "c6e9",
	"./surah/52_45.png": "8e54",
	"./surah/52_46.png": "a285",
	"./surah/52_47.png": "b4da",
	"./surah/52_48.png": "bc19",
	"./surah/52_49.png": "b4ee",
	"./surah/52_5.png": "cacc",
	"./surah/52_6.png": "bc64",
	"./surah/52_7.png": "541f",
	"./surah/52_8.png": "d2ea",
	"./surah/52_9.png": "a971",
	"./surah/53_1.png": "2a207",
	"./surah/53_10.png": "e943",
	"./surah/53_11.png": "5454",
	"./surah/53_12.png": "fd69",
	"./surah/53_13.png": "1dab1",
	"./surah/53_14.png": "0388",
	"./surah/53_15.png": "2418c",
	"./surah/53_16.png": "7f93",
	"./surah/53_17.png": "ec33",
	"./surah/53_18.png": "274e",
	"./surah/53_19.png": "8422",
	"./surah/53_2.png": "4b50",
	"./surah/53_20.png": "7ffe",
	"./surah/53_21.png": "f844f",
	"./surah/53_22.png": "a44e",
	"./surah/53_23.png": "1774",
	"./surah/53_24.png": "bea5",
	"./surah/53_25.png": "4a6f",
	"./surah/53_26.png": "765d",
	"./surah/53_27.png": "8286",
	"./surah/53_28.png": "5492",
	"./surah/53_29.png": "ad48",
	"./surah/53_3.png": "47f6",
	"./surah/53_30.png": "0dde",
	"./surah/53_31.png": "ac90",
	"./surah/53_32.png": "8900",
	"./surah/53_33.png": "61b7",
	"./surah/53_34.png": "1644",
	"./surah/53_35.png": "bb55",
	"./surah/53_36.png": "5240",
	"./surah/53_37.png": "555e",
	"./surah/53_38.png": "03e1",
	"./surah/53_39.png": "ae5d",
	"./surah/53_4.png": "a227",
	"./surah/53_40.png": "364d",
	"./surah/53_41.png": "5f3c",
	"./surah/53_42.png": "ed62",
	"./surah/53_43.png": "b05b",
	"./surah/53_44.png": "481a",
	"./surah/53_45.png": "4c2b",
	"./surah/53_46.png": "6657",
	"./surah/53_47.png": "187f",
	"./surah/53_48.png": "61e9",
	"./surah/53_49.png": "3a90",
	"./surah/53_5.png": "17747",
	"./surah/53_50.png": "0c85",
	"./surah/53_51.png": "1d6f",
	"./surah/53_52.png": "4e0c",
	"./surah/53_53.png": "45ef",
	"./surah/53_54.png": "cffd",
	"./surah/53_55.png": "70bd",
	"./surah/53_56.png": "705d",
	"./surah/53_57.png": "3f4c",
	"./surah/53_58.png": "c0bf",
	"./surah/53_59.png": "de52",
	"./surah/53_6.png": "a66ee",
	"./surah/53_60.png": "b9ef",
	"./surah/53_61.png": "f1d2",
	"./surah/53_62.png": "26f4",
	"./surah/53_7.png": "02cf",
	"./surah/53_8.png": "3b6e",
	"./surah/53_9.png": "ea13",
	"./surah/54_1.png": "cc87",
	"./surah/54_10.png": "cdeb",
	"./surah/54_11.png": "599f",
	"./surah/54_12.png": "1cfc4",
	"./surah/54_13.png": "ac77",
	"./surah/54_14.png": "1d4e",
	"./surah/54_15.png": "6c0c",
	"./surah/54_16.png": "cfdf",
	"./surah/54_17.png": "8cea",
	"./surah/54_18.png": "3380",
	"./surah/54_19.png": "01ad",
	"./surah/54_2.png": "a55a",
	"./surah/54_20.png": "3642",
	"./surah/54_21.png": "1f88",
	"./surah/54_22.png": "296f",
	"./surah/54_23.png": "e456",
	"./surah/54_24.png": "1b05",
	"./surah/54_25.png": "6aa7",
	"./surah/54_26.png": "2330",
	"./surah/54_27.png": "9c04",
	"./surah/54_28.png": "3e2a",
	"./surah/54_29.png": "f7cc",
	"./surah/54_3.png": "a4f9",
	"./surah/54_30.png": "a399",
	"./surah/54_31.png": "2053",
	"./surah/54_32.png": "e39c",
	"./surah/54_33.png": "c4d3",
	"./surah/54_34.png": "ca0f",
	"./surah/54_35.png": "b1c74",
	"./surah/54_36.png": "301b",
	"./surah/54_37.png": "49f3",
	"./surah/54_38.png": "1450",
	"./surah/54_39.png": "594d",
	"./surah/54_4.png": "cad5",
	"./surah/54_40.png": "a6f4",
	"./surah/54_41.png": "8f2f0",
	"./surah/54_42.png": "172b",
	"./surah/54_43.png": "77ed",
	"./surah/54_44.png": "59ee",
	"./surah/54_45.png": "e60b",
	"./surah/54_46.png": "56cf",
	"./surah/54_47.png": "c499",
	"./surah/54_48.png": "9741",
	"./surah/54_49.png": "87ab",
	"./surah/54_5.png": "ca93",
	"./surah/54_50.png": "81f3",
	"./surah/54_51.png": "0e64",
	"./surah/54_52.png": "5c42",
	"./surah/54_53.png": "c359",
	"./surah/54_54.png": "69ca",
	"./surah/54_55.png": "1dd3",
	"./surah/54_6.png": "e97b",
	"./surah/54_7.png": "3ee9",
	"./surah/54_8.png": "d4c2",
	"./surah/54_9.png": "94f5",
	"./surah/55_1.png": "e698",
	"./surah/55_10.png": "c14fc",
	"./surah/55_11.png": "d273",
	"./surah/55_12.png": "7921",
	"./surah/55_13.png": "0e95d",
	"./surah/55_14.png": "e492",
	"./surah/55_15.png": "cfa7",
	"./surah/55_16.png": "8327",
	"./surah/55_17.png": "feb98",
	"./surah/55_18.png": "69ee",
	"./surah/55_19.png": "157d",
	"./surah/55_2.png": "08b6",
	"./surah/55_20.png": "9f74",
	"./surah/55_21.png": "f54a",
	"./surah/55_22.png": "087d",
	"./surah/55_23.png": "f376",
	"./surah/55_24.png": "261d",
	"./surah/55_25.png": "d29e",
	"./surah/55_26.png": "6a32",
	"./surah/55_27.png": "b128",
	"./surah/55_28.png": "e623",
	"./surah/55_29.png": "267b",
	"./surah/55_3.png": "f773",
	"./surah/55_30.png": "3247",
	"./surah/55_31.png": "b6c9",
	"./surah/55_32.png": "b818",
	"./surah/55_33.png": "c695",
	"./surah/55_34.png": "fff9",
	"./surah/55_35.png": "108d",
	"./surah/55_36.png": "4d3a",
	"./surah/55_37.png": "234da",
	"./surah/55_38.png": "b2851",
	"./surah/55_39.png": "9451",
	"./surah/55_4.png": "5279",
	"./surah/55_40.png": "7533",
	"./surah/55_41.png": "807c",
	"./surah/55_42.png": "fe39",
	"./surah/55_43.png": "4dcc",
	"./surah/55_44.png": "26fe",
	"./surah/55_45.png": "231f",
	"./surah/55_46.png": "fa27",
	"./surah/55_47.png": "29b6",
	"./surah/55_48.png": "9cf5",
	"./surah/55_49.png": "c8360",
	"./surah/55_5.png": "8c8f",
	"./surah/55_50.png": "aad8",
	"./surah/55_51.png": "415d",
	"./surah/55_52.png": "0fd0",
	"./surah/55_53.png": "c456",
	"./surah/55_54.png": "d698",
	"./surah/55_55.png": "17f6",
	"./surah/55_56.png": "4241",
	"./surah/55_57.png": "9f4c",
	"./surah/55_58.png": "d0ca",
	"./surah/55_59.png": "ebad",
	"./surah/55_6.png": "8f6b",
	"./surah/55_60.png": "dcd7",
	"./surah/55_61.png": "f19e",
	"./surah/55_62.png": "b112",
	"./surah/55_63.png": "c64a4",
	"./surah/55_64.png": "ed6d",
	"./surah/55_65.png": "55e4",
	"./surah/55_66.png": "c0c7",
	"./surah/55_67.png": "a684",
	"./surah/55_68.png": "b9c3",
	"./surah/55_69.png": "338b",
	"./surah/55_7.png": "7796",
	"./surah/55_70.png": "a9bb",
	"./surah/55_71.png": "99744",
	"./surah/55_72.png": "2d51",
	"./surah/55_73.png": "6ffa",
	"./surah/55_74.png": "d4e4",
	"./surah/55_75.png": "42bf",
	"./surah/55_76.png": "1b9e",
	"./surah/55_77.png": "a414",
	"./surah/55_78.png": "29ab",
	"./surah/55_8.png": "7c22",
	"./surah/55_9.png": "bba0",
	"./surah/56_1.png": "a66b",
	"./surah/56_10.png": "49d5",
	"./surah/56_11.png": "221b",
	"./surah/56_12.png": "f654",
	"./surah/56_13.png": "e58f6",
	"./surah/56_14.png": "59e7",
	"./surah/56_15.png": "38c9",
	"./surah/56_16.png": "ae2b",
	"./surah/56_17.png": "0bd1",
	"./surah/56_18.png": "f0d1",
	"./surah/56_19.png": "0d19",
	"./surah/56_2.png": "ce85",
	"./surah/56_20.png": "2fb8",
	"./surah/56_21.png": "4bf7",
	"./surah/56_22.png": "fa275",
	"./surah/56_23.png": "84ed",
	"./surah/56_24.png": "0757",
	"./surah/56_25.png": "7d9f",
	"./surah/56_26.png": "d220",
	"./surah/56_27.png": "2374",
	"./surah/56_28.png": "4c8a",
	"./surah/56_29.png": "0f19",
	"./surah/56_3.png": "0df1",
	"./surah/56_30.png": "e160",
	"./surah/56_31.png": "a2b8",
	"./surah/56_32.png": "8b93",
	"./surah/56_33.png": "532d",
	"./surah/56_34.png": "c4c5",
	"./surah/56_35.png": "4eed",
	"./surah/56_36.png": "d6b0",
	"./surah/56_37.png": "fdded",
	"./surah/56_38.png": "9dab",
	"./surah/56_39.png": "ca7f",
	"./surah/56_4.png": "2b67",
	"./surah/56_40.png": "d03b",
	"./surah/56_41.png": "e47d",
	"./surah/56_42.png": "1670",
	"./surah/56_43.png": "f7682",
	"./surah/56_44.png": "48ad",
	"./surah/56_45.png": "c3e0",
	"./surah/56_46.png": "551a",
	"./surah/56_47.png": "59fe",
	"./surah/56_48.png": "64ad",
	"./surah/56_49.png": "8659f",
	"./surah/56_5.png": "b362",
	"./surah/56_50.png": "9ea8",
	"./surah/56_51.png": "7b80",
	"./surah/56_52.png": "d5f3",
	"./surah/56_53.png": "ad0f",
	"./surah/56_54.png": "921c6",
	"./surah/56_55.png": "2806",
	"./surah/56_56.png": "7b00",
	"./surah/56_57.png": "d880",
	"./surah/56_58.png": "18ebd",
	"./surah/56_59.png": "c783",
	"./surah/56_6.png": "9988",
	"./surah/56_60.png": "4635",
	"./surah/56_61.png": "d4d7",
	"./surah/56_62.png": "2a47",
	"./surah/56_63.png": "11bb",
	"./surah/56_64.png": "5dbf",
	"./surah/56_65.png": "2721",
	"./surah/56_66.png": "b5eab",
	"./surah/56_67.png": "026f",
	"./surah/56_68.png": "994d",
	"./surah/56_69.png": "84bd",
	"./surah/56_7.png": "530c",
	"./surah/56_70.png": "77a9",
	"./surah/56_71.png": "66f5",
	"./surah/56_72.png": "9446",
	"./surah/56_73.png": "050c",
	"./surah/56_74.png": "3829",
	"./surah/56_75.png": "f979",
	"./surah/56_76.png": "2296",
	"./surah/56_77.png": "fa4a",
	"./surah/56_78.png": "071a",
	"./surah/56_79.png": "7a6b",
	"./surah/56_8.png": "7e56",
	"./surah/56_80.png": "d70c",
	"./surah/56_81.png": "2bbd",
	"./surah/56_82.png": "b145",
	"./surah/56_83.png": "7f08",
	"./surah/56_84.png": "e818",
	"./surah/56_85.png": "331ad",
	"./surah/56_86.png": "e2ea",
	"./surah/56_87.png": "293c3",
	"./surah/56_88.png": "9a9b",
	"./surah/56_89.png": "62ce",
	"./surah/56_9.png": "4579",
	"./surah/56_90.png": "ae39",
	"./surah/56_91.png": "5f2c",
	"./surah/56_92.png": "c3cf",
	"./surah/56_93.png": "7b92",
	"./surah/56_94.png": "5780",
	"./surah/56_95.png": "aed2",
	"./surah/56_96.png": "d67e",
	"./surah/57_1.png": "b32e",
	"./surah/57_10.png": "c69d",
	"./surah/57_11.png": "11a6",
	"./surah/57_12.png": "73f4",
	"./surah/57_13.png": "ab79",
	"./surah/57_14.png": "a182",
	"./surah/57_15.png": "efc0",
	"./surah/57_16.png": "06a3",
	"./surah/57_17.png": "0718",
	"./surah/57_18.png": "78b7",
	"./surah/57_19.png": "a587",
	"./surah/57_2.png": "67a7",
	"./surah/57_20.png": "063e8",
	"./surah/57_21.png": "0734",
	"./surah/57_22.png": "d6027",
	"./surah/57_23.png": "e903",
	"./surah/57_24.png": "2512",
	"./surah/57_25.png": "1549",
	"./surah/57_26.png": "a4ba",
	"./surah/57_27.png": "85d5",
	"./surah/57_28.png": "d197",
	"./surah/57_29.png": "92c1",
	"./surah/57_3.png": "b7c7",
	"./surah/57_4.png": "ac06",
	"./surah/57_5.png": "488f",
	"./surah/57_6.png": "532a",
	"./surah/57_7.png": "d3b6a",
	"./surah/57_8.png": "732c",
	"./surah/57_9.png": "e07f",
	"./surah/58_1.png": "98d4",
	"./surah/58_10.png": "c965",
	"./surah/58_11.png": "d8c2",
	"./surah/58_12.png": "e3bf",
	"./surah/58_13.png": "76e4",
	"./surah/58_14.png": "e577",
	"./surah/58_15.png": "312e",
	"./surah/58_16.png": "4da3",
	"./surah/58_17.png": "00ae",
	"./surah/58_18.png": "04945",
	"./surah/58_19.png": "9d36",
	"./surah/58_2.png": "ecb9",
	"./surah/58_20.png": "3d94",
	"./surah/58_21.png": "6b6a",
	"./surah/58_22.png": "37dba",
	"./surah/58_3.png": "68cc",
	"./surah/58_4.png": "834a",
	"./surah/58_5.png": "3bfac",
	"./surah/58_6.png": "43db",
	"./surah/58_7.png": "b47e",
	"./surah/58_8.png": "1b48",
	"./surah/58_9.png": "a915",
	"./surah/59_1.png": "fa92",
	"./surah/59_10.png": "125b",
	"./surah/59_11.png": "d852",
	"./surah/59_12.png": "cefb",
	"./surah/59_13.png": "b7f7",
	"./surah/59_14.png": "9e36",
	"./surah/59_15.png": "a39c",
	"./surah/59_16.png": "3a32",
	"./surah/59_17.png": "db7d",
	"./surah/59_18.png": "5f24",
	"./surah/59_19.png": "1439",
	"./surah/59_2.png": "36f7",
	"./surah/59_20.png": "8182",
	"./surah/59_21.png": "53a0",
	"./surah/59_22.png": "2f18",
	"./surah/59_23.png": "f7d8",
	"./surah/59_24.png": "12e0",
	"./surah/59_3.png": "2f25",
	"./surah/59_4.png": "59b4",
	"./surah/59_5.png": "edbd",
	"./surah/59_6.png": "3a9d",
	"./surah/59_7.png": "0d49",
	"./surah/59_8.png": "8c4d",
	"./surah/59_9.png": "166b",
	"./surah/5_1.png": "2450",
	"./surah/5_10.png": "39bd",
	"./surah/5_100.png": "978a",
	"./surah/5_101.png": "2a9d",
	"./surah/5_102.png": "20a0",
	"./surah/5_103.png": "b1e3",
	"./surah/5_104.png": "e08a",
	"./surah/5_105.png": "b32f",
	"./surah/5_106.png": "f486",
	"./surah/5_107.png": "6c2e",
	"./surah/5_108.png": "2beb",
	"./surah/5_109.png": "7c61",
	"./surah/5_11.png": "8efd",
	"./surah/5_110.png": "0027",
	"./surah/5_111.png": "2fe6",
	"./surah/5_112.png": "ab56",
	"./surah/5_113.png": "4166",
	"./surah/5_114.png": "9433",
	"./surah/5_115.png": "c7ac",
	"./surah/5_116.png": "a64c",
	"./surah/5_117.png": "ddf6",
	"./surah/5_118.png": "dc9b",
	"./surah/5_119.png": "968c",
	"./surah/5_12.png": "c895",
	"./surah/5_120.png": "ebeb",
	"./surah/5_13.png": "6624",
	"./surah/5_14.png": "a280",
	"./surah/5_15.png": "2f05",
	"./surah/5_16.png": "ead8",
	"./surah/5_17.png": "8197",
	"./surah/5_18.png": "ccf8",
	"./surah/5_19.png": "1a69",
	"./surah/5_2.png": "f6c0",
	"./surah/5_20.png": "5782",
	"./surah/5_21.png": "9cb7",
	"./surah/5_22.png": "77d6",
	"./surah/5_23.png": "8960",
	"./surah/5_24.png": "e2af",
	"./surah/5_25.png": "589c",
	"./surah/5_26.png": "e2ef",
	"./surah/5_27.png": "cfa0",
	"./surah/5_28.png": "ad35",
	"./surah/5_29.png": "bc66",
	"./surah/5_3.png": "2a27",
	"./surah/5_30.png": "d0e0a",
	"./surah/5_31.png": "24ca",
	"./surah/5_32.png": "6aa7f",
	"./surah/5_33.png": "ad10",
	"./surah/5_34.png": "dcf4",
	"./surah/5_35.png": "40d1",
	"./surah/5_36.png": "650c",
	"./surah/5_37.png": "271a",
	"./surah/5_38.png": "2c1d",
	"./surah/5_39.png": "68bf",
	"./surah/5_4.png": "15c5",
	"./surah/5_40.png": "ccd2",
	"./surah/5_41.png": "2519",
	"./surah/5_42.png": "9b5d",
	"./surah/5_43.png": "7b58",
	"./surah/5_44.png": "8aa09",
	"./surah/5_45.png": "b343",
	"./surah/5_46.png": "f041",
	"./surah/5_47.png": "9ab8",
	"./surah/5_48.png": "202a",
	"./surah/5_49.png": "e102",
	"./surah/5_5.png": "cf29",
	"./surah/5_50.png": "319b",
	"./surah/5_51.png": "6537",
	"./surah/5_52.png": "b704",
	"./surah/5_53.png": "33d1d",
	"./surah/5_54.png": "6c11",
	"./surah/5_55.png": "cb09",
	"./surah/5_56.png": "918f",
	"./surah/5_57.png": "2a10",
	"./surah/5_58.png": "be36",
	"./surah/5_59.png": "fd3e",
	"./surah/5_6.png": "ab17",
	"./surah/5_60.png": "62de",
	"./surah/5_61.png": "b623",
	"./surah/5_62.png": "d8e8",
	"./surah/5_63.png": "7739",
	"./surah/5_64.png": "a10e",
	"./surah/5_65.png": "4db2",
	"./surah/5_66.png": "0835",
	"./surah/5_67.png": "3bc9",
	"./surah/5_68.png": "1063",
	"./surah/5_69.png": "556f",
	"./surah/5_7.png": "550f",
	"./surah/5_70.png": "ee23c",
	"./surah/5_71.png": "7a78",
	"./surah/5_72.png": "7248",
	"./surah/5_73.png": "3a86",
	"./surah/5_74.png": "26b9",
	"./surah/5_75.png": "6468",
	"./surah/5_76.png": "8116",
	"./surah/5_77.png": "bff2",
	"./surah/5_78.png": "05ac",
	"./surah/5_79.png": "96f2",
	"./surah/5_8.png": "c796",
	"./surah/5_80.png": "4ebf1",
	"./surah/5_81.png": "aacb",
	"./surah/5_82.png": "67c6",
	"./surah/5_83.png": "3f2e",
	"./surah/5_84.png": "5af37",
	"./surah/5_85.png": "2700",
	"./surah/5_86.png": "4508",
	"./surah/5_87.png": "285b",
	"./surah/5_88.png": "1383",
	"./surah/5_89.png": "9ef9",
	"./surah/5_9.png": "13ee",
	"./surah/5_90.png": "6be1",
	"./surah/5_91.png": "c405",
	"./surah/5_92.png": "c722",
	"./surah/5_93.png": "8471",
	"./surah/5_94.png": "c39a",
	"./surah/5_95.png": "a196",
	"./surah/5_96.png": "d461",
	"./surah/5_97.png": "2b82",
	"./surah/5_98.png": "a27b",
	"./surah/5_99.png": "a13e",
	"./surah/60_1.png": "239f",
	"./surah/60_10.png": "fe02",
	"./surah/60_11.png": "b6c8",
	"./surah/60_12.png": "64a9",
	"./surah/60_13.png": "8b03",
	"./surah/60_2.png": "c694",
	"./surah/60_3.png": "e655",
	"./surah/60_4.png": "6227",
	"./surah/60_5.png": "5869",
	"./surah/60_6.png": "1c6e",
	"./surah/60_7.png": "8714",
	"./surah/60_8.png": "5e7fc",
	"./surah/60_9.png": "8f2a",
	"./surah/61_1.png": "c368",
	"./surah/61_10.png": "9e8e",
	"./surah/61_11.png": "9a06",
	"./surah/61_12.png": "07b4",
	"./surah/61_13.png": "17d26",
	"./surah/61_14.png": "0882",
	"./surah/61_2.png": "969c",
	"./surah/61_3.png": "7ee3",
	"./surah/61_4.png": "b1a5",
	"./surah/61_5.png": "391b",
	"./surah/61_6.png": "0f2a0",
	"./surah/61_7.png": "142e",
	"./surah/61_8.png": "5de7",
	"./surah/61_9.png": "8e77",
	"./surah/62_1.png": "e564",
	"./surah/62_10.png": "b141",
	"./surah/62_11.png": "a64f",
	"./surah/62_2.png": "3e33",
	"./surah/62_3.png": "2742",
	"./surah/62_4.png": "52ae",
	"./surah/62_5.png": "c3fa",
	"./surah/62_6.png": "8e92",
	"./surah/62_7.png": "022c",
	"./surah/62_8.png": "7a0d",
	"./surah/62_9.png": "e9e8",
	"./surah/63_1.png": "6944",
	"./surah/63_10.png": "9797",
	"./surah/63_11.png": "277f",
	"./surah/63_2.png": "2ed53",
	"./surah/63_3.png": "011c",
	"./surah/63_4.png": "b7db6",
	"./surah/63_5.png": "c8ee",
	"./surah/63_6.png": "2ebb",
	"./surah/63_7.png": "3059",
	"./surah/63_8.png": "b209",
	"./surah/63_9.png": "8657",
	"./surah/64_1.png": "546a",
	"./surah/64_10.png": "c74aa",
	"./surah/64_11.png": "0cdf",
	"./surah/64_12.png": "886f",
	"./surah/64_13.png": "0725",
	"./surah/64_14.png": "ac36",
	"./surah/64_15.png": "4501",
	"./surah/64_16.png": "52c3",
	"./surah/64_17.png": "8faf",
	"./surah/64_18.png": "126c",
	"./surah/64_2.png": "0d3e",
	"./surah/64_3.png": "4116",
	"./surah/64_4.png": "8d949",
	"./surah/64_5.png": "d8b8",
	"./surah/64_6.png": "caad7",
	"./surah/64_7.png": "c994",
	"./surah/64_8.png": "eab4",
	"./surah/64_9.png": "fea1",
	"./surah/65_1.png": "c326",
	"./surah/65_10.png": "1781",
	"./surah/65_11.png": "d6ee3",
	"./surah/65_12.png": "925b",
	"./surah/65_2.png": "f777",
	"./surah/65_3.png": "e5ec",
	"./surah/65_4.png": "3878",
	"./surah/65_5.png": "e95ac",
	"./surah/65_6.png": "1391a",
	"./surah/65_7.png": "a892",
	"./surah/65_8.png": "184f",
	"./surah/65_9.png": "408a9",
	"./surah/66_1.png": "ba4f",
	"./surah/66_10.png": "5ff9",
	"./surah/66_11.png": "d444",
	"./surah/66_12.png": "676b",
	"./surah/66_2.png": "83ca",
	"./surah/66_3.png": "2041",
	"./surah/66_4.png": "7745",
	"./surah/66_5.png": "540b",
	"./surah/66_6.png": "f5cb",
	"./surah/66_7.png": "a5a7",
	"./surah/66_8.png": "921a2",
	"./surah/66_9.png": "256a",
	"./surah/67_1.png": "b97b",
	"./surah/67_10.png": "3ede",
	"./surah/67_11.png": "19d3",
	"./surah/67_12.png": "6ea4",
	"./surah/67_13.png": "f7e2",
	"./surah/67_14.png": "96a7",
	"./surah/67_15.png": "058d",
	"./surah/67_16.png": "e79c",
	"./surah/67_17.png": "47ee",
	"./surah/67_18.png": "513b",
	"./surah/67_19.png": "cb2d",
	"./surah/67_2.png": "12dd",
	"./surah/67_20.png": "d7f1",
	"./surah/67_21.png": "eed4",
	"./surah/67_22.png": "afed",
	"./surah/67_23.png": "fb16",
	"./surah/67_24.png": "4def",
	"./surah/67_25.png": "b080",
	"./surah/67_26.png": "7c45",
	"./surah/67_27.png": "6411",
	"./surah/67_28.png": "8307",
	"./surah/67_29.png": "bc11",
	"./surah/67_3.png": "8e1c",
	"./surah/67_30.png": "34f1",
	"./surah/67_4.png": "2185",
	"./surah/67_5.png": "0b20",
	"./surah/67_6.png": "b9db",
	"./surah/67_7.png": "fb23",
	"./surah/67_8.png": "5a125",
	"./surah/67_9.png": "477e",
	"./surah/68_1.png": "f87e",
	"./surah/68_10.png": "2e31",
	"./surah/68_11.png": "cc8b",
	"./surah/68_12.png": "fef0",
	"./surah/68_13.png": "5928",
	"./surah/68_14.png": "10c2",
	"./surah/68_15.png": "94084",
	"./surah/68_16.png": "6aba",
	"./surah/68_17.png": "d1168",
	"./surah/68_18.png": "fe84",
	"./surah/68_19.png": "a7a8",
	"./surah/68_2.png": "30e5",
	"./surah/68_20.png": "a115c",
	"./surah/68_21.png": "0493",
	"./surah/68_22.png": "e625",
	"./surah/68_23.png": "c0f0",
	"./surah/68_24.png": "7688",
	"./surah/68_25.png": "5891",
	"./surah/68_26.png": "8373",
	"./surah/68_27.png": "c90f",
	"./surah/68_28.png": "f495",
	"./surah/68_29.png": "33b8a",
	"./surah/68_3.png": "6301",
	"./surah/68_30.png": "1e32",
	"./surah/68_31.png": "2f43",
	"./surah/68_32.png": "1bd4",
	"./surah/68_33.png": "6b1c",
	"./surah/68_34.png": "cb46",
	"./surah/68_35.png": "941b",
	"./surah/68_36.png": "d7fc",
	"./surah/68_37.png": "a061",
	"./surah/68_38.png": "44cf",
	"./surah/68_39.png": "0f88",
	"./surah/68_4.png": "5974",
	"./surah/68_40.png": "4d45",
	"./surah/68_41.png": "3951",
	"./surah/68_42.png": "be47",
	"./surah/68_43.png": "1df7",
	"./surah/68_44.png": "96a8",
	"./surah/68_45.png": "2828",
	"./surah/68_46.png": "bb06",
	"./surah/68_47.png": "4f57",
	"./surah/68_48.png": "a4ef",
	"./surah/68_49.png": "9364",
	"./surah/68_5.png": "57a4",
	"./surah/68_50.png": "bc41",
	"./surah/68_51.png": "4d46",
	"./surah/68_52.png": "dc8a",
	"./surah/68_6.png": "7742",
	"./surah/68_7.png": "a998",
	"./surah/68_8.png": "178a",
	"./surah/68_9.png": "b0f9",
	"./surah/69_1.png": "53aa",
	"./surah/69_10.png": "96bf",
	"./surah/69_11.png": "b027",
	"./surah/69_12.png": "ba75",
	"./surah/69_13.png": "943d",
	"./surah/69_14.png": "9ef4",
	"./surah/69_15.png": "0bb1",
	"./surah/69_16.png": "5a35",
	"./surah/69_17.png": "9536",
	"./surah/69_18.png": "c492",
	"./surah/69_19.png": "2575",
	"./surah/69_2.png": "92c5",
	"./surah/69_20.png": "0ee66",
	"./surah/69_21.png": "bbe7",
	"./surah/69_22.png": "4e5e",
	"./surah/69_23.png": "5c9e",
	"./surah/69_24.png": "b74e",
	"./surah/69_25.png": "4561",
	"./surah/69_26.png": "09de",
	"./surah/69_27.png": "aa3e",
	"./surah/69_28.png": "c67f",
	"./surah/69_29.png": "a186",
	"./surah/69_3.png": "f43e",
	"./surah/69_30.png": "cf2aa",
	"./surah/69_31.png": "2e80",
	"./surah/69_32.png": "1670a",
	"./surah/69_33.png": "e7fb",
	"./surah/69_34.png": "6a24",
	"./surah/69_35.png": "6298",
	"./surah/69_36.png": "10c1",
	"./surah/69_37.png": "ccb3",
	"./surah/69_38.png": "f545",
	"./surah/69_39.png": "79a0",
	"./surah/69_4.png": "cd60",
	"./surah/69_40.png": "c207",
	"./surah/69_41.png": "f5ff",
	"./surah/69_42.png": "515f",
	"./surah/69_43.png": "b637",
	"./surah/69_44.png": "9d7c",
	"./surah/69_45.png": "0852",
	"./surah/69_46.png": "d043",
	"./surah/69_47.png": "3f4c8",
	"./surah/69_48.png": "5796",
	"./surah/69_49.png": "83de",
	"./surah/69_5.png": "0c0b",
	"./surah/69_50.png": "6ef9",
	"./surah/69_51.png": "3ffe",
	"./surah/69_52.png": "982f",
	"./surah/69_6.png": "e129",
	"./surah/69_7.png": "6dc4",
	"./surah/69_8.png": "f94f",
	"./surah/69_9.png": "0e9c",
	"./surah/6_1.png": "f2aa",
	"./surah/6_10.png": "23ad",
	"./surah/6_100.png": "bf0b",
	"./surah/6_101.png": "f90a",
	"./surah/6_102.png": "29b4",
	"./surah/6_103.png": "9584",
	"./surah/6_104.png": "b9f6",
	"./surah/6_105.png": "cb44",
	"./surah/6_106.png": "f762",
	"./surah/6_107.png": "190ad",
	"./surah/6_108.png": "db5e",
	"./surah/6_109.png": "6af7",
	"./surah/6_11.png": "7b73",
	"./surah/6_110.png": "7c55",
	"./surah/6_111.png": "968b",
	"./surah/6_112.png": "1e7f4",
	"./surah/6_113.png": "7ca3",
	"./surah/6_114.png": "c5e0f",
	"./surah/6_115.png": "460f",
	"./surah/6_116.png": "1830",
	"./surah/6_117.png": "fd89",
	"./surah/6_118.png": "583da",
	"./surah/6_119.png": "a4bb",
	"./surah/6_12.png": "727f",
	"./surah/6_120.png": "6275",
	"./surah/6_121.png": "eae3",
	"./surah/6_122.png": "2ef6",
	"./surah/6_123.png": "d2a9f",
	"./surah/6_124.png": "a1d2",
	"./surah/6_125.png": "e2597",
	"./surah/6_126.png": "ac48",
	"./surah/6_127.png": "38c2",
	"./surah/6_128.png": "4348",
	"./surah/6_129.png": "b0a4",
	"./surah/6_13.png": "3165",
	"./surah/6_130.png": "23a1",
	"./surah/6_131.png": "9fcb",
	"./surah/6_132.png": "20fa",
	"./surah/6_133.png": "88e2",
	"./surah/6_134.png": "e5b8",
	"./surah/6_135.png": "a87f",
	"./surah/6_136.png": "d822",
	"./surah/6_137.png": "370f",
	"./surah/6_138.png": "a1da",
	"./surah/6_139.png": "7a1a",
	"./surah/6_14.png": "88d9",
	"./surah/6_140.png": "3577",
	"./surah/6_141.png": "10a0",
	"./surah/6_142.png": "aea3",
	"./surah/6_143.png": "cea5",
	"./surah/6_144.png": "f6a7a",
	"./surah/6_145.png": "d0be",
	"./surah/6_146.png": "542b",
	"./surah/6_147.png": "119a4",
	"./surah/6_148.png": "706d",
	"./surah/6_149.png": "fb7c",
	"./surah/6_15.png": "8499",
	"./surah/6_150.png": "63bfc",
	"./surah/6_151.png": "23bd",
	"./surah/6_152.png": "cae4",
	"./surah/6_153.png": "ebc1",
	"./surah/6_154.png": "fcba",
	"./surah/6_155.png": "b4c0",
	"./surah/6_156.png": "4479",
	"./surah/6_157.png": "dea2",
	"./surah/6_158.png": "8192",
	"./surah/6_159.png": "6d8dd",
	"./surah/6_16.png": "3854",
	"./surah/6_160.png": "5aa8",
	"./surah/6_161.png": "ca91",
	"./surah/6_162.png": "fabb",
	"./surah/6_163.png": "35e0",
	"./surah/6_164.png": "5fa4",
	"./surah/6_165.png": "9450",
	"./surah/6_17.png": "5266",
	"./surah/6_18.png": "0fd4",
	"./surah/6_19.png": "2688",
	"./surah/6_2.png": "11bf",
	"./surah/6_20.png": "c4d0",
	"./surah/6_21.png": "4e9e",
	"./surah/6_22.png": "98b0",
	"./surah/6_23.png": "c1f1",
	"./surah/6_24.png": "c4b7",
	"./surah/6_25.png": "11ab",
	"./surah/6_26.png": "0fd2",
	"./surah/6_27.png": "d61e",
	"./surah/6_28.png": "91d9",
	"./surah/6_29.png": "6b338",
	"./surah/6_3.png": "c782",
	"./surah/6_30.png": "5588",
	"./surah/6_31.png": "bd16",
	"./surah/6_32.png": "4bf6",
	"./surah/6_33.png": "28f7",
	"./surah/6_34.png": "c94e",
	"./surah/6_35.png": "2b3dd",
	"./surah/6_36.png": "f1c4",
	"./surah/6_37.png": "5f26",
	"./surah/6_38.png": "1f9cb",
	"./surah/6_39.png": "cdcc",
	"./surah/6_4.png": "ccd5",
	"./surah/6_40.png": "bf77",
	"./surah/6_41.png": "ba68",
	"./surah/6_42.png": "d9a3",
	"./surah/6_43.png": "d21b4",
	"./surah/6_44.png": "05847",
	"./surah/6_45.png": "9358",
	"./surah/6_46.png": "0f54",
	"./surah/6_47.png": "3edd",
	"./surah/6_48.png": "0ef3",
	"./surah/6_49.png": "439f",
	"./surah/6_5.png": "9b27",
	"./surah/6_50.png": "79d1",
	"./surah/6_51.png": "796db",
	"./surah/6_52.png": "877f",
	"./surah/6_53.png": "033c",
	"./surah/6_54.png": "dd02",
	"./surah/6_55.png": "86d0",
	"./surah/6_56.png": "b4d9",
	"./surah/6_57.png": "034b",
	"./surah/6_58.png": "4a10",
	"./surah/6_59.png": "3190",
	"./surah/6_6.png": "f32a",
	"./surah/6_60.png": "af0d",
	"./surah/6_61.png": "9350",
	"./surah/6_62.png": "609d",
	"./surah/6_63.png": "34a5",
	"./surah/6_64.png": "9968",
	"./surah/6_65.png": "f4c3",
	"./surah/6_66.png": "2790",
	"./surah/6_67.png": "f4f9",
	"./surah/6_68.png": "75af",
	"./surah/6_69.png": "f086",
	"./surah/6_7.png": "c36b",
	"./surah/6_70.png": "a3a0",
	"./surah/6_71.png": "b77b",
	"./surah/6_72.png": "aba5",
	"./surah/6_73.png": "b5e4",
	"./surah/6_74.png": "5e6f",
	"./surah/6_75.png": "ee45",
	"./surah/6_76.png": "54c0",
	"./surah/6_77.png": "07d5",
	"./surah/6_78.png": "3f25",
	"./surah/6_79.png": "520b",
	"./surah/6_8.png": "42af4",
	"./surah/6_80.png": "fe5a",
	"./surah/6_81.png": "63a4",
	"./surah/6_82.png": "7000",
	"./surah/6_83.png": "dcdd",
	"./surah/6_84.png": "18ab",
	"./surah/6_85.png": "f4d8",
	"./surah/6_86.png": "89b3",
	"./surah/6_87.png": "c3b1",
	"./surah/6_88.png": "1c96",
	"./surah/6_89.png": "090e",
	"./surah/6_9.png": "e3da",
	"./surah/6_90.png": "5939",
	"./surah/6_91.png": "563c",
	"./surah/6_92.png": "bf3a",
	"./surah/6_93.png": "be94",
	"./surah/6_94.png": "534b",
	"./surah/6_95.png": "25fd",
	"./surah/6_96.png": "e481",
	"./surah/6_97.png": "cbb3",
	"./surah/6_98.png": "3c74",
	"./surah/6_99.png": "a908",
	"./surah/70_1.png": "4649",
	"./surah/70_10.png": "0488",
	"./surah/70_11.png": "5d11",
	"./surah/70_12.png": "0752",
	"./surah/70_13.png": "3862",
	"./surah/70_14.png": "0a00",
	"./surah/70_15.png": "65e9",
	"./surah/70_16.png": "545e",
	"./surah/70_17.png": "3bbc",
	"./surah/70_18.png": "23c0",
	"./surah/70_19.png": "77a1",
	"./surah/70_2.png": "12b4",
	"./surah/70_20.png": "a6bf",
	"./surah/70_21.png": "bf4c",
	"./surah/70_22.png": "f9f6",
	"./surah/70_23.png": "51d6",
	"./surah/70_24.png": "cc55",
	"./surah/70_25.png": "73e9",
	"./surah/70_26.png": "11e4",
	"./surah/70_27.png": "f30c",
	"./surah/70_28.png": "76b6",
	"./surah/70_29.png": "ee82",
	"./surah/70_3.png": "2f13",
	"./surah/70_30.png": "92cc",
	"./surah/70_31.png": "083c",
	"./surah/70_32.png": "b730",
	"./surah/70_33.png": "4b0c",
	"./surah/70_34.png": "78ef",
	"./surah/70_35.png": "53dfd",
	"./surah/70_36.png": "d354",
	"./surah/70_37.png": "42d5",
	"./surah/70_38.png": "ebf2",
	"./surah/70_39.png": "f137",
	"./surah/70_4.png": "59ff",
	"./surah/70_40.png": "4fb5",
	"./surah/70_41.png": "7cc4",
	"./surah/70_42.png": "aa97",
	"./surah/70_43.png": "e65f",
	"./surah/70_44.png": "59f3",
	"./surah/70_5.png": "5d00",
	"./surah/70_6.png": "57ea",
	"./surah/70_7.png": "64c0e",
	"./surah/70_8.png": "2dcc9",
	"./surah/70_9.png": "ec26",
	"./surah/71_1.png": "6048",
	"./surah/71_10.png": "4ec5",
	"./surah/71_11.png": "3e29",
	"./surah/71_12.png": "1e5a",
	"./surah/71_13.png": "62ca",
	"./surah/71_14.png": "ff4f",
	"./surah/71_15.png": "1f1d",
	"./surah/71_16.png": "c2e2",
	"./surah/71_17.png": "7703",
	"./surah/71_18.png": "9da7",
	"./surah/71_19.png": "b15e",
	"./surah/71_2.png": "a8a0",
	"./surah/71_20.png": "87c8",
	"./surah/71_21.png": "b06f0",
	"./surah/71_22.png": "a811",
	"./surah/71_23.png": "72ca",
	"./surah/71_24.png": "ea61",
	"./surah/71_25.png": "055b",
	"./surah/71_26.png": "a552",
	"./surah/71_27.png": "d051",
	"./surah/71_28.png": "aae3",
	"./surah/71_3.png": "ce3f",
	"./surah/71_4.png": "d0a0",
	"./surah/71_5.png": "fe7e",
	"./surah/71_6.png": "4dff",
	"./surah/71_7.png": "7259",
	"./surah/71_8.png": "be38",
	"./surah/71_9.png": "ecdb",
	"./surah/72_1.png": "9e89",
	"./surah/72_10.png": "7706",
	"./surah/72_11.png": "be52",
	"./surah/72_12.png": "ab4c",
	"./surah/72_13.png": "e588",
	"./surah/72_14.png": "135a",
	"./surah/72_15.png": "f275",
	"./surah/72_16.png": "8cb9",
	"./surah/72_17.png": "5494",
	"./surah/72_18.png": "6506",
	"./surah/72_19.png": "1755",
	"./surah/72_2.png": "0845",
	"./surah/72_20.png": "09a00",
	"./surah/72_21.png": "108e",
	"./surah/72_22.png": "024b",
	"./surah/72_23.png": "194b",
	"./surah/72_24.png": "6b9b",
	"./surah/72_25.png": "d1b1",
	"./surah/72_26.png": "89d5",
	"./surah/72_27.png": "f1e6",
	"./surah/72_28.png": "cc77",
	"./surah/72_3.png": "de9b",
	"./surah/72_4.png": "9119",
	"./surah/72_5.png": "3b99",
	"./surah/72_6.png": "a7e2",
	"./surah/72_7.png": "1cce",
	"./surah/72_8.png": "7eba",
	"./surah/72_9.png": "ef56",
	"./surah/73_1.png": "937c",
	"./surah/73_10.png": "35bb0",
	"./surah/73_11.png": "c1f0",
	"./surah/73_12.png": "e98f",
	"./surah/73_13.png": "dc81",
	"./surah/73_14.png": "928e",
	"./surah/73_15.png": "b53b",
	"./surah/73_16.png": "4b81",
	"./surah/73_17.png": "77bb",
	"./surah/73_18.png": "c2f60",
	"./surah/73_19.png": "c9f0",
	"./surah/73_2.png": "7a73",
	"./surah/73_20.png": "4dad",
	"./surah/73_3.png": "283d",
	"./surah/73_4.png": "e1e4",
	"./surah/73_5.png": "c0c4",
	"./surah/73_6.png": "d537",
	"./surah/73_7.png": "a081",
	"./surah/73_8.png": "e86e",
	"./surah/73_9.png": "6d56",
	"./surah/74_1.png": "d120",
	"./surah/74_10.png": "3aa6",
	"./surah/74_11.png": "1333",
	"./surah/74_12.png": "bb7f",
	"./surah/74_13.png": "2d95",
	"./surah/74_14.png": "b3c3",
	"./surah/74_15.png": "10c67",
	"./surah/74_16.png": "3837",
	"./surah/74_17.png": "3d93",
	"./surah/74_18.png": "1868",
	"./surah/74_19.png": "741c",
	"./surah/74_2.png": "19f4",
	"./surah/74_20.png": "d3eb",
	"./surah/74_21.png": "73c1",
	"./surah/74_22.png": "fad5",
	"./surah/74_23.png": "e89d",
	"./surah/74_24.png": "4b9b",
	"./surah/74_25.png": "88ff",
	"./surah/74_26.png": "2dce",
	"./surah/74_27.png": "03cb",
	"./surah/74_28.png": "5f2e",
	"./surah/74_29.png": "eecb",
	"./surah/74_3.png": "bf25",
	"./surah/74_30.png": "0f09",
	"./surah/74_31.png": "5bb3",
	"./surah/74_32.png": "01a4",
	"./surah/74_33.png": "db59",
	"./surah/74_34.png": "6733",
	"./surah/74_35.png": "1c4d",
	"./surah/74_36.png": "f060",
	"./surah/74_37.png": "819c",
	"./surah/74_38.png": "5ec4",
	"./surah/74_39.png": "b2eb",
	"./surah/74_4.png": "6080",
	"./surah/74_40.png": "6fe2",
	"./surah/74_41.png": "5c54",
	"./surah/74_42.png": "cc3d",
	"./surah/74_43.png": "16d0",
	"./surah/74_44.png": "decf",
	"./surah/74_45.png": "18de",
	"./surah/74_46.png": "dc1c",
	"./surah/74_47.png": "0da41",
	"./surah/74_48.png": "b3df",
	"./surah/74_49.png": "06f4",
	"./surah/74_5.png": "202e",
	"./surah/74_50.png": "d695a",
	"./surah/74_51.png": "64af",
	"./surah/74_52.png": "3e12",
	"./surah/74_53.png": "11d3",
	"./surah/74_54.png": "ba4f0",
	"./surah/74_55.png": "70bf",
	"./surah/74_56.png": "28dc",
	"./surah/74_6.png": "e3a5",
	"./surah/74_7.png": "66c2",
	"./surah/74_8.png": "3a0d",
	"./surah/74_9.png": "6278",
	"./surah/75_1.png": "dceb",
	"./surah/75_10.png": "7bfd",
	"./surah/75_11.png": "1aeb",
	"./surah/75_12.png": "9ae3",
	"./surah/75_13.png": "a65a",
	"./surah/75_14.png": "6e1b",
	"./surah/75_15.png": "623b",
	"./surah/75_16.png": "f3d2",
	"./surah/75_17.png": "5afb",
	"./surah/75_18.png": "4d84",
	"./surah/75_19.png": "f6e9",
	"./surah/75_2.png": "2c57",
	"./surah/75_20.png": "7ca5",
	"./surah/75_21.png": "2daa",
	"./surah/75_22.png": "29f9",
	"./surah/75_23.png": "d097",
	"./surah/75_24.png": "4625",
	"./surah/75_25.png": "4704c",
	"./surah/75_26.png": "cc04",
	"./surah/75_27.png": "ac61",
	"./surah/75_28.png": "a084",
	"./surah/75_29.png": "b1a0",
	"./surah/75_3.png": "0869",
	"./surah/75_30.png": "b2b9",
	"./surah/75_31.png": "e691",
	"./surah/75_32.png": "9cd3",
	"./surah/75_33.png": "a6849",
	"./surah/75_34.png": "8e40",
	"./surah/75_35.png": "8fe4",
	"./surah/75_36.png": "66a8",
	"./surah/75_37.png": "48e4",
	"./surah/75_38.png": "ff1e",
	"./surah/75_39.png": "0148d",
	"./surah/75_4.png": "b2bb",
	"./surah/75_40.png": "0e13",
	"./surah/75_5.png": "73bf",
	"./surah/75_6.png": "8350",
	"./surah/75_7.png": "4929",
	"./surah/75_8.png": "8679",
	"./surah/75_9.png": "ed57",
	"./surah/76_1.png": "ce22",
	"./surah/76_10.png": "4ce2",
	"./surah/76_11.png": "76aa",
	"./surah/76_12.png": "2f137",
	"./surah/76_13.png": "d25b",
	"./surah/76_14.png": "a33a",
	"./surah/76_15.png": "7133",
	"./surah/76_16.png": "8639",
	"./surah/76_17.png": "8621",
	"./surah/76_18.png": "ce39",
	"./surah/76_19.png": "dce2",
	"./surah/76_2.png": "cf9b",
	"./surah/76_20.png": "15aeb",
	"./surah/76_21.png": "eda6",
	"./surah/76_22.png": "1b1a9",
	"./surah/76_23.png": "6fe3",
	"./surah/76_24.png": "ea44",
	"./surah/76_25.png": "6e25",
	"./surah/76_26.png": "15fa",
	"./surah/76_27.png": "04ab",
	"./surah/76_28.png": "ffe2",
	"./surah/76_29.png": "1589",
	"./surah/76_3.png": "98fe",
	"./surah/76_30.png": "f200",
	"./surah/76_31.png": "afc5",
	"./surah/76_4.png": "ba9b",
	"./surah/76_5.png": "5dce",
	"./surah/76_6.png": "2b26",
	"./surah/76_7.png": "5322",
	"./surah/76_8.png": "4d69",
	"./surah/76_9.png": "95af",
	"./surah/77_1.png": "ce19",
	"./surah/77_10.png": "8cf1",
	"./surah/77_11.png": "1e0d",
	"./surah/77_12.png": "877a",
	"./surah/77_13.png": "c7b1",
	"./surah/77_14.png": "dc69",
	"./surah/77_15.png": "4d86",
	"./surah/77_16.png": "9ba43",
	"./surah/77_17.png": "00a4",
	"./surah/77_18.png": "f85d",
	"./surah/77_19.png": "cd17",
	"./surah/77_2.png": "02db",
	"./surah/77_20.png": "4f1e",
	"./surah/77_21.png": "a6dc",
	"./surah/77_22.png": "11a65",
	"./surah/77_23.png": "7d7a",
	"./surah/77_24.png": "da9e",
	"./surah/77_25.png": "9160",
	"./surah/77_26.png": "b8ec",
	"./surah/77_27.png": "05f6",
	"./surah/77_28.png": "bff3",
	"./surah/77_29.png": "40b2",
	"./surah/77_3.png": "84a0",
	"./surah/77_30.png": "0b5a",
	"./surah/77_31.png": "4069",
	"./surah/77_32.png": "74a8",
	"./surah/77_33.png": "c9dd",
	"./surah/77_34.png": "df07",
	"./surah/77_35.png": "a3f6",
	"./surah/77_36.png": "01da",
	"./surah/77_37.png": "0534",
	"./surah/77_38.png": "3c78",
	"./surah/77_39.png": "a7f0",
	"./surah/77_4.png": "3760",
	"./surah/77_40.png": "e156",
	"./surah/77_41.png": "3cf0",
	"./surah/77_42.png": "9f7d8",
	"./surah/77_43.png": "c4ad",
	"./surah/77_44.png": "3282",
	"./surah/77_45.png": "4dade",
	"./surah/77_46.png": "39ae",
	"./surah/77_47.png": "23dd",
	"./surah/77_48.png": "c20e7",
	"./surah/77_49.png": "d438",
	"./surah/77_5.png": "3750",
	"./surah/77_50.png": "2bfb",
	"./surah/77_6.png": "6558e",
	"./surah/77_7.png": "61b66",
	"./surah/77_8.png": "7acb",
	"./surah/77_9.png": "64b0c",
	"./surah/78_1.png": "6a7b",
	"./surah/78_10.png": "6f27",
	"./surah/78_11.png": "82ec",
	"./surah/78_12.png": "56ab",
	"./surah/78_13.png": "80e1",
	"./surah/78_14.png": "2e4b",
	"./surah/78_15.png": "b1b1",
	"./surah/78_16.png": "727c",
	"./surah/78_17.png": "5ff98",
	"./surah/78_18.png": "0b39",
	"./surah/78_19.png": "796c",
	"./surah/78_2.png": "119d",
	"./surah/78_20.png": "96de",
	"./surah/78_21.png": "44ec",
	"./surah/78_22.png": "e4ef",
	"./surah/78_23.png": "ea18",
	"./surah/78_24.png": "7c8c",
	"./surah/78_25.png": "0903",
	"./surah/78_26.png": "a4cd",
	"./surah/78_27.png": "b59f",
	"./surah/78_28.png": "689b",
	"./surah/78_29.png": "935f",
	"./surah/78_3.png": "a38c",
	"./surah/78_30.png": "a2f4",
	"./surah/78_31.png": "de79",
	"./surah/78_32.png": "61b1",
	"./surah/78_33.png": "83a4",
	"./surah/78_34.png": "8a36",
	"./surah/78_35.png": "53df1",
	"./surah/78_36.png": "673f",
	"./surah/78_37.png": "e188",
	"./surah/78_38.png": "2bd6",
	"./surah/78_39.png": "b1f1",
	"./surah/78_4.png": "d33b",
	"./surah/78_40.png": "751b",
	"./surah/78_5.png": "95f9",
	"./surah/78_6.png": "877d",
	"./surah/78_7.png": "8052",
	"./surah/78_8.png": "d71f",
	"./surah/78_9.png": "bb0e",
	"./surah/79_1.png": "db45",
	"./surah/79_10.png": "c108",
	"./surah/79_11.png": "3e57",
	"./surah/79_12.png": "a5eb",
	"./surah/79_13.png": "1f5f6",
	"./surah/79_14.png": "3cb9",
	"./surah/79_15.png": "79e7",
	"./surah/79_16.png": "62ee",
	"./surah/79_17.png": "ea36",
	"./surah/79_18.png": "b8a7",
	"./surah/79_19.png": "3583",
	"./surah/79_2.png": "4b92",
	"./surah/79_20.png": "a393",
	"./surah/79_21.png": "a61e",
	"./surah/79_22.png": "2a69",
	"./surah/79_23.png": "0fb7",
	"./surah/79_24.png": "f3af",
	"./surah/79_25.png": "b4ba",
	"./surah/79_26.png": "deb8",
	"./surah/79_27.png": "af09",
	"./surah/79_28.png": "9a4f",
	"./surah/79_29.png": "06ec",
	"./surah/79_3.png": "9161",
	"./surah/79_30.png": "b593",
	"./surah/79_31.png": "5b8a",
	"./surah/79_32.png": "fd1c",
	"./surah/79_33.png": "9c9b7",
	"./surah/79_34.png": "fa2e",
	"./surah/79_35.png": "07a6",
	"./surah/79_36.png": "6ddf",
	"./surah/79_37.png": "da2b",
	"./surah/79_38.png": "bf6b",
	"./surah/79_39.png": "19ac",
	"./surah/79_4.png": "dfd0",
	"./surah/79_40.png": "3389",
	"./surah/79_41.png": "3f1a",
	"./surah/79_42.png": "6e46",
	"./surah/79_43.png": "563d",
	"./surah/79_44.png": "b632",
	"./surah/79_45.png": "2fd4",
	"./surah/79_46.png": "b4a2",
	"./surah/79_5.png": "83fb",
	"./surah/79_6.png": "c0ad",
	"./surah/79_7.png": "eb38",
	"./surah/79_8.png": "61f3",
	"./surah/79_9.png": "6acac",
	"./surah/7_1.png": "ce48",
	"./surah/7_10.png": "d340",
	"./surah/7_100.png": "d2d45",
	"./surah/7_101.png": "ca8e",
	"./surah/7_102.png": "93f7",
	"./surah/7_103.png": "618e",
	"./surah/7_104.png": "f798",
	"./surah/7_105.png": "823d",
	"./surah/7_106.png": "605e",
	"./surah/7_107.png": "7f4f",
	"./surah/7_108.png": "a381",
	"./surah/7_109.png": "9225",
	"./surah/7_11.png": "1807",
	"./surah/7_110.png": "be76",
	"./surah/7_111.png": "a39e",
	"./surah/7_112.png": "42ad",
	"./surah/7_113.png": "f39f",
	"./surah/7_114.png": "7a39",
	"./surah/7_115.png": "00ec",
	"./surah/7_116.png": "9124",
	"./surah/7_117.png": "66af",
	"./surah/7_118.png": "96eb",
	"./surah/7_119.png": "05af",
	"./surah/7_12.png": "c96c",
	"./surah/7_120.png": "19a6",
	"./surah/7_121.png": "604c",
	"./surah/7_122.png": "aa38",
	"./surah/7_123.png": "3655",
	"./surah/7_124.png": "91bf",
	"./surah/7_125.png": "873d",
	"./surah/7_126.png": "52b2",
	"./surah/7_127.png": "c884",
	"./surah/7_128.png": "293b4",
	"./surah/7_129.png": "3e0f",
	"./surah/7_13.png": "9c82",
	"./surah/7_130.png": "8a366",
	"./surah/7_131.png": "7cc2",
	"./surah/7_132.png": "e6f9",
	"./surah/7_133.png": "017d",
	"./surah/7_134.png": "aa41",
	"./surah/7_135.png": "e93a",
	"./surah/7_136.png": "4bdd",
	"./surah/7_137.png": "5f45",
	"./surah/7_138.png": "0c5e",
	"./surah/7_139.png": "3336a",
	"./surah/7_14.png": "dfbc",
	"./surah/7_140.png": "c018",
	"./surah/7_141.png": "5bf2",
	"./surah/7_142.png": "1cdc8",
	"./surah/7_143.png": "dc84",
	"./surah/7_144.png": "9018",
	"./surah/7_145.png": "b731",
	"./surah/7_146.png": "af36",
	"./surah/7_147.png": "386b",
	"./surah/7_148.png": "e46f",
	"./surah/7_149.png": "0f5f",
	"./surah/7_15.png": "11b3",
	"./surah/7_150.png": "9498",
	"./surah/7_151.png": "5218",
	"./surah/7_152.png": "239d",
	"./surah/7_153.png": "0b137",
	"./surah/7_154.png": "48a9",
	"./surah/7_155.png": "bf7a",
	"./surah/7_156.png": "7e0e",
	"./surah/7_157.png": "3857",
	"./surah/7_158.png": "3394",
	"./surah/7_159.png": "0fbd",
	"./surah/7_16.png": "1907",
	"./surah/7_160.png": "5bfc",
	"./surah/7_161.png": "0010",
	"./surah/7_162.png": "bdda",
	"./surah/7_163.png": "bdda4",
	"./surah/7_164.png": "bbc2",
	"./surah/7_165.png": "76b1",
	"./surah/7_166.png": "6122",
	"./surah/7_167.png": "363b",
	"./surah/7_168.png": "e93a3",
	"./surah/7_169.png": "a6cb",
	"./surah/7_17.png": "c1b2",
	"./surah/7_170.png": "9f0d",
	"./surah/7_171.png": "3f23",
	"./surah/7_172.png": "7e2f",
	"./surah/7_173.png": "2e70",
	"./surah/7_174.png": "d236",
	"./surah/7_175.png": "416b",
	"./surah/7_176.png": "bcb0",
	"./surah/7_177.png": "32ba",
	"./surah/7_178.png": "c45d",
	"./surah/7_179.png": "eedb",
	"./surah/7_18.png": "9551",
	"./surah/7_180.png": "274d",
	"./surah/7_181.png": "b06fa",
	"./surah/7_182.png": "ae92",
	"./surah/7_183.png": "c286",
	"./surah/7_184.png": "f84a",
	"./surah/7_185.png": "7593",
	"./surah/7_186.png": "63fa",
	"./surah/7_187.png": "5103",
	"./surah/7_188.png": "c0836",
	"./surah/7_189.png": "9a43d",
	"./surah/7_19.png": "e7a6",
	"./surah/7_190.png": "8eeb",
	"./surah/7_191.png": "6e30",
	"./surah/7_192.png": "3127",
	"./surah/7_193.png": "e517",
	"./surah/7_194.png": "528d7",
	"./surah/7_195.png": "d707",
	"./surah/7_196.png": "47c4",
	"./surah/7_197.png": "8e22",
	"./surah/7_198.png": "a787",
	"./surah/7_199.png": "c4fe",
	"./surah/7_2.png": "1e9d",
	"./surah/7_20.png": "cbc6",
	"./surah/7_200.png": "39ea",
	"./surah/7_201.png": "5ac8",
	"./surah/7_202.png": "b95f",
	"./surah/7_203.png": "ea40",
	"./surah/7_204.png": "cc04e",
	"./surah/7_205.png": "2e1f",
	"./surah/7_206.png": "3106",
	"./surah/7_21.png": "2162",
	"./surah/7_22.png": "97e5",
	"./surah/7_23.png": "775f",
	"./surah/7_24.png": "2829",
	"./surah/7_25.png": "9676",
	"./surah/7_26.png": "67d8",
	"./surah/7_27.png": "7f937",
	"./surah/7_28.png": "4958",
	"./surah/7_29.png": "09ce",
	"./surah/7_3.png": "e9fd",
	"./surah/7_30.png": "5fcd",
	"./surah/7_31.png": "fdb7",
	"./surah/7_32.png": "dacf",
	"./surah/7_33.png": "7379",
	"./surah/7_34.png": "549d",
	"./surah/7_35.png": "53c6",
	"./surah/7_36.png": "7aae",
	"./surah/7_37.png": "7d82",
	"./surah/7_38.png": "b234",
	"./surah/7_39.png": "35c1",
	"./surah/7_4.png": "5d91",
	"./surah/7_40.png": "2bf8",
	"./surah/7_41.png": "c1f3",
	"./surah/7_42.png": "f9f1",
	"./surah/7_43.png": "c6db",
	"./surah/7_44.png": "78ce",
	"./surah/7_45.png": "8d5f",
	"./surah/7_46.png": "f2c8",
	"./surah/7_47.png": "5bc6",
	"./surah/7_48.png": "d28c",
	"./surah/7_49.png": "0f2d",
	"./surah/7_5.png": "d706",
	"./surah/7_50.png": "4a4b",
	"./surah/7_51.png": "ef43",
	"./surah/7_52.png": "032c",
	"./surah/7_53.png": "99a7",
	"./surah/7_54.png": "e2a0",
	"./surah/7_55.png": "04c4",
	"./surah/7_56.png": "21ff",
	"./surah/7_57.png": "5882",
	"./surah/7_58.png": "0137",
	"./surah/7_59.png": "a8eb",
	"./surah/7_6.png": "0f98",
	"./surah/7_60.png": "5338",
	"./surah/7_61.png": "a9ba",
	"./surah/7_62.png": "69cd",
	"./surah/7_63.png": "da3d",
	"./surah/7_64.png": "2853",
	"./surah/7_65.png": "6d1b",
	"./surah/7_66.png": "8d9d",
	"./surah/7_67.png": "4800",
	"./surah/7_68.png": "e8c0",
	"./surah/7_69.png": "ae60",
	"./surah/7_7.png": "7e8a",
	"./surah/7_70.png": "6d63",
	"./surah/7_71.png": "fa17",
	"./surah/7_72.png": "6135",
	"./surah/7_73.png": "54d3",
	"./surah/7_74.png": "fac1",
	"./surah/7_75.png": "bdbc",
	"./surah/7_76.png": "1a23",
	"./surah/7_77.png": "ed70",
	"./surah/7_78.png": "0773",
	"./surah/7_79.png": "0094",
	"./surah/7_8.png": "8f26",
	"./surah/7_80.png": "4f70",
	"./surah/7_81.png": "4bff",
	"./surah/7_82.png": "e0e3",
	"./surah/7_83.png": "753b",
	"./surah/7_84.png": "d830",
	"./surah/7_85.png": "6555",
	"./surah/7_86.png": "0f45",
	"./surah/7_87.png": "c941",
	"./surah/7_88.png": "f3f7",
	"./surah/7_89.png": "4094",
	"./surah/7_9.png": "9a5e",
	"./surah/7_90.png": "37dc",
	"./surah/7_91.png": "54a0",
	"./surah/7_92.png": "412b",
	"./surah/7_93.png": "86e9",
	"./surah/7_94.png": "b39b",
	"./surah/7_95.png": "3f7d",
	"./surah/7_96.png": "c823",
	"./surah/7_97.png": "33eb",
	"./surah/7_98.png": "f1ec3",
	"./surah/7_99.png": "65cd",
	"./surah/80_1.png": "9d31",
	"./surah/80_10.png": "1a5f",
	"./surah/80_11.png": "6814",
	"./surah/80_12.png": "c5dd",
	"./surah/80_13.png": "4c85",
	"./surah/80_14.png": "c7eb",
	"./surah/80_15.png": "6a76",
	"./surah/80_16.png": "82ff",
	"./surah/80_17.png": "4669",
	"./surah/80_18.png": "51b3",
	"./surah/80_19.png": "0e93",
	"./surah/80_2.png": "cd95",
	"./surah/80_20.png": "b768",
	"./surah/80_21.png": "35d0",
	"./surah/80_22.png": "fb51",
	"./surah/80_23.png": "a8b9",
	"./surah/80_24.png": "bfd0",
	"./surah/80_25.png": "06bb",
	"./surah/80_26.png": "bae47",
	"./surah/80_27.png": "3317",
	"./surah/80_28.png": "3d90",
	"./surah/80_29.png": "b12b",
	"./surah/80_3.png": "2fb81",
	"./surah/80_30.png": "bc4e",
	"./surah/80_31.png": "d56eb",
	"./surah/80_32.png": "9fb2",
	"./surah/80_33.png": "783b",
	"./surah/80_34.png": "6eaa",
	"./surah/80_35.png": "e3d9",
	"./surah/80_36.png": "bbacc",
	"./surah/80_37.png": "f1cd",
	"./surah/80_38.png": "c4f6",
	"./surah/80_39.png": "4f63",
	"./surah/80_4.png": "208d8",
	"./surah/80_40.png": "9719",
	"./surah/80_41.png": "9f19",
	"./surah/80_42.png": "e453",
	"./surah/80_5.png": "3ee1",
	"./surah/80_6.png": "d12e",
	"./surah/80_7.png": "dceb8",
	"./surah/80_8.png": "2ce1",
	"./surah/80_9.png": "fec4",
	"./surah/81_1.png": "5f65",
	"./surah/81_10.png": "fbfb",
	"./surah/81_11.png": "2088",
	"./surah/81_12.png": "caa06",
	"./surah/81_13.png": "1de3",
	"./surah/81_14.png": "5ab7",
	"./surah/81_15.png": "0cd7",
	"./surah/81_16.png": "f86e",
	"./surah/81_17.png": "5976",
	"./surah/81_18.png": "c088",
	"./surah/81_19.png": "0a50",
	"./surah/81_2.png": "4ced",
	"./surah/81_20.png": "b147",
	"./surah/81_21.png": "e429",
	"./surah/81_22.png": "c450",
	"./surah/81_23.png": "ffbaf",
	"./surah/81_24.png": "1b5c",
	"./surah/81_25.png": "a234",
	"./surah/81_26.png": "0abf",
	"./surah/81_27.png": "33fe",
	"./surah/81_28.png": "f8c2",
	"./surah/81_29.png": "1a36",
	"./surah/81_3.png": "b124",
	"./surah/81_4.png": "8798",
	"./surah/81_5.png": "c445",
	"./surah/81_6.png": "96c9",
	"./surah/81_7.png": "524f",
	"./surah/81_8.png": "97a5",
	"./surah/81_9.png": "a166",
	"./surah/82_1.png": "9881",
	"./surah/82_10.png": "e42c",
	"./surah/82_11.png": "390d",
	"./surah/82_12.png": "58b1",
	"./surah/82_13.png": "08fb",
	"./surah/82_14.png": "58ef",
	"./surah/82_15.png": "9b6b",
	"./surah/82_16.png": "f1e5",
	"./surah/82_17.png": "3372",
	"./surah/82_18.png": "7bab",
	"./surah/82_19.png": "ee80",
	"./surah/82_2.png": "b39d",
	"./surah/82_3.png": "8c2b",
	"./surah/82_4.png": "b67c6",
	"./surah/82_5.png": "2ff7",
	"./surah/82_6.png": "f3e3",
	"./surah/82_7.png": "de58",
	"./surah/82_8.png": "581e",
	"./surah/82_9.png": "c158",
	"./surah/83_1.png": "6deec",
	"./surah/83_10.png": "0777",
	"./surah/83_11.png": "56ac",
	"./surah/83_12.png": "7bd0",
	"./surah/83_13.png": "60de",
	"./surah/83_14.png": "c469",
	"./surah/83_15.png": "c7bd",
	"./surah/83_16.png": "d35d",
	"./surah/83_17.png": "9541",
	"./surah/83_18.png": "75166",
	"./surah/83_19.png": "7490",
	"./surah/83_2.png": "347b",
	"./surah/83_20.png": "dd79",
	"./surah/83_21.png": "f42b",
	"./surah/83_22.png": "cca0",
	"./surah/83_23.png": "b2ed",
	"./surah/83_24.png": "f759",
	"./surah/83_25.png": "920c",
	"./surah/83_26.png": "cdebf",
	"./surah/83_27.png": "c41c",
	"./surah/83_28.png": "6cd4",
	"./surah/83_29.png": "a6b3",
	"./surah/83_3.png": "0f28",
	"./surah/83_30.png": "9394",
	"./surah/83_31.png": "a1a7",
	"./surah/83_32.png": "23df",
	"./surah/83_33.png": "7949",
	"./surah/83_34.png": "6e33",
	"./surah/83_35.png": "7b79",
	"./surah/83_36.png": "a3f9",
	"./surah/83_4.png": "d3e2",
	"./surah/83_5.png": "7795",
	"./surah/83_6.png": "4111",
	"./surah/83_7.png": "9afe",
	"./surah/83_8.png": "24c7a",
	"./surah/83_9.png": "96f7",
	"./surah/84_1.png": "c02c",
	"./surah/84_10.png": "5faf",
	"./surah/84_11.png": "c28f",
	"./surah/84_12.png": "ab02",
	"./surah/84_13.png": "32cd",
	"./surah/84_14.png": "09ef",
	"./surah/84_15.png": "2d77",
	"./surah/84_16.png": "f2ae2",
	"./surah/84_17.png": "cf1b",
	"./surah/84_18.png": "073e",
	"./surah/84_19.png": "b8e4",
	"./surah/84_2.png": "8ab9f",
	"./surah/84_20.png": "58c6",
	"./surah/84_21.png": "a6a0",
	"./surah/84_22.png": "2c95",
	"./surah/84_23.png": "c74f",
	"./surah/84_24.png": "3eff8",
	"./surah/84_25.png": "8ccc",
	"./surah/84_3.png": "dad2",
	"./surah/84_4.png": "f5b0",
	"./surah/84_5.png": "19c2",
	"./surah/84_6.png": "93ea",
	"./surah/84_7.png": "5237",
	"./surah/84_8.png": "3c3e",
	"./surah/84_9.png": "651f",
	"./surah/85_1.png": "5a5f",
	"./surah/85_10.png": "18b78",
	"./surah/85_11.png": "0cfb2",
	"./surah/85_12.png": "45cd",
	"./surah/85_13.png": "21c9",
	"./surah/85_14.png": "8c0c",
	"./surah/85_15.png": "1e72",
	"./surah/85_16.png": "8871",
	"./surah/85_17.png": "a12d",
	"./surah/85_18.png": "6a2c",
	"./surah/85_19.png": "3089",
	"./surah/85_2.png": "08ae",
	"./surah/85_20.png": "7c62",
	"./surah/85_21.png": "17e3",
	"./surah/85_22.png": "f895",
	"./surah/85_3.png": "6330",
	"./surah/85_4.png": "3595",
	"./surah/85_5.png": "2c6f",
	"./surah/85_6.png": "8525",
	"./surah/85_7.png": "b07f",
	"./surah/85_8.png": "b5fb",
	"./surah/85_9.png": "dcf0",
	"./surah/86_1.png": "44f9",
	"./surah/86_10.png": "0ba6",
	"./surah/86_11.png": "7222",
	"./surah/86_12.png": "787c",
	"./surah/86_13.png": "6a8a",
	"./surah/86_14.png": "133b",
	"./surah/86_15.png": "c1be",
	"./surah/86_16.png": "1a4a",
	"./surah/86_17.png": "a792",
	"./surah/86_2.png": "4b15",
	"./surah/86_3.png": "8455",
	"./surah/86_4.png": "9495",
	"./surah/86_5.png": "f040",
	"./surah/86_6.png": "8987",
	"./surah/86_7.png": "9801",
	"./surah/86_8.png": "5806",
	"./surah/86_9.png": "cb74",
	"./surah/87_1.png": "0d5e",
	"./surah/87_10.png": "a7b2",
	"./surah/87_11.png": "65ed",
	"./surah/87_12.png": "edcc",
	"./surah/87_13.png": "3cfb",
	"./surah/87_14.png": "9088",
	"./surah/87_15.png": "8756",
	"./surah/87_16.png": "4eb6",
	"./surah/87_17.png": "7ba8",
	"./surah/87_18.png": "2b20",
	"./surah/87_19.png": "7b68",
	"./surah/87_2.png": "a7da",
	"./surah/87_3.png": "3fed4",
	"./surah/87_4.png": "6990",
	"./surah/87_5.png": "3869",
	"./surah/87_6.png": "c08e",
	"./surah/87_7.png": "07f8",
	"./surah/87_8.png": "e1c34",
	"./surah/87_9.png": "5f1a",
	"./surah/88_1.png": "0397",
	"./surah/88_10.png": "cd81",
	"./surah/88_11.png": "1934",
	"./surah/88_12.png": "6272",
	"./surah/88_13.png": "4acd3",
	"./surah/88_14.png": "2007",
	"./surah/88_15.png": "7f64",
	"./surah/88_16.png": "7a81",
	"./surah/88_17.png": "1dfd",
	"./surah/88_18.png": "464d",
	"./surah/88_19.png": "c4e4",
	"./surah/88_2.png": "886c",
	"./surah/88_20.png": "81c5",
	"./surah/88_21.png": "12510",
	"./surah/88_22.png": "1aba",
	"./surah/88_23.png": "ca5b",
	"./surah/88_24.png": "9f28",
	"./surah/88_25.png": "e280",
	"./surah/88_26.png": "fea4",
	"./surah/88_3.png": "4f50",
	"./surah/88_4.png": "c0a8",
	"./surah/88_5.png": "27f1",
	"./surah/88_6.png": "8d76",
	"./surah/88_7.png": "b53a",
	"./surah/88_8.png": "79f3",
	"./surah/88_9.png": "a1a1",
	"./surah/89_1.png": "0d34",
	"./surah/89_10.png": "bf86",
	"./surah/89_11.png": "1cf7",
	"./surah/89_12.png": "178f",
	"./surah/89_13.png": "e913",
	"./surah/89_14.png": "0886",
	"./surah/89_15.png": "b0f3",
	"./surah/89_16.png": "49c7",
	"./surah/89_17.png": "f002",
	"./surah/89_18.png": "1822",
	"./surah/89_19.png": "b2c3",
	"./surah/89_2.png": "f52e",
	"./surah/89_20.png": "8dfa",
	"./surah/89_21.png": "a6b1",
	"./surah/89_22.png": "a1a1e",
	"./surah/89_23.png": "4c7f",
	"./surah/89_24.png": "befc",
	"./surah/89_25.png": "268e",
	"./surah/89_26.png": "6116",
	"./surah/89_27.png": "0ae1",
	"./surah/89_28.png": "5ad2",
	"./surah/89_29.png": "424e",
	"./surah/89_3.png": "54fe",
	"./surah/89_30.png": "32ad",
	"./surah/89_4.png": "5b1c",
	"./surah/89_5.png": "9ae0a",
	"./surah/89_6.png": "0ce3",
	"./surah/89_7.png": "843d",
	"./surah/89_8.png": "562f",
	"./surah/89_9.png": "ee35",
	"./surah/8_1.png": "eb9b",
	"./surah/8_10.png": "2b25",
	"./surah/8_11.png": "79b3",
	"./surah/8_12.png": "53ed",
	"./surah/8_13.png": "8799",
	"./surah/8_14.png": "0b2c",
	"./surah/8_15.png": "54cc",
	"./surah/8_16.png": "7d86",
	"./surah/8_17.png": "a755",
	"./surah/8_18.png": "66dd",
	"./surah/8_19.png": "1446",
	"./surah/8_2.png": "8619",
	"./surah/8_20.png": "0a90",
	"./surah/8_21.png": "f5ca",
	"./surah/8_22.png": "169e",
	"./surah/8_23.png": "42850",
	"./surah/8_24.png": "cc3a",
	"./surah/8_25.png": "fab0",
	"./surah/8_26.png": "fec0",
	"./surah/8_27.png": "10c0",
	"./surah/8_28.png": "68eb",
	"./surah/8_29.png": "1683",
	"./surah/8_3.png": "b2fa",
	"./surah/8_30.png": "ef1e",
	"./surah/8_31.png": "748c",
	"./surah/8_32.png": "1ae9",
	"./surah/8_33.png": "8340",
	"./surah/8_34.png": "9598",
	"./surah/8_35.png": "aa88",
	"./surah/8_36.png": "a48f",
	"./surah/8_37.png": "a63a",
	"./surah/8_38.png": "953c",
	"./surah/8_39.png": "72a4",
	"./surah/8_4.png": "2bac",
	"./surah/8_40.png": "8565",
	"./surah/8_41.png": "c7b6",
	"./surah/8_42.png": "d218",
	"./surah/8_43.png": "7092",
	"./surah/8_44.png": "436d",
	"./surah/8_45.png": "02fa",
	"./surah/8_46.png": "5439",
	"./surah/8_47.png": "b046",
	"./surah/8_48.png": "0c04",
	"./surah/8_49.png": "e6de",
	"./surah/8_5.png": "0d2a",
	"./surah/8_50.png": "90b4",
	"./surah/8_51.png": "21c5",
	"./surah/8_52.png": "7057",
	"./surah/8_53.png": "ee38",
	"./surah/8_54.png": "cf4f",
	"./surah/8_55.png": "7a46",
	"./surah/8_56.png": "d592",
	"./surah/8_57.png": "8681",
	"./surah/8_58.png": "85bc",
	"./surah/8_59.png": "7572",
	"./surah/8_6.png": "a3a1",
	"./surah/8_60.png": "dd3a",
	"./surah/8_61.png": "0386",
	"./surah/8_62.png": "0cd6",
	"./surah/8_63.png": "1457",
	"./surah/8_64.png": "d457",
	"./surah/8_65.png": "6a62",
	"./surah/8_66.png": "5f63",
	"./surah/8_67.png": "df84",
	"./surah/8_68.png": "b9cf",
	"./surah/8_69.png": "1426",
	"./surah/8_7.png": "2376",
	"./surah/8_70.png": "a187",
	"./surah/8_71.png": "bd5c",
	"./surah/8_72.png": "c337",
	"./surah/8_73.png": "cb92",
	"./surah/8_74.png": "8382",
	"./surah/8_75.png": "8778",
	"./surah/8_8.png": "de3e",
	"./surah/8_9.png": "0195",
	"./surah/90_1.png": "b8e32",
	"./surah/90_10.png": "90a2",
	"./surah/90_11.png": "10b6",
	"./surah/90_12.png": "6fb4",
	"./surah/90_13.png": "d00b",
	"./surah/90_14.png": "f86ee",
	"./surah/90_15.png": "be7a",
	"./surah/90_16.png": "5d8c",
	"./surah/90_17.png": "ee3f0",
	"./surah/90_18.png": "4a7e",
	"./surah/90_19.png": "0ecb",
	"./surah/90_2.png": "51ba",
	"./surah/90_20.png": "a188",
	"./surah/90_3.png": "a52f",
	"./surah/90_4.png": "dbf4",
	"./surah/90_5.png": "9d01",
	"./surah/90_6.png": "10d1",
	"./surah/90_7.png": "359e",
	"./surah/90_8.png": "a95b",
	"./surah/90_9.png": "836e",
	"./surah/91_1.png": "f707",
	"./surah/91_10.png": "9aed",
	"./surah/91_11.png": "c096",
	"./surah/91_12.png": "6c21",
	"./surah/91_13.png": "a4c0",
	"./surah/91_14.png": "0898",
	"./surah/91_15.png": "74f5",
	"./surah/91_2.png": "c3112",
	"./surah/91_3.png": "d3ff",
	"./surah/91_4.png": "4644",
	"./surah/91_5.png": "0509",
	"./surah/91_6.png": "ef52",
	"./surah/91_7.png": "3156",
	"./surah/91_8.png": "ebbb6",
	"./surah/91_9.png": "987d",
	"./surah/92_1.png": "d7a3",
	"./surah/92_10.png": "1371",
	"./surah/92_11.png": "5d8d",
	"./surah/92_12.png": "4ad4",
	"./surah/92_13.png": "c2ab",
	"./surah/92_14.png": "9d94",
	"./surah/92_15.png": "ca5c",
	"./surah/92_16.png": "abf4",
	"./surah/92_17.png": "132b",
	"./surah/92_18.png": "1e4d",
	"./surah/92_19.png": "2a66",
	"./surah/92_2.png": "e64e",
	"./surah/92_20.png": "1053",
	"./surah/92_21.png": "7529",
	"./surah/92_3.png": "b045",
	"./surah/92_4.png": "e96b",
	"./surah/92_5.png": "bcd2",
	"./surah/92_6.png": "f254",
	"./surah/92_7.png": "dba2",
	"./surah/92_8.png": "e6ea",
	"./surah/92_9.png": "911c",
	"./surah/93_1.png": "dc7f",
	"./surah/93_10.png": "8f3b",
	"./surah/93_11.png": "21a4",
	"./surah/93_2.png": "83d6",
	"./surah/93_3.png": "eded",
	"./surah/93_4.png": "d1d7",
	"./surah/93_5.png": "b4fc",
	"./surah/93_6.png": "14d9",
	"./surah/93_7.png": "2139",
	"./surah/93_8.png": "b73f",
	"./surah/93_9.png": "0684",
	"./surah/94_1.png": "fa928",
	"./surah/94_2.png": "d22c",
	"./surah/94_3.png": "0363",
	"./surah/94_4.png": "404d",
	"./surah/94_5.png": "8e84",
	"./surah/94_6.png": "7a28",
	"./surah/94_7.png": "7fc62",
	"./surah/94_8.png": "3ffed",
	"./surah/95_1.png": "d19d",
	"./surah/95_2.png": "afd0",
	"./surah/95_3.png": "7d77",
	"./surah/95_4.png": "2cb5",
	"./surah/95_5.png": "bede",
	"./surah/95_6.png": "b5ca",
	"./surah/95_7.png": "6fc3",
	"./surah/95_8.png": "0ed9b",
	"./surah/96_1.png": "2593",
	"./surah/96_10.png": "69fc",
	"./surah/96_11.png": "98a79",
	"./surah/96_12.png": "7ede",
	"./surah/96_13.png": "67069",
	"./surah/96_14.png": "25e2",
	"./surah/96_15.png": "1679",
	"./surah/96_16.png": "38f3",
	"./surah/96_17.png": "6075",
	"./surah/96_18.png": "f5ba",
	"./surah/96_19.png": "de69",
	"./surah/96_2.png": "3af8",
	"./surah/96_3.png": "3026",
	"./surah/96_4.png": "5a24",
	"./surah/96_5.png": "f428",
	"./surah/96_6.png": "8b4d",
	"./surah/96_7.png": "a6e0",
	"./surah/96_8.png": "bbfd",
	"./surah/96_9.png": "ed5a",
	"./surah/97_1.png": "1202",
	"./surah/97_2.png": "86ed",
	"./surah/97_3.png": "93f8",
	"./surah/97_4.png": "5370",
	"./surah/97_5.png": "a319",
	"./surah/98_1.png": "8435",
	"./surah/98_2.png": "46d4",
	"./surah/98_3.png": "49d2",
	"./surah/98_4.png": "bbb7",
	"./surah/98_5.png": "04f4",
	"./surah/98_6.png": "3ef0",
	"./surah/98_7.png": "f664",
	"./surah/98_8.png": "7992",
	"./surah/99_1.png": "640f",
	"./surah/99_2.png": "f14e",
	"./surah/99_3.png": "8d1d",
	"./surah/99_4.png": "883b",
	"./surah/99_5.png": "5d3f",
	"./surah/99_6.png": "7164",
	"./surah/99_7.png": "401a",
	"./surah/99_8.png": "44a2",
	"./surah/9_1.png": "805f",
	"./surah/9_10.png": "0710",
	"./surah/9_100.png": "2354",
	"./surah/9_101.png": "d503",
	"./surah/9_102.png": "ec48",
	"./surah/9_103.png": "3930",
	"./surah/9_104.png": "726c",
	"./surah/9_105.png": "5cc5",
	"./surah/9_106.png": "06f1",
	"./surah/9_107.png": "e2fb",
	"./surah/9_108.png": "6357",
	"./surah/9_109.png": "f1e2",
	"./surah/9_11.png": "3d89",
	"./surah/9_110.png": "0520",
	"./surah/9_111.png": "a98c",
	"./surah/9_112.png": "dc16",
	"./surah/9_113.png": "aced",
	"./surah/9_114.png": "f3ed",
	"./surah/9_115.png": "3219",
	"./surah/9_116.png": "9164",
	"./surah/9_117.png": "a3ef",
	"./surah/9_118.png": "84d9",
	"./surah/9_119.png": "8b51",
	"./surah/9_12.png": "a8c7",
	"./surah/9_120.png": "5b3d",
	"./surah/9_121.png": "a1ef",
	"./surah/9_122.png": "8eca",
	"./surah/9_123.png": "58ed",
	"./surah/9_124.png": "15c54",
	"./surah/9_125.png": "969d",
	"./surah/9_126.png": "bb8f",
	"./surah/9_127.png": "383b",
	"./surah/9_128.png": "4604",
	"./surah/9_129.png": "5644",
	"./surah/9_13.png": "704b",
	"./surah/9_14.png": "ae603",
	"./surah/9_15.png": "d7ea",
	"./surah/9_16.png": "9c7f",
	"./surah/9_17.png": "16b1",
	"./surah/9_18.png": "7c4a",
	"./surah/9_19.png": "12d32",
	"./surah/9_2.png": "c6fd",
	"./surah/9_20.png": "834f",
	"./surah/9_21.png": "f0c0",
	"./surah/9_22.png": "8819",
	"./surah/9_23.png": "f96d",
	"./surah/9_24.png": "b7c07",
	"./surah/9_25.png": "651d",
	"./surah/9_26.png": "1f74",
	"./surah/9_27.png": "9066",
	"./surah/9_28.png": "5eb1",
	"./surah/9_29.png": "f414",
	"./surah/9_3.png": "f65d",
	"./surah/9_30.png": "6843",
	"./surah/9_31.png": "b0d6",
	"./surah/9_32.png": "ecbf",
	"./surah/9_33.png": "e2d1",
	"./surah/9_34.png": "d91a",
	"./surah/9_35.png": "c6be",
	"./surah/9_36.png": "65d9",
	"./surah/9_37.png": "9d500",
	"./surah/9_38.png": "30fe",
	"./surah/9_39.png": "d16f",
	"./surah/9_4.png": "aca8",
	"./surah/9_40.png": "56b3",
	"./surah/9_41.png": "362a",
	"./surah/9_42.png": "c9e4",
	"./surah/9_43.png": "f17a",
	"./surah/9_44.png": "71d5",
	"./surah/9_45.png": "6da3",
	"./surah/9_46.png": "8f16",
	"./surah/9_47.png": "5c31",
	"./surah/9_48.png": "b36f",
	"./surah/9_49.png": "602e",
	"./surah/9_5.png": "a3c7",
	"./surah/9_50.png": "bab4",
	"./surah/9_51.png": "f504",
	"./surah/9_52.png": "2f71",
	"./surah/9_53.png": "a4e2",
	"./surah/9_54.png": "41aa",
	"./surah/9_55.png": "8e2d",
	"./surah/9_56.png": "3d4d",
	"./surah/9_57.png": "977e",
	"./surah/9_58.png": "4357",
	"./surah/9_59.png": "2bef",
	"./surah/9_6.png": "fbfb7",
	"./surah/9_60.png": "36b8",
	"./surah/9_61.png": "9c63",
	"./surah/9_62.png": "6e48",
	"./surah/9_63.png": "cd8b",
	"./surah/9_64.png": "184a",
	"./surah/9_65.png": "58c97",
	"./surah/9_66.png": "60aa",
	"./surah/9_67.png": "ab1f",
	"./surah/9_68.png": "7810",
	"./surah/9_69.png": "4f70f",
	"./surah/9_7.png": "bf94",
	"./surah/9_70.png": "12ac",
	"./surah/9_71.png": "b183",
	"./surah/9_72.png": "66bd",
	"./surah/9_73.png": "5265c",
	"./surah/9_74.png": "e055",
	"./surah/9_75.png": "6e31",
	"./surah/9_76.png": "bfd5",
	"./surah/9_77.png": "f2aef",
	"./surah/9_78.png": "55a82",
	"./surah/9_79.png": "4b3d",
	"./surah/9_8.png": "fe1c",
	"./surah/9_80.png": "c6fd1",
	"./surah/9_81.png": "60c2",
	"./surah/9_82.png": "ab65",
	"./surah/9_83.png": "bfcc",
	"./surah/9_84.png": "7635",
	"./surah/9_85.png": "aa48",
	"./surah/9_86.png": "cee2",
	"./surah/9_87.png": "35b8",
	"./surah/9_88.png": "e99f",
	"./surah/9_89.png": "d5b3",
	"./surah/9_9.png": "acee",
	"./surah/9_90.png": "7089b",
	"./surah/9_91.png": "39ec",
	"./surah/9_92.png": "5a3e",
	"./surah/9_93.png": "e5384",
	"./surah/9_94.png": "70f6",
	"./surah/9_95.png": "8a56",
	"./surah/9_96.png": "f0c3",
	"./surah/9_97.png": "5300",
	"./surah/9_98.png": "ad4f",
	"./surah/9_99.png": "c6d5",
	"./surahList": "f739",
	"./surahList.json": "f739",
	"./title/1.png": "fbb8",
	"./title/10.png": "2bd2",
	"./title/100.png": "b9e6",
	"./title/101.png": "101b",
	"./title/102.png": "0fbb",
	"./title/103.png": "de6c",
	"./title/104.png": "d4be",
	"./title/105.png": "6dd9",
	"./title/106.png": "36e5",
	"./title/107.png": "33d1",
	"./title/108.png": "694b",
	"./title/109.png": "2646",
	"./title/11.png": "9cca",
	"./title/110.png": "e20e",
	"./title/111.png": "e2ac",
	"./title/112.png": "20e0",
	"./title/113.png": "3770",
	"./title/114.png": "19e8",
	"./title/12.png": "89b8",
	"./title/13.png": "2e75",
	"./title/14.png": "a58c",
	"./title/15.png": "4e65",
	"./title/16.png": "2880",
	"./title/17.png": "2e38",
	"./title/18.png": "d914",
	"./title/19.png": "4688",
	"./title/2.png": "3c2f",
	"./title/20.png": "3c4d",
	"./title/21.png": "3481",
	"./title/22.png": "37b1",
	"./title/23.png": "fcab",
	"./title/24.png": "f36b",
	"./title/25.png": "5ec7",
	"./title/26.png": "0b7c",
	"./title/27.png": "1325",
	"./title/28.png": "02ca",
	"./title/29.png": "b406",
	"./title/3.png": "9b65",
	"./title/30.png": "60ac",
	"./title/31.png": "5877",
	"./title/32.png": "f905",
	"./title/33.png": "bc8e",
	"./title/34.png": "12fd",
	"./title/35.png": "0bf9",
	"./title/36.png": "7cee",
	"./title/37.png": "841e",
	"./title/38.png": "6996",
	"./title/39.png": "3fb9",
	"./title/4.png": "2378",
	"./title/40.png": "08b9",
	"./title/41.png": "e66c",
	"./title/42.png": "880f",
	"./title/43.png": "a963",
	"./title/44.png": "15f1",
	"./title/45.png": "15a7",
	"./title/46.png": "fd84",
	"./title/47.png": "61e5",
	"./title/48.png": "be90",
	"./title/49.png": "2c32",
	"./title/5.png": "b1e7",
	"./title/50.png": "92e1",
	"./title/51.png": "c1a8",
	"./title/52.png": "d505",
	"./title/53.png": "a540",
	"./title/54.png": "e973",
	"./title/55.png": "5613",
	"./title/56.png": "781b",
	"./title/57.png": "f5b6",
	"./title/58.png": "5657",
	"./title/59.png": "8e6f",
	"./title/6.png": "b59b",
	"./title/60.png": "39d2",
	"./title/61.png": "021f",
	"./title/62.png": "9aac",
	"./title/63.png": "b09a",
	"./title/64.png": "446a",
	"./title/65.png": "90ce",
	"./title/66.png": "0cb5",
	"./title/67.png": "fb1c",
	"./title/68.png": "e9b9",
	"./title/69.png": "f739b",
	"./title/7.png": "707b",
	"./title/70.png": "1ba7",
	"./title/71.png": "c8a4",
	"./title/72.png": "b532",
	"./title/73.png": "b70b",
	"./title/74.png": "7d6c",
	"./title/75.png": "7588",
	"./title/76.png": "cbfa",
	"./title/77.png": "a010",
	"./title/78.png": "8159",
	"./title/79.png": "175a",
	"./title/8.png": "4818",
	"./title/80.png": "5aba",
	"./title/81.png": "1982",
	"./title/82.png": "3ad0",
	"./title/83.png": "fb01",
	"./title/84.png": "2148",
	"./title/85.png": "8e4c",
	"./title/86.png": "746f7",
	"./title/87.png": "e785",
	"./title/88.png": "8fce",
	"./title/89.png": "289c",
	"./title/9.png": "477b",
	"./title/90.png": "743a",
	"./title/91.png": "921c",
	"./title/92.png": "a9e8",
	"./title/93.png": "5cef",
	"./title/94.png": "b024",
	"./title/95.png": "b143",
	"./title/96.png": "37db",
	"./title/97.png": "1370",
	"./title/98.png": "59e6",
	"./title/99.png": "4346",
	"./translations": "434f",
	"./translations.json": "434f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6242";